import React, { useState, useRef, useEffect } from 'react';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { Tabs, Modal } from 'antd';
import '../../assets/styles/seller_profile.scss';
import CommonService from "../../services/common.service"; // adjust path if needed 
import StorageService from "../../services/StorageService";
import { toast } from "react-toastify";
import { useLocationMaster } from "../../hooks/useLocationMaster";
import { useBusinessTypeMaster } from "../../hooks/useBusinessTypeMaster";
import { useCurrencyMaster } from "../../hooks/useCurrencyMaster";
import { useFactoryDetailsMaster } from "../../hooks/useFactoryDetailsMaster";
import { useProductDetailsMaster } from "../../hooks/useProductDetailsMaster";
// NEW UNIFIED ATTRIBUTE HOOK - Dynamically loads attributes based on selected category
import { useCategoryAttributes } from "../../hooks/useCategoryAttributes";

// In antd v5, TabPane is accessed via Tabs.TabPane for backward compatibility
// Note: In antd v5, TabPane is deprecated but still available as Tabs.TabPane
// Check if TabPane exists, otherwise use a fallback
let TabPane;
if (Tabs.TabPane) {
  TabPane = Tabs.TabPane;
} else if (Tabs && typeof Tabs === 'object') {
  // Fallback: create a simple TabPane component if not available
  TabPane = ({ children, ...props }) => <div {...props}>{children}</div>;
  console.warn('TabPane is not available on Tabs. Using fallback component.');
} else {
  TabPane = ({ children, ...props }) => <div {...props}>{children}</div>;
  console.error('Tabs is not available. This may indicate an antd import issue.');
}



const initialState = {
  // Company
  companyName: '',
  designation: '',
  trader: '',
  gstNumber: '',
  registrationNumber: '',
  website: '',
  noOfEmployees: '',
  yearEstablished: '',
  companyDescription: '',
  // Contact
  altContactName: '',
  altEmail: '',
  altContact: '',
  // Address
  address: '',
  landmark: '',
  country: '',
  state: '',
  city: '',
  pincode: '',
  // Bank
  accountHolder: '',
  accountNumber: '',
  bankName: '',
  branchName: '',
  ifsc: '',
  swift: '',
  currency: '',
  // Trading
  totalRevenue: '',
  exportPercentage: '',
  overseasAddress: '',
  iecNumber: '',
  // Timezone
  timezone: '',
  pd_custom_available: false,
  pd_custom_type: '',
  // Bulk Discount
  isPriceNegotiableAboveTier3: false
};

const CUSTOMIZATION_BACKEND_TYPES = ['LOGO', 'Color', 'Labells', 'Sketch', 'Packing', 'Graphic', 'Sample-base'];

const MASTER_CUSTOMIZATION_LABEL_TO_LEGACY = {
  'minor customization': 'Graphic',
  'drawing-based customization': 'Sketch',
  'drawing based customization': 'Sketch',
  'sample-based customization': 'Sample-base',
  'sample based customization': 'Sample-base',
  'full customization': 'LOGO',
};

const LEGACY_CUSTOMIZATION_LABEL_TO_ENUM = {
  LOGO: 'LOGO',
  Logo: 'LOGO',
  logo: 'LOGO',
  Color: 'Color',
  Colour: 'Color',
  color: 'Color',
  colour: 'Color',
  Labels: 'Labells',
  Labells: 'Labells',
  labels: 'Labells',
  labells: 'Labells',
  Sketch: 'Sketch',
  sketch: 'Sketch',
  Packing: 'Packing',
  Packaging: 'Packing',
  packing: 'Packing',
  packaging: 'Packing',
  Graphic: 'Graphic',
  graphic: 'Graphic',
  'Sample-based': 'Sample-base',
  'Sample-base': 'Sample-base',
  'sample-based': 'Sample-base',
  'sample-base': 'Sample-base',
};

const CUSTOMIZATION_ROW_TO_DETAIL_KEY = {
  logo: 'logo',
  color: 'color',
  labels: 'labells',
  packing: 'packing',
  graphic: 'graphic',
  sketch: 'sketch',
  sample_based: 'sample_base',
};

const CUSTOMIZATION_DETAIL_KEY_TO_ROW = {
  logo: 'logo',
  color: 'color',
  labells: 'labels',
  labels: 'labels',
  packing: 'packing',
  graphic: 'graphic',
  sketch: 'sketch',
  sample_base: 'sample_based',
};

const DEFAULT_CUSTOMIZATION_ROWS = [
  { id: 'logo', name: 'LOGO', enabled: false, moq: '', priceNoTax: '', tax: '', priceWithTax: '', desc: '' },
  { id: 'color', name: 'Color', enabled: false, moq: '', priceNoTax: '', tax: '', priceWithTax: '', desc: '' },
  { id: 'labels', name: 'Labels', enabled: false, moq: '', priceNoTax: '', tax: '', priceWithTax: '', desc: '' },
  { id: 'packing', name: 'Packing', enabled: false, moq: '', priceNoTax: '', tax: '', priceWithTax: '', desc: '' },
  { id: 'graphic', name: 'Graphic', enabled: false, moq: '', priceNoTax: '', tax: '', priceWithTax: '', desc: '' },
  { id: 'sketch', name: 'Sketch', enabled: false, moq: '', priceNoTax: '', tax: '', priceWithTax: '', desc: '' },
  { id: 'sample_based', name: 'Sample-based', enabled: false, moq: '', priceNoTax: '', tax: '', priceWithTax: '', desc: '' },
];

const LEGACY_CUSTOMIZATION_ENUM_TO_MASTER_HINT = {
  LOGO: 'full customization',
  Graphic: 'minor customization',
  Sketch: 'drawing-based',
  'Sample-base': 'sample-based',
  Color: 'color',
  Labells: 'label',
  Labels: 'label',
  Packing: 'packing',
};

function normalizeCustomizationAvailable(value) {
  return value === true || value === 1 || value === '1';
}

function normalizeCustomizationTypes(raw) {
  if (Array.isArray(raw)) return raw;
  if (raw == null || raw === '') return [];
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [raw];
    } catch {
      return [raw];
    }
  }
  return [raw];
}

function normalizeCustomizationDetails(raw) {
  if (!raw) return {};
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
      return {};
    }
  }
  return typeof raw === 'object' ? raw : {};
}

function mapCustomizationTypeForEditValue(customizationTypeValue, customizationTypesOptions = []) {
  if (customizationTypeValue === undefined || customizationTypeValue === null || customizationTypeValue === '') {
    return '';
  }

  if (!customizationTypesOptions?.length) {
    return customizationTypeValue;
  }

  const trimmedType = typeof customizationTypeValue === 'string'
    ? customizationTypeValue.trim()
    : String(customizationTypeValue).trim();

  const findByValue = (value) => customizationTypesOptions.find((opt) =>
    opt.value === value
    || String(opt.value) === String(value)
    || Number(opt.value) === Number(value),
  );

  let foundOption = findByValue(customizationTypeValue);

  if (!foundOption) {
    foundOption = customizationTypesOptions.find((opt) => {
      const optLabel = String(opt.label || '').trim();
      return optLabel.toLowerCase() === trimmedType.toLowerCase();
    });
  }

  if (!foundOption) {
    const hint = LEGACY_CUSTOMIZATION_ENUM_TO_MASTER_HINT[trimmedType]
      ?? LEGACY_CUSTOMIZATION_ENUM_TO_MASTER_HINT[trimmedType.toUpperCase()];
    if (hint) {
      foundOption = customizationTypesOptions.find((opt) =>
        String(opt.label || '').toLowerCase().includes(hint.toLowerCase()),
      );
    }
  }

  if (!foundOption) {
    const normalizedType = trimmedType.toLowerCase().replace(/[-\s_]/g, '');
    foundOption = customizationTypesOptions.find((opt) => {
      const normalizedOptLabel = String(opt.label || '').toLowerCase().replace(/[-\s_]/g, '');
      return normalizedOptLabel === normalizedType
        || String(opt.label || '').toLowerCase().includes(trimmedType.toLowerCase());
    });
  }

  return foundOption?.value !== undefined ? foundOption.value : customizationTypeValue;
}

function mapMasterCustomizationLabelToLegacy(label) {
  if (!label) return null;
  const normalized = String(label).trim().toLowerCase();
  if (MASTER_CUSTOMIZATION_LABEL_TO_LEGACY[normalized]) {
    return MASTER_CUSTOMIZATION_LABEL_TO_LEGACY[normalized];
  }
  return LEGACY_CUSTOMIZATION_LABEL_TO_ENUM[String(label).trim()]
    ?? LEGACY_CUSTOMIZATION_LABEL_TO_ENUM[normalized]
    ?? null;
}

function resolveCustomizationBackendEnum(customTypeValue, customizationTypesOptions = []) {
  if (customTypeValue === undefined || customTypeValue === null || customTypeValue === '') {
    return null;
  }

  const asLegacyEnum = (value) => {
    const text = String(value).trim();
    if (CUSTOMIZATION_BACKEND_TYPES.includes(text)) return text;
    return mapMasterCustomizationLabelToLegacy(text);
  };

  const direct = asLegacyEnum(customTypeValue);
  if (direct && CUSTOMIZATION_BACKEND_TYPES.includes(direct)) return direct;

  const optionId = typeof customTypeValue === 'number'
    ? customTypeValue
    : (!Number.isNaN(Number(customTypeValue)) && String(customTypeValue).trim() !== '' ? Number(customTypeValue) : null);

  if (optionId != null) {
    const foundOption = customizationTypesOptions.find((opt) =>
      opt.value === optionId
      || Number(opt.value) === optionId
      || String(opt.value) === String(optionId),
    );
    if (foundOption?.label) {
      const mapped = mapMasterCustomizationLabelToLegacy(foundOption.label);
      if (mapped && CUSTOMIZATION_BACKEND_TYPES.includes(mapped)) return mapped;
    }
  }

  if (typeof customTypeValue === 'string') {
    const mapped = mapMasterCustomizationLabelToLegacy(customTypeValue);
    if (mapped && CUSTOMIZATION_BACKEND_TYPES.includes(mapped)) return mapped;
  }

  return null;
}

function buildCustomizationDetailsPayload(customizationRows = []) {
  const details = {};

  for (const row of customizationRows) {
    const key = CUSTOMIZATION_ROW_TO_DETAIL_KEY[row.id];
    if (!key || !row.enabled) continue;

    const moq = row.moq !== '' && row.moq != null ? parseInt(String(row.moq), 10) : undefined;
    const priceWithoutTax = row.priceNoTax !== '' && row.priceNoTax != null
      ? parseFloat(String(row.priceNoTax))
      : undefined;
    const priceWithTax = row.priceWithTax !== '' && row.priceWithTax != null
      ? parseFloat(String(row.priceWithTax))
      : undefined;

    details[key] = {
      enabled: true,
      ...(Number.isFinite(moq) && moq > 0 ? { moq } : {}),
      ...(Number.isFinite(priceWithoutTax) ? { price_without_tax: priceWithoutTax } : {}),
      ...(Number.isFinite(priceWithTax) ? { price_with_tax: priceWithTax } : {}),
      ...(row.desc && String(row.desc).trim() ? { description_or_image: String(row.desc).trim() } : {}),
    };
  }

  return Object.keys(details).length ? details : undefined;
}

function hydrateCustomizationRowsFromDetails(details, baseRows = DEFAULT_CUSTOMIZATION_ROWS) {
  const normalizedDetails = normalizeCustomizationDetails(details);
  if (!normalizedDetails || typeof normalizedDetails !== 'object') {
    return baseRows.map((row) => ({ ...row }));
  }

  return baseRows.map((row) => {
    const detailKey = Object.entries(CUSTOMIZATION_DETAIL_KEY_TO_ROW).find(([, rowId]) => rowId === row.id)?.[0];
    const detail = detailKey ? normalizedDetails[detailKey] : null;
    if (!detail || typeof detail !== 'object') return { ...row };

    const priceNoTax = detail.price_without_tax != null ? String(detail.price_without_tax) : '';
    const priceWithTax = detail.price_with_tax != null ? String(detail.price_with_tax) : '';
    let tax = '';
    if (priceNoTax && priceWithTax) {
      const base = parseFloat(priceNoTax);
      const withTax = parseFloat(priceWithTax);
      if (Number.isFinite(base) && base > 0 && Number.isFinite(withTax)) {
        tax = String((((withTax / base) - 1) * 100).toFixed(2));
      }
    }

    return {
      ...row,
      enabled: detail.enabled === true,
      moq: detail.moq != null ? String(detail.moq) : '',
      priceNoTax,
      tax,
      priceWithTax,
      desc: detail.description_or_image != null ? String(detail.description_or_image) : '',
    };
  });
}

export default function SellerProfile() {
  const navigate = useNavigate();
  const [companyId, setCompanyId] = useState(null);
  var companyIdRef = useRef(null);

  // helper to update both state and ref
  function updateCompanyId(id) {
    setCompanyId(id);       // React state
    companyIdRef.current = id; // Always latest value
  }

  const [factoryId, setFactoryIdState] = useState(null);
  const [qualityId, setQualityIdState] = useState(null);
  const [productId, setProductIdState] = useState(null);

  // refs for synchronous access inside closures / event handlers
  var factoryIdRef = useRef(null);
  var qualityIdRef = useRef(null);
  var productIdRef = useRef(null);

  // Media file URLs (stored after upload)
  const [mediaFiles, setMediaFiles] = useState({
    company_logo: '',
    profile_banner: '',
    brochure: '',
    company_video: ''
  });

  const [uploading, setUploading] = useState(false);
  
  // Loading states for factory location dropdowns (per-factory loading)
  const [loadingFactoryStates, setLoadingFactoryStates] = useState(false);
  const [loadingFactoryCities, setLoadingFactoryCities] = useState(false);
  const [isLoadingProfile, setIsLoadingProfile] = useState(true);
  const [profileData, setProfileData] = useState(null);
  const hasProcessedProfile = useRef(false);
  const [isCompanyProfileSaved, setIsCompanyProfileSaved] = useState(false);
  const [isFactoryDetailsSaved, setIsFactoryDetailsSaved] = useState(false);
  const [isQualityDetailsSaved, setIsQualityDetailsSaved] = useState(false);
  const [isProductDetailsSaved, setIsProductDetailsSaved] = useState(false);
  const [showContractManufacturerModal, setShowContractManufacturerModal] = useState(false);

  // Store the profile's state and city names for later lookup
  const [pendingStateName, setPendingStateName] = useState(null);
  const [pendingCityName, setPendingCityName] = useState(null);
  const [pendingCountryId, setPendingCountryId] = useState(null);

  // Master Data Hooks - MUST be called before any code that uses them
  const {
    countries: rawCountries,
    states: rawStates,
    cities: rawCities,
    updateListsForCountry,
    updateListsForState,
  } = useLocationMaster();

  // Business Type Master - hook now fetches from API
  const { businessTypeOptions, timezoneOptions } = useBusinessTypeMaster();

  // Currency Master
  const { currencyOptions } = useCurrencyMaster();

  // Map imported master data (id/label) into react-select option shape { value, label }
  const countries = rawCountries.map((c) => ({ value: c.id, label: c.label }));
  const states = rawStates.map((s) => ({ value: s.id, label: s.label }));
  const cities = rawCities.map((c) => ({ value: c.id, label: c.label }));

  // Load existing profile on component mount to prevent duplicates
  useEffect(() => {
    loadExistingProfile();
  }, []);

  // Helper function to find ID from name/label or return ID if already an ID
  const findIdByName = (options, nameOrId) => {
    if (!nameOrId || !options || options.length === 0) return '';
    
    // First, check if nameOrId is already an ID that exists in options
    const foundById = options.find(opt => 
      String(opt.id) === String(nameOrId) || 
      String(opt.value) === String(nameOrId)
    );
    if (foundById) {
      return String(foundById.id || foundById.value || '');
    }
    
    // If not found by ID, try to find by label/name
    const foundByName = options.find(opt => 
      opt.label?.toLowerCase() === String(nameOrId).toLowerCase() ||
      opt.name?.toLowerCase() === String(nameOrId).toLowerCase()
    );
    return foundByName ? String(foundByName.id || foundByName.value || '') : String(nameOrId);
  };

  // Load existing company profile
  const loadExistingProfile = async () => {
    try {
      setIsLoadingProfile(true);
      const response = await CommonService.get('/company/my-profile');
      
      if (response && response.success && response.data) {
        const profile = response.data;
        const existingCompanyId = profile.company_id || profile.id;
        
        // Check if profile role is BUYER only (not SELLER or BOTH)
        if (profile.company_role === 'BUYER') {
          toast.error('This page is for sellers only. Redirecting to buyer profile...');
          navigate('/buyer-profile');
          return;
        }
        
        if (existingCompanyId) {
          // Profile exists, set companyId for update operations
          updateCompanyId(existingCompanyId);
          
          // Reset the processed flag when loading a new profile
          hasProcessedProfile.current = false;
          
          // Mark as saved since profile already exists
          setIsCompanyProfileSaved(true);
          
          // Store profile data for later processing when master data is available
          setProfileData(profile);
          
          // Load basic form data (non-location fields)
          setForm(prev => ({
            ...prev,
            companyName: profile.company_name || '',
            designation: profile.designation || '',
            trader: profile.company_type_id ? String(profile.company_type_id) : '',
            gstNumber: profile.tax_number || '',
            registrationNumber: profile.registration_number || '',
            website: profile.website || '',
            noOfEmployees: profile.number_of_employees ? String(profile.number_of_employees) : '',
            yearEstablished: profile.establishment_year ? String(profile.establishment_year) : '',
            companyDescription: profile.company_description || '',
            altContactName: profile.contact_details?.alternate_contact_name || '',
            altEmail: profile.contact_details?.alternate_email || '',
            altContact: profile.contact_details?.alternate_contact_number || '',
            address: profile.address?.address || '',
            landmark: profile.address?.landmark || '',
            pincode: profile.address?.pincode || '',
            accountHolder: profile.bank_details?.account_holder_name || '',
            accountNumber: profile.bank_details?.account_number || '',
            bankName: profile.bank_details?.bank_name || '',
            branchName: profile.bank_details?.branch_name || '',
            ifsc: profile.bank_details?.ifsc_code || '',
            swift: profile.bank_details?.swift_code || '',
            totalRevenue: profile.annual_turnover || '',
            exportPercentage: profile.export_percentage ? String(profile.export_percentage) : '',
            overseasAddress: profile.overseas_address?.address || '',
            iecNumber: profile.iec_number || '',
          }));

          // Load media files
          if (profile.media) {
            setMediaFiles(prev => ({
              ...prev,
              company_logo: profile.media.company_logo || '',
              profile_banner: profile.media.profile_banner || '',
              brochure: profile.media.brochure || '',
              company_video: profile.media.company_video || '',
            }));
          }

          // Load products
          if (profile.main_products && Array.isArray(profile.main_products)) {
            setProducts(profile.main_products);
          }

          // Certificates are now loaded via loadQualityDetails() function
          // which is called after factory details are loaded

          // Store seller_profile data for later use in payload
          // This will be used when building the payload to preserve existing seller_profile data
          if (profile.seller_profile) {
            // Store seller_profile in a ref or state for use in buildJsonPayloadForCompanyDetails
            // For now, we'll use it directly from profileData when building payload
          }

          // Load factory details, quality details, and products if companyId exists (will be called after master data loads)
          if (existingCompanyId) {
            // Delay loading factory details, quality details, and products to ensure master data is available
            setTimeout(() => {
              loadFactoryDetails(existingCompanyId);
              loadQualityDetails(existingCompanyId);
              loadProductDetails(existingCompanyId);
            }, 500);
          }
        }
      }
    } catch (err) {
      // Profile doesn't exist yet, which is fine for new users
      console.log('No existing profile found or error loading profile:', err);
      // Don't show error toast as this is expected for new users
    } finally {
      setIsLoadingProfile(false);
    }
  };

  // Store factory data temporarily until master data is loaded
  const [pendingFactoryData, setPendingFactoryData] = useState(null);

  // Load existing factory details from factory_profile table
  const loadFactoryDetails = async (companyId) => {
    try {
      // Load from factory_profile endpoint
      const response = await CommonService.get(`/profile/company/${companyId}/factories`);
      if (response && response.success && response.data) {
        const factories = Array.isArray(response.data) ? response.data : [response.data];
        
        if (factories.length > 0) {
          // Set factory ID from first factory
          const firstFactory = factories[0];
          if (firstFactory.factory_id) {
            setFactoryIdState(firstFactory.factory_id);
            factoryIdRef.current = firstFactory.factory_id;
          }

          // Get factory_details and warehouse_locations from factory_profile
          const factoryDetails = firstFactory.factory_details || [];
          const warehouseLocations = firstFactory.warehouse_locations || [];
          
          if (factoryDetails.length > 0 || warehouseLocations.length > 0) {
          // Map factories to factoryDetailsList format
          // Backend returns labels (names) - Factory Details stores labels directly (not IDs)
          const mappedFactories = factoryDetails.map(factory => {
            // Store labels directly (Factory Details uses labels, not IDs)
            const countryLabel = factory.country ? String(factory.country) : '';
            const stateLabel = factory.state ? String(factory.state) : '';
            const cityLabel = factory.city ? String(factory.city) : '';

            return {
              factoryName: factory.factory_name || '',
              factorySize: factory.area_size || '',
              factoryUnit: factory.area_unit || '',
              noOfEmployees: factory.workers_count ? String(factory.workers_count) : '',
              noOfQualityStaff: factory.total_qc_staff ? String(factory.total_qc_staff) : '',
              noOfRDStaff: factory.total_rd_staff ? String(factory.total_rd_staff) : '',
              totalProductionLines: factory.total_production_lines ? String(factory.total_production_lines) : '',
              annualOutput: factory.annual_output || '',
              averageLeadTime: factory.average_lead_time_production ? String(factory.average_lead_time_production) : '',
              factoryAddress: factory.address || factory.factory_address || '',
              factoryCountry: countryLabel, // Store label directly
              factoryState: stateLabel, // Store label directly
              factoryCity: cityLabel, // Store label directly
              factoryPincode: factory.pincode || '',
              // Per-factory location options to prevent cross-contamination
              factoryStates: [],
              factoryCities: []
            };
          });

          const factoriesWithEmptyOptions = mappedFactories.length > 0 ? mappedFactories.map(f => ({
            ...f,
            factoryStates: [],
            factoryCities: []
          })) : [{
            factoryName: '',
            factorySize: '',
            factoryUnit: '',
            noOfEmployees: '',
            noOfQualityStaff: '',
            noOfRDStaff: '',
            totalProductionLines: '',
            annualOutput: '',
            averageLeadTime: '',
            factoryAddress: '',
            factoryCountry: '',
            factoryState: '',
            factoryCity: '',
            factoryPincode: '',
            factoryStates: [],
            factoryCities: []
          }];

          // Set factory details list - useEffect will load states/cities when countries are available
          setFactoryDetailsList(factoriesWithEmptyOptions);

          // Load warehouse locations if available (from company profile)
          if (warehouseLocations.length > 0) {
            const mappedWarehouses = warehouseLocations.map(warehouse => {
              // Backend returns labels (names) - Warehouse Details stores labels directly (not IDs)
              // Store labels directly (Warehouse Details uses labels, not IDs)
              const warehouseCountryLabel = warehouse.warehouse_country ? String(warehouse.warehouse_country) : '';
              const warehouseStateLabel = warehouse.warehouse_state ? String(warehouse.warehouse_state) : '';
              const warehouseCityLabel = warehouse.warehouse_city ? String(warehouse.warehouse_city) : '';

              return {
                warehouseName: warehouse.warehouse_name || '',
                stockQuantity: warehouse.warehouse_stock_quantity ? String(warehouse.warehouse_stock_quantity) : '',
                warehouseAddress: warehouse.warehouse_address || '',
                warehouseCountry: warehouseCountryLabel, // Store label directly
                warehouseState: warehouseStateLabel, // Store label directly
                warehouseCity: warehouseCityLabel, // Store label directly
                warehousePincode: warehouse.warehouse_pincode || '',
                // Per-warehouse location options to prevent cross-contamination (same as factories)
                warehouseStates: [],
                warehouseCities: []
              };
            });

            if (mappedWarehouses.length > 0) {
              // Set warehouse locations list - useEffect will load states/cities when countries are available
              setWarehouseLocationsList(mappedWarehouses);
            }
          }

          // Load logistics, shipping, payment, and other factory-related data from factory_profile
          if (firstFactory.nearest_port || firstFactory.nearest_airport || firstFactory.highway_name) {
            setForm(prev => ({
              ...prev,
              nearestPort: firstFactory.nearest_port || '',
              factoryToPortDistance: firstFactory.distance_port ? String(firstFactory.distance_port) : '',
              nearestAirport: firstFactory.nearest_airport || '',
              factoryToAirportDistance: firstFactory.distance_airport ? String(firstFactory.distance_airport) : '',
              nearestHighway: firstFactory.highway_name || '',
              factoryToHighwayDistance: firstFactory.highway_distance ? String(firstFactory.highway_distance) : ''
            }));
          }

          if (firstFactory.shipping_information || firstFactory.shipping_terms || firstFactory.mode_of_transport) {
            setForm(prev => ({
              ...prev,
              shippingInformation: firstFactory.shipping_information || '',
              shippingTerms: firstFactory.shipping_terms || '',
              modeOfTransport: Array.isArray(firstFactory.mode_of_transport) ? firstFactory.mode_of_transport : (firstFactory.mode_of_transport ? [firstFactory.mode_of_transport] : []),
              dispatchLocation: firstFactory.dispatch_location || ''
            }));
          }

          // Load payment methods, payment schedule, late payment policy, and currency
          // Payment methods can be an array, but the UI uses a single select, so take the first one
          if (firstFactory.payment_methods) {
            let paymentMethodValue = '';
            if (Array.isArray(firstFactory.payment_methods) && firstFactory.payment_methods.length > 0) {
              // Take the first payment method for single select dropdown
              paymentMethodValue = String(firstFactory.payment_methods[0]);
            } else if (firstFactory.payment_methods) {
              paymentMethodValue = String(firstFactory.payment_methods);
            }
            
            setForm(prev => ({
              ...prev,
              paymentMethod: paymentMethodValue,
              paymentMethods: Array.isArray(firstFactory.payment_methods) ? firstFactory.payment_methods.map(pm => String(pm)) : [String(firstFactory.payment_methods)]
            }));
          }
          
          // Map payment schedule - ensure it's a string
          if (firstFactory.payment_schedule) {
            const mappedPaymentSchedule = String(firstFactory.payment_schedule);
            setForm(prev => ({
              ...prev,
              paymentSchedule: mappedPaymentSchedule
            }));
          }
          
          // Map late payment policy - ensure it's a string
          if (firstFactory.late_payment_policy) {
            const mappedLatePaymentPolicy = String(firstFactory.late_payment_policy);
            setForm(prev => ({
              ...prev,
              latePaymentPolicy: mappedLatePaymentPolicy
            }));
          }
          
          // Map currency - ensure it's a string
          if (firstFactory.currency) {
            const mappedCurrency = String(firstFactory.currency);
            setForm(prev => ({
              ...prev,
              paymentCurrency: mappedCurrency,
              currency: mappedCurrency
            }));
          }

          // Load refund policy - handle both boolean and string values
          if (firstFactory.refund_policy !== undefined && firstFactory.refund_policy !== null) {
            // Convert to boolean if needed
            const refundPolicyValue = typeof firstFactory.refund_policy === 'boolean' 
              ? firstFactory.refund_policy 
              : (firstFactory.refund_policy === 'true' || firstFactory.refund_policy === 1 || firstFactory.refund_policy === '1');
            
            setForm(prev => ({
              ...prev,
              refundPolicy: refundPolicyValue,
              refundPolicyDescription: firstFactory.refund_policy_description || ''
            }));
          } else if (firstFactory.refund_policy_description) {
            // If only description exists, set refund policy to false
            setForm(prev => ({
              ...prev,
              refundPolicy: false,
              refundPolicyDescription: firstFactory.refund_policy_description || ''
            }));
          }

          // Mark as saved since factory details exist
          setIsFactoryDetailsSaved(true);
          }
        } else {
          // Handle legacy single-factory format (if factory_details array is empty but factory data exists)
          // firstFactory is already defined in the parent scope (line 273)
          const factory = factories[0];
          if (factory.factory_name || factory.factory_address) {
            // Map single factory to array format
            // Backend returns labels (names) - Factory Details stores labels directly (not IDs)
            const countryLabel = factory.country ? String(factory.country) : '';
            const stateLabel = factory.state ? String(factory.state) : '';
            const cityLabel = factory.city ? String(factory.city) : '';

            setFactoryDetailsList([{
              factoryName: factory.factory_name || '',
              factorySize: factory.area_size || '',
              factoryUnit: factory.area_unit || '',
              noOfEmployees: factory.workers_count ? String(factory.workers_count) : '',
              noOfQualityStaff: factory.total_qc_staff ? String(factory.total_qc_staff) : '',
              noOfRDStaff: factory.total_rd_staff ? String(factory.total_rd_staff) : '',
              totalProductionLines: factory.total_production_lines ? String(factory.total_production_lines) : '',
              annualOutput: factory.annual_output || '',
              averageLeadTime: factory.average_lead_time_production ? String(factory.average_lead_time_production) : '',
              factoryAddress: factory.address || factory.factory_address || '',
              factoryCountry: countryLabel, // Store label directly
              factoryState: stateLabel, // Store label directly
              factoryCity: cityLabel, // Store label directly
              factoryPincode: factory.pincode || '',
              factoryStates: [],
              factoryCities: []
            }]);

            // Load warehouse if available in legacy format
            if (factory.warehouse_name || factory.warehouse_address) {
              // Backend returns labels (names) - Warehouse Details stores labels directly (not IDs)
              const warehouseCountryLabel = factory.warehouse_country ? String(factory.warehouse_country) : '';
              const warehouseStateLabel = factory.warehouse_state ? String(factory.warehouse_state) : '';
              const warehouseCityLabel = factory.warehouse_city ? String(factory.warehouse_city) : '';

              setWarehouseLocationsList([{
                warehouseName: factory.warehouse_name || '',
                stockQuantity: factory.warehouse_stock_quantity ? String(factory.warehouse_stock_quantity) : '',
                warehouseAddress: factory.warehouse_address || '',
                warehouseCountry: warehouseCountryLabel, // Store label directly
                warehouseState: warehouseStateLabel, // Store label directly
                warehouseCity: warehouseCityLabel, // Store label directly
                warehousePincode: factory.warehouse_pincode || '',
                warehouseStates: [],
                warehouseCities: []
              }]);
            }

            // Load other factory data
            if (factory.nearest_port || factory.nearest_airport || factory.highway_name) {
              setForm(prev => ({
                ...prev,
                nearestPort: factory.nearest_port || '',
                factoryToPortDistance: factory.distance_port ? String(factory.distance_port) : '',
                nearestAirport: factory.nearest_airport || '',
                factoryToAirportDistance: factory.distance_airport ? String(factory.distance_airport) : '',
                nearestHighway: factory.highway_name || '',
                factoryToHighwayDistance: factory.highway_distance ? String(factory.highway_distance) : ''
              }));
            }

            if (factory.shipping_information || factory.shipping_terms || factory.mode_of_transport) {
              setForm(prev => ({
                ...prev,
                shippingInformation: factory.shipping_information || '',
                shippingTerms: factory.shipping_terms || '',
                modeOfTransport: Array.isArray(factory.mode_of_transport) ? factory.mode_of_transport : (factory.mode_of_transport ? [factory.mode_of_transport] : []),
                dispatchLocation: factory.dispatch_location || ''
              }));
            }

            // Load payment methods, payment schedule, late payment policy, and currency
            // Payment methods can be an array, but the UI uses a single select, so take the first one
            if (factory.payment_methods) {
              let paymentMethodValue = '';
              if (Array.isArray(factory.payment_methods) && factory.payment_methods.length > 0) {
                // Take the first payment method for single select dropdown
                paymentMethodValue = String(factory.payment_methods[0]);
              } else if (factory.payment_methods) {
                paymentMethodValue = String(factory.payment_methods);
              }
              
              setForm(prev => ({
                ...prev,
                paymentMethod: paymentMethodValue,
                paymentMethods: Array.isArray(factory.payment_methods) ? factory.payment_methods.map(pm => String(pm)) : [String(factory.payment_methods)]
              }));
            }
            
            // Map payment schedule - ensure it's a string
            if (factory.payment_schedule) {
              const mappedPaymentSchedule = String(factory.payment_schedule);
              setForm(prev => ({
                ...prev,
                paymentSchedule: mappedPaymentSchedule
              }));
            }
            
            // Map late payment policy - ensure it's a string
            if (factory.late_payment_policy) {
              const mappedLatePaymentPolicy = String(factory.late_payment_policy);
              setForm(prev => ({
                ...prev,
                latePaymentPolicy: mappedLatePaymentPolicy
              }));
            }
            
            // Map currency - ensure it's a string
            if (factory.currency) {
              const mappedCurrency = String(factory.currency);
              setForm(prev => ({
                ...prev,
                paymentCurrency: mappedCurrency,
                currency: mappedCurrency
              }));
            }

            // Load refund policy - handle both boolean and string values
            if (factory.refund_policy !== undefined && factory.refund_policy !== null) {
              // Convert to boolean if needed
              const refundPolicyValue = typeof factory.refund_policy === 'boolean' 
                ? factory.refund_policy 
                : (factory.refund_policy === 'true' || factory.refund_policy === 1 || factory.refund_policy === '1');
              
              setForm(prev => ({
                ...prev,
                refundPolicy: refundPolicyValue,
                refundPolicyDescription: factory.refund_policy_description || ''
              }));
            } else if (factory.refund_policy_description) {
              // If only description exists, set refund policy to false
              setForm(prev => ({
                ...prev,
                refundPolicy: false,
                refundPolicyDescription: factory.refund_policy_description || ''
              }));
            }

            setIsFactoryDetailsSaved(true);
          }
        }
      }
    } catch (err) {
      console.log('No existing factory details found or error loading factory:', err);
      // Don't show error toast as this is expected for new users
    }
  };

  // Memoize master data lengths to prevent unnecessary re-renders
  const countriesLoaded = rawCountries.length > 0;
  const timezonesLoaded = timezoneOptions.length > 0;
  const currenciesLoaded = currencyOptions.length > 0;
  const businessTypesLoaded = businessTypeOptions.length > 0;

  // Reload form values when master data becomes available (only once)
  useEffect(() => {
    if (profileData && countriesLoaded && timezonesLoaded && currenciesLoaded && businessTypesLoaded && !hasProcessedProfile.current) {
      const profile = profileData;

      // Find country ID first
      const countryId = findIdByName(rawCountries, profile.address?.country) || '';
      
      // Find timezone, currency, and business type (these don't depend on other data)
      const timezoneId = timezoneOptions.find(tz => 
        tz.label?.toLowerCase() === profile.address?.timezone?.toLowerCase() ||
        String(tz.value) === String(profile.address?.timezone)
      )?.value || '';
      const currencyId = currencyOptions.find(c => 
        c.currencyCode === profile.currency ||
        c.label === profile.currency ||
        String(c.value) === String(profile.currency)
      )?.value || profile.currency || 'USD';
      // Find business type ID - try to match by ID first, then by value
      const businessTypeId = profile.company_type_id 
        ? (businessTypeOptions.find(bt => 
            String(bt.value) === String(profile.company_type_id) || 
            Number(bt.value) === Number(profile.company_type_id)
          )?.value || String(profile.company_type_id))
        : '';

      // Update form with country, timezone, currency, and business type first
      setForm(prev => ({
        ...prev,
        country: countryId,
        timezone: timezoneId,
        currency: currencyId,
        trader: businessTypeId || prev.trader,
      }));

      // Store state and city names for later lookup after states/cities are loaded
      if (countryId && profile.address?.state) {
        setPendingStateName(profile.address.state);
        setPendingCountryId(countryId);
      }
      if (profile.address?.city) {
        setPendingCityName(profile.address.city);
      }

      // Load states for the country
      if (countryId) {
        updateListsForCountry(countryId);
      }

      // Mark as processed to prevent re-running
      hasProcessedProfile.current = true;
    }
  }, [profileData, countriesLoaded, timezonesLoaded, currenciesLoaded, businessTypesLoaded]);

  // When states are loaded, find and set the state ID
  useEffect(() => {
    if (pendingStateName && rawStates.length > 0 && pendingCountryId) {
      const stateId = findIdByName(rawStates, pendingStateName);
      if (stateId) {
        setForm(prev => ({
          ...prev,
          state: stateId,
        }));
        
        // Load cities for this state
        updateListsForState(pendingCountryId, stateId);
        setPendingStateName(null); // Clear pending state name
      }
    }
  }, [rawStates, pendingStateName, pendingCountryId]);

  // When cities are loaded, find and set the city ID
  useEffect(() => {
    if (pendingCityName && rawCities.length > 0) {
      const cityId = findIdByName(rawCities, pendingCityName);
      if (cityId) {
        setForm(prev => ({
          ...prev,
          city: cityId,
        }));
        setPendingCityName(null); // Clear pending city name
      }
    }
  }, [rawCities, pendingCityName]);

  // Factory Details stores labels directly (no conversion to IDs needed)
  // Removed useEffect hooks that converted labels to IDs since we're storing labels now

  // Re-process warehouse locations when master data becomes available
  // Same pattern as Company Profile Address section
  useEffect(() => {
    if (warehouseLocationsList.length > 0 && countriesLoaded && rawCountries.length > 0) {
      setWarehouseLocationsList(prev => prev.map(warehouse => {
        let updatedWarehouse = { ...warehouse };
        
        // For country: convert label to ID (same as Company Profile Address)
        if (warehouse.warehouseCountry) {
          const countryId = findIdByName(rawCountries, warehouse.warehouseCountry);
          if (countryId && countryId !== warehouse.warehouseCountry) {
            updatedWarehouse.warehouseCountry = countryId;
          }
        }
        
        return updatedWarehouse;
      }));
    }
  }, [countriesLoaded, rawCountries]);

  // When states are loaded, convert warehouse state labels to IDs (same as Company Profile Address)
  useEffect(() => {
    if (warehouseLocationsList.length > 0 && rawStates.length > 0) {
      setWarehouseLocationsList(prev => prev.map(warehouse => {
        let updatedWarehouse = { ...warehouse };
        
        // Use _pendingStateLabel if available (label from backend), otherwise try warehouseState
        const stateLabel = warehouse._pendingStateLabel || warehouse.warehouseState;
        if (stateLabel && typeof stateLabel === 'string') {
          // Check if it's already an ID by trying to find it in rawStates
          const isAlreadyId = rawStates.find(s => 
            String(s.id) === String(stateLabel) || 
            String(s.value) === String(stateLabel)
          );
          
          if (!isAlreadyId) {
            // It's a label, convert to ID (same as Company Profile Address)
            const stateId = findIdByName(rawStates, stateLabel);
            if (stateId) {
              updatedWarehouse.warehouseState = stateId;
              // Clear the pending label after conversion
              delete updatedWarehouse._pendingStateLabel;
            }
          } else {
            // It's already an ID, ensure it's in string format
            updatedWarehouse.warehouseState = String(isAlreadyId.id || isAlreadyId.value);
            delete updatedWarehouse._pendingStateLabel;
          }
        }
        
        return updatedWarehouse;
      }));
    }
  }, [rawStates]);

  // When cities are loaded, convert warehouse city labels to IDs (same as Company Profile Address)
  useEffect(() => {
    if (warehouseLocationsList.length > 0 && rawCities.length > 0) {
      setWarehouseLocationsList(prev => prev.map(warehouse => {
        let updatedWarehouse = { ...warehouse };
        
        // Use _pendingCityLabel if available (label from backend), otherwise try warehouseCity
        const cityLabel = warehouse._pendingCityLabel || warehouse.warehouseCity;
        if (cityLabel && typeof cityLabel === 'string') {
          // Check if it's already an ID by trying to find it in rawCities
          const isAlreadyId = rawCities.find(c => 
            String(c.id) === String(cityLabel) || 
            String(c.value) === String(cityLabel)
          );
          
          if (!isAlreadyId) {
            // It's a label, convert to ID (same as Company Profile Address)
            const cityId = findIdByName(rawCities, cityLabel);
            if (cityId) {
              updatedWarehouse.warehouseCity = cityId;
              // Clear the pending label after conversion
              delete updatedWarehouse._pendingCityLabel;
            }
          } else {
            // It's already an ID, ensure it's in string format
            updatedWarehouse.warehouseCity = String(isAlreadyId.id || isAlreadyId.value);
            delete updatedWarehouse._pendingCityLabel;
          }
        }
        
        return updatedWarehouse;
      }));
    }
  }, [rawCities]);

  // function setId({ key, id }) {
  //   switch (key) {
  //     case "company":
  //       setCompanyIdState(id);
  //       companyIdRef.current = id;
  //       break;
  //     case "factory":
  //       setFactoryIdState(id);
  //       factoryIdRef.current = id;
  //       break;
  //     case "quality":
  //       setQualityIdState(id);
  //       qualityIdRef.current = id;
  //       break;
  //     case "product":
  //       setProductIdState(id);
  //       productIdRef.current = id;
  //       break;
  //     default:
  //       break;
  //   }
  // }

  // Factory Details Master
  const { 
    factorySizeUnitsOptions, 
    factoryDistanceUnitsOptions,
    shippingTermsOptions,
    modeOfTransportOptions,
    paymentMethodOptions,
    paymentScheduleOptions,
    latePaymentPolicyOptions
  } = useFactoryDetailsMaster();

  // Product Details Master
  const { 
    customizationTypes,
    customizationTypesOptions,
    dimensionUnit,
    dimensionUnitOptions,
    attributeUnit,
    attributeUnitOptions,
    packagingMaterials,
    packagingMaterialsOptions,
    labelling,
    labellingOptions,
    inventoryStatus,
    inventoryStatusOptions,
    packingTypesOptions,
    fetchPackingTypes,
    loadingPackingTypes,
    categoryData: apiCategoryData,
    loadingCategories,
    subCategories: hookSubCategories,
    subCategoriesOptions,
    loadingSubCategories: hookLoadingSubCategories,
    fetchSubCategories,
    subSubCategories: hookSubSubCategories,
    subSubCategoriesOptions,
    loadingSubSubCategories: hookLoadingSubSubCategories,
    fetchSubSubCategories
  } = useProductDetailsMaster();

  // helper - find option object by value (with type coercion and fuzzy matching)
  const findOption = (options, val, matchBy = 'value') => {
    if (!val || val === '' || !options || options.length === 0) return null;
    
    // Convert val to string for consistent comparison
    const valStr = String(val).trim();
    if (!valStr) return null;
    
    if (matchBy === 'label') {
      // Match by label (for factory/warehouse locations that store labels)
      return options.find((o) => 
        String(o.label) === valStr || 
        o.label?.toLowerCase() === valStr.toLowerCase()
      ) || null;
    } else {
      // Match by value (default) - try multiple matching strategies
      // First, try exact and case-insensitive matches
      let found = options.find((o) => {
        if (!o || typeof o !== 'object') return false;
        // Try exact match
        if (String(o.value) === valStr || o.value === val) return true;
        // Try numeric match
        if (!isNaN(Number(o.value)) && !isNaN(Number(valStr)) && Number(o.value) === Number(valStr)) return true;
        // Try case-insensitive string match
        if (typeof o.value === 'string' && o.value.toLowerCase() === valStr.toLowerCase()) return true;
        // Try matching by label as fallback
        if (o.label && String(o.label).toLowerCase() === valStr.toLowerCase()) return true;
        return false;
      });
      
      // If not found, try matching enum strings (like "OUT_OF_STOCK") by converting to readable labels
      if (!found && typeof valStr === 'string' && valStr.includes('_')) {
        const upperValStr = valStr.toUpperCase();
        
        // Convert enum format to readable label (e.g., "OUT_OF_STOCK" -> "Out of Stock")
        const readableLabel = valStr
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ');
        
        found = options.find((o) => {
          if (!o || typeof o !== 'object') return false;
          const optionLabel = String(o.label || '').trim();
          const normalizedOptLabel = optionLabel.toLowerCase().replace(/[-\s_]/g, ' ').trim();
          const normalizedReadableLabel = readableLabel.toLowerCase().replace(/[-\s_]/g, ' ').trim();
          
          // Match by readable label format with various normalizations
          if (optionLabel.toLowerCase() === readableLabel.toLowerCase() ||
              normalizedOptLabel === normalizedReadableLabel ||
              optionLabel.toLowerCase().includes(readableLabel.toLowerCase()) ||
              readableLabel.toLowerCase().includes(optionLabel.toLowerCase())) {
            return true;
          }
          
          // Also try converting option label to enum format and comparing
          const labelAsEnum = optionLabel
            .toUpperCase()
            .replace(/[-\s]+/g, '_')
            .replace(/[^A-Z0-9_]/g, '');
          
          return labelAsEnum === upperValStr;
        });
      }
      
      // If not found, try fuzzy matching for common typos (especially for packing types)
      if (!found && typeof valStr === 'string') {
        const valLower = valStr.toLowerCase();
        found = options.find((o) => {
          if (!o || typeof o !== 'object') return false;
          const optionValue = String(o.value || '').toLowerCase();
          const optionLabel = String(o.label || '').toLowerCase();
          
          // Try fuzzy match - check if strings are very similar (handle common typos)
          // Common typo: "Flim" vs "Film"
          if (valLower.includes('flim') && (optionValue.includes('film') || optionLabel.includes('film'))) {
            return true;
          }
          if (valLower.includes('film') && (optionValue.includes('flim') || optionLabel.includes('flim'))) {
            return true;
          }
          
          // Try Levenshtein-like matching for very similar strings (difference of 1-2 characters)
          const similarity = (str1, str2) => {
            const longer = str1.length > str2.length ? str1 : str2;
            const shorter = str1.length > str2.length ? str2 : str1;
            if (longer.length === 0) return 1.0;
            const editDistance = levenshteinDistance(longer, shorter);
            return (longer.length - editDistance) / longer.length;
          };
          
          // If strings are 85% similar, consider it a match
          if (similarity(valLower, optionValue) >= 0.85 || similarity(valLower, optionLabel) >= 0.85) {
            return true;
          }
          
          return false;
        });
      }
      
      return found || null;
    }
  };
  
  // Helper function for Levenshtein distance (for fuzzy matching)
  const levenshteinDistance = (str1, str2) => {
    const matrix = [];
    for (let i = 0; i <= str2.length; i++) {
      matrix[i] = [i];
    }
    for (let j = 0; j <= str1.length; j++) {
      matrix[0][j] = j;
    }
    for (let i = 1; i <= str2.length; i++) {
      for (let j = 1; j <= str1.length; j++) {
        if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1,
            matrix[i][j - 1] + 1,
            matrix[i - 1][j] + 1
          );
        }
      }
    }
    return matrix[str2.length][str1.length];
  };

  // handle location change from react-select
  // name: "country" | "state" | "city"
  // selected: option object or null
  const handleLocationChange = (name, selected) => {
    const value = selected ? selected.value : "";
    // update your form using same shape as your onChange expects
    // (you previously call onChange({ target: { name, value } }))
    onChange({ target: { name, value } });

    if (name === "country") {
      // clear dependent values
      onChange({ target: { name: "state", value: "" } });
      onChange({ target: { name: "city", value: "" } });

      // ask hook to load states for this country
      updateListsForCountry(value);
    } else if (name === "state") {
      // clear city
      onChange({ target: { name: "city", value: "" } });

      // update city list for selected state (pass the country id as well)
      updateListsForState(form.country || value ? form.country || value : "", value);
      // Note: updateListsForState signature expects (countryId, stateId).
      // If you keep country in form, use that. Here we use form.country as source of truth.
    }
  };

  // handle factory location change from react-select
  // name: "factoryCountry" | "factoryState" | "factoryCity"
  // selected: option object or null
  const handleFactoryLocationChange = (name, selected) => {
    const value = selected ? selected.value : "";
    
    if (name === "factoryCountry") {
      // clear dependent values and update country
      setForm(prev => ({ ...prev, factoryCountry: value, factoryState: "", factoryCity: "" }));
      // ask hook to load states for this country
      if (value) updateListsForCountry(value);
    } else if (name === "factoryState") {
      // clear city and update state
      setForm(prev => {
        const updated = { ...prev, factoryState: value, factoryCity: "" };
        // update city list for selected state (pass the country id as well)
        if (value && updated.factoryCountry) {
          updateListsForState(updated.factoryCountry, value);
        }
        return updated;
      });
    } else {
      // just update the field
      setForm(prev => ({ ...prev, [name]: value }));
    }
  };

  // handle warehouse location change from react-select
  // name: "warehouseCountry" | "warehouseState" | "warehouseCity"
  // selected: option object or null
  const handleWarehouseLocationChange = (name, selected) => {
    const value = selected ? selected.value : "";
    
    if (name === "warehouseCountry") {
      // clear dependent values and update country
      setForm(prev => ({ ...prev, warehouseCountry: value, warehouseState: "", warehouseCity: "" }));
      // ask hook to load states for this country
      if (value) updateListsForCountry(value);
    } else if (name === "warehouseState") {
      // clear city and update state
      setForm(prev => {
        const updated = { ...prev, warehouseState: value, warehouseCity: "" };
        // update city list for selected state (pass the country id as well)
        if (value && updated.warehouseCountry) {
          updateListsForState(updated.warehouseCountry, value);
        }
        return updated;
      });
    } else {
      // just update the field
      setForm(prev => ({ ...prev, [name]: value }));
    }
  };

  const [form, setForm] = useState(initialState);
  const [productInput, setProductInput] = useState('');
  const [products, setProducts] = useState(['pen', 'pencil', 'paper']);
  const [keywordInput, setKeywordInput] = useState('');
  const [keywords, setKeywords] = useState([]);
  const [activeTab, setActiveTab] = useState('1');

  // Dynamic Category Attributes (New Unified System)
  // This hook fetches attributes dynamically based on the selected category_id
  // Usage: When form.pd_cat changes, this will automatically fetch the mapped attributes
  const {
    attributes: categoryAttributes,
    attributesByKey: categoryAttributesByKey,
    loading: categoryAttributesLoading,
    error: categoryAttributesError,
    getAttributeByKey,
    getAttributeOptions,
    getSubAttribute,
    getSubAttributeOptions,
  } = useCategoryAttributes(form?.pd_cat || null);

  // Debug logging for category attributes
  useEffect(() => {
    if (form?.pd_cat) {
      console.log('[seller_profile] Category selected:', {
        categoryId: form.pd_cat,
        attributesCount: categoryAttributes?.length || 0,
        loading: categoryAttributesLoading,
        error: categoryAttributesError,
        attributes: categoryAttributes?.map(a => ({
          key: a.attribute_key,
          name: a.attribute_name,
          type: a.attribute_type,
          isActive: a.is_active,
          optionsCount: a.options?.length || 0,
          subAttributesCount: a.sub_attributes?.length || 0
        }))
      });
    }
  }, [form?.pd_cat, categoryAttributes, categoryAttributesLoading, categoryAttributesError]);
  
  // Factory Details and Warehouse Locations arrays
  const [factoryDetailsList, setFactoryDetailsList] = useState([{
    factoryName: '',
    factorySize: '',
    factoryUnit: '',
    noOfEmployees: '',
    noOfQualityStaff: '',
    noOfRDStaff: '',
    totalProductionLines: '',
    annualOutput: '',
    averageLeadTime: '',
    factoryAddress: '',
    factoryCountry: '',
    factoryState: '',
    factoryCity: '',
    factoryPincode: '',
    // Per-factory location options to prevent cross-contamination
    factoryStates: [],
    factoryCities: []
  }]);
  
  const [warehouseLocationsList, setWarehouseLocationsList] = useState([{
    warehouseName: '',
    stockQuantity: '',
    warehouseAddress: '',
    warehouseCountry: '',
    warehouseState: '',
    warehouseCity: '',
    warehousePincode: '',
    // Per-warehouse location options to prevent cross-contamination (same as factories)
    warehouseStates: [],
    warehouseCities: []
  }]);

  // Certificates array for "Add More" functionality
  const [certificatesList, setCertificatesList] = useState([{
    certificateTitle: '',
    certificationCompany: '',
    certificateStartDate: '',
    certificateEndDate: '',
    certificateDetails: '',
    certificateAttachmentUrl: ''
  }]);

  // Add new factory details entry
  const addFactoryDetails = () => {
    setFactoryDetailsList(prev => [...prev, {
      factoryName: '',
      factorySize: '',
      factoryUnit: '',
      noOfEmployees: '',
      noOfQualityStaff: '',
      noOfRDStaff: '',
      totalProductionLines: '',
      annualOutput: '',
      averageLeadTime: '',
      factoryAddress: '',
      factoryCountry: '',
      factoryState: '',
      factoryCity: '',
      factoryPincode: '',
      // Per-factory location options to prevent cross-contamination
      factoryStates: [],
      factoryCities: []
    }]);
  };

  // Remove factory details entry
  const removeFactoryDetails = (index) => {
    if (factoryDetailsList.length > 1) {
      setFactoryDetailsList(prev => prev.filter((_, i) => i !== index));
    }
  };

  // Update factory details entry
  const updateFactoryDetails = (index, field, value) => {
    setFactoryDetailsList(prev => prev.map((item, i) => 
      i === index ? { ...item, [field]: value } : item
    ));
  };

  // Add new warehouse location entry
  const addWarehouseLocation = () => {
    setWarehouseLocationsList(prev => [...prev, {
      warehouseName: '',
      stockQuantity: '',
      warehouseAddress: '',
      warehouseCountry: '',
      warehouseState: '',
      warehouseCity: '',
      warehousePincode: '',
      // Per-warehouse location options to prevent cross-contamination (same as factories)
      warehouseStates: [],
      warehouseCities: []
    }]);
  };

  // Remove warehouse location entry
  const removeWarehouseLocation = (index) => {
    if (warehouseLocationsList.length > 1) {
      setWarehouseLocationsList(prev => prev.filter((_, i) => i !== index));
    }
  };

  // Add new certificate entry
  const addCertificate = () => {
    setCertificatesList(prev => [...prev, {
      certificateTitle: '',
      certificationCompany: '',
      certificateStartDate: '',
      certificateEndDate: '',
      certificateDetails: '',
      certificateAttachmentUrl: ''
    }]);
  };

  // Remove certificate entry
  const removeCertificate = (index) => {
    if (certificatesList.length > 1) {
      setCertificatesList(prev => prev.filter((_, i) => i !== index));
    }
  };

  // Update certificate entry
  const updateCertificate = (index, field, value) => {
    setCertificatesList(prev => prev.map((item, i) => 
      i === index ? { ...item, [field]: value } : item
    ));
  };

  // Load factory location data (states/cities) when countries are loaded and factory details exist
  // This useEffect must be after factoryDetailsList declaration to avoid "before initialization" error
  useEffect(() => {
    // Check if we have factories with country data and countries are loaded
    const hasFactoriesWithCountries = factoryDetailsList.some(f => f.factoryCountry);
    
    if (hasFactoriesWithCountries && countriesLoaded && rawCountries && rawCountries.length > 0) {
      const loadFactoryLocationData = async () => {
        const promises = factoryDetailsList.map(async (factory, index) => {
          if (!factory.factoryCountry) return;
          
          // Skip if states are already loaded for this factory (prevent infinite loop)
          if (factory.factoryStates && factory.factoryStates.length > 0) {
            // Still check if cities need to be loaded
            if (factory.factoryState && (!factory.factoryCities || factory.factoryCities.length === 0)) {
              // Cities not loaded yet, but states are - load cities
              const stateId = factory.factoryStates.find(s => {
                const stateLabel = s.label?.toLowerCase().trim();
                const factoryStateLabel = String(factory.factoryState).toLowerCase().trim();
                return stateLabel === factoryStateLabel;
              })?.value;
              
              if (stateId) {
                try {
                  const cityResponse = await CommonService.get(`/master/company-City/${stateId}`);
                  if (cityResponse && cityResponse.success && cityResponse.data) {
                    const apiCities = Array.isArray(cityResponse.data) 
                      ? cityResponse.data 
                      : cityResponse.data.cities || cityResponse.data.master_cities || [];
                    
                    const mappedCities = apiCities.map((city) => {
                      const id = city.city_id || city.id || city.value;
                      const label = city.city_name || city.city_label || city.label || city.name || city.city;
                      return { value: String(id), label };
                    }).filter(c => c.value !== undefined && c.value !== null && c.label);
                    
                    // Update factory cities options
                    setFactoryDetailsList(prev => prev.map((f, i) => {
                      if (i === index) {
                        return { 
                          ...f, 
                          factoryCities: mappedCities
                        };
                      }
                      return f;
                    }));
                  }
                } catch (cityErr) {
                  console.error(`Error loading cities for factory ${index}:`, cityErr);
                }
              }
            }
            return; // States already loaded, skip
          }
          
          // Find country ID from label for API call
          const countryId = findIdByName(rawCountries, factory.factoryCountry);
          
          if (!countryId) {
            console.warn(`Could not find country ID for label: "${factory.factoryCountry}" in factory ${index}`);
            return;
          }
          
          try {
            const response = await CommonService.get(`/master/company-State/${countryId}`);
            if (response && response.success && response.data) {
              const apiStates = Array.isArray(response.data) 
                ? response.data 
                : response.data.states || response.data.master_states || [];
              
              const mappedStates = apiStates.map((state) => {
                const id = state.state_id || state.id || state.value;
                const label = state.state_name || state.state_label || state.label || state.name || state.state;
                return { value: String(id), label };
              }).filter(s => s.value !== undefined && s.value !== null && s.label);
              
              // Update factory states options
              setFactoryDetailsList(prev => prev.map((f, i) => {
                if (i === index) {
                  return { 
                    ...f, 
                    factoryStates: mappedStates
                  };
                }
                return f;
              }));

              // If factory also has a state selected, load cities
              if (factory.factoryState) {
                // Find state ID from label for API call (case-insensitive match)
                const stateId = mappedStates.find(s => {
                  const stateLabel = s.label?.toLowerCase().trim();
                  const factoryStateLabel = String(factory.factoryState).toLowerCase().trim();
                  return stateLabel === factoryStateLabel;
                })?.value;
                
                if (stateId) {
                  try {
                    const cityResponse = await CommonService.get(`/master/company-City/${stateId}`);
                    if (cityResponse && cityResponse.success && cityResponse.data) {
                      const apiCities = Array.isArray(cityResponse.data) 
                        ? cityResponse.data 
                        : cityResponse.data.cities || cityResponse.data.master_cities || [];
                      
                      const mappedCities = apiCities.map((city) => {
                        const id = city.city_id || city.id || city.value;
                        const label = city.city_name || city.city_label || city.label || city.name || city.city;
                        return { value: String(id), label };
                      }).filter(c => c.value !== undefined && c.value !== null && c.label);
                      
                      // Update factory cities options
                      setFactoryDetailsList(prev => prev.map((f, i) => {
                        if (i === index) {
                          return { 
                            ...f, 
                            factoryCities: mappedCities
                          };
                        }
                        return f;
                      }));
                    }
                  } catch (cityErr) {
                    console.error(`Error loading cities for factory ${index}:`, cityErr);
                  }
                } else {
                  console.warn(`Could not find state ID for label: "${factory.factoryState}" in factory ${index}. Available states:`, mappedStates.map(s => s.label));
                }
              }
            }
          } catch (stateErr) {
            console.error(`Error loading states for factory ${index}:`, stateErr);
          }
        });
        await Promise.all(promises);
      };
      
      loadFactoryLocationData();
    }
  }, [factoryDetailsList.length, countriesLoaded, rawCountries]);

  // Load warehouse location data (states/cities) when warehouses are loaded and countries are available
  // This useEffect handles the conversion of stored labels to IDs for API calls, then back to labels for display
  useEffect(() => {
    // Check if we have warehouses with country data and countries are loaded
    const hasWarehousesWithCountries = warehouseLocationsList.some(w => w.warehouseCountry);
    
    if (hasWarehousesWithCountries && countriesLoaded && rawCountries && rawCountries.length > 0) {
      const loadWarehouseLocationData = async () => {
        const promises = warehouseLocationsList.map(async (warehouse, index) => {
          if (!warehouse.warehouseCountry) return;
          
          // Skip if states are already loaded for this warehouse (prevent infinite loop)
          if (warehouse.warehouseStates && warehouse.warehouseStates.length > 0) {
            // Still check if cities need to be loaded
            if (warehouse.warehouseState && (!warehouse.warehouseCities || warehouse.warehouseCities.length === 0)) {
              // Cities not loaded yet, but states are - load cities
              const stateId = warehouse.warehouseStates.find(s => {
                const stateLabel = s.label?.toLowerCase().trim();
                const warehouseStateLabel = String(warehouse.warehouseState).toLowerCase().trim();
                return stateLabel === warehouseStateLabel;
              })?.value;
              
              if (stateId) {
                try {
                  const cityResponse = await CommonService.get(`/master/company-City/${stateId}`);
                  if (cityResponse && cityResponse.success && cityResponse.data) {
                    const apiCities = Array.isArray(cityResponse.data) 
                      ? cityResponse.data 
                      : cityResponse.data.cities || cityResponse.data.master_cities || [];
                    
                    const mappedCities = apiCities.map((city) => {
                      const id = city.city_id || city.id || city.value;
                      const label = city.city_name || city.city_label || city.label || city.name || city.city;
                      return { value: String(id), label };
                    }).filter(c => c.value !== undefined && c.value !== null && c.label);
                    
                    // Update only this warehouse's cities list
                    setWarehouseLocationsList(prev => prev.map((w, i) => {
                      if (i === index) {
                        return { ...w, warehouseCities: mappedCities };
                      }
                      return w;
                    }));
                  }
                } catch (cityErr) {
                  console.error(`Error loading cities for warehouse ${index}:`, cityErr);
                }
              }
            }
            return; // States already loaded, skip
          }
          
          try {
            // Convert country label to ID for API call (same pattern as factory details)
            const countryId = findIdByName(rawCountries, warehouse.warehouseCountry);
            
            if (!countryId) {
              console.warn(`Could not find country ID for warehouse ${index + 1} with country: "${warehouse.warehouseCountry}"`);
              return;
            }
            
            // Validate countryId is a valid number
            const numericCountryId = parseInt(countryId);
            if (isNaN(numericCountryId) || numericCountryId <= 0) {
              console.warn(`Invalid country ID for warehouse ${index + 1}: "${countryId}" (country: "${warehouse.warehouseCountry}")`);
              return;
            }
            
            // Load states for this specific warehouse's country
            let response;
            try {
              response = await CommonService.get(`/master/company-State/${numericCountryId}`);
            } catch (apiError) {
              // Handle network errors or API errors
              if (apiError.code === 'ERR_NETWORK' || apiError.message?.includes('Network Error')) {
                console.error(`Network error loading states for warehouse ${index + 1} (country ID: ${numericCountryId}):`, apiError.message);
              } else {
                console.error(`API error loading states for warehouse ${index + 1} (country ID: ${numericCountryId}):`, apiError);
              }
              return; // Skip this warehouse if API call fails
            }
              
            if (response && response.success && response.data) {
                const apiStates = Array.isArray(response.data) 
                  ? response.data 
                  : response.data.states || response.data.master_states || [];
                
                const mappedStates = apiStates.map((state) => {
                  const id = state.state_id || state.id || state.value;
                  const label = state.state_name || state.state_label || state.label || state.name || state.state;
                  return { value: String(id), label };
                }).filter(s => s.value !== undefined && s.value !== null && s.label);
                
                // Update only this warehouse's states list
                setWarehouseLocationsList(prev => prev.map((w, i) => {
                  if (i === index) {
                    return { ...w, warehouseStates: mappedStates };
                  }
                  return w;
                }));
                
                // If warehouse also has a state selected, load cities for that state
                if (warehouse.warehouseState) {
                  try {
                    // Find state ID from label for API call (case-insensitive match, same as factory)
                    const stateId = mappedStates.find(s => {
                      const stateLabel = s.label?.toLowerCase().trim();
                      const warehouseStateLabel = String(warehouse.warehouseState).toLowerCase().trim();
                      return stateLabel === warehouseStateLabel;
                    })?.value;
                    
                    if (stateId) {
                      const cityResponse = await CommonService.get(`/master/company-City/${stateId}`);
                      if (cityResponse && cityResponse.success && cityResponse.data) {
                        const apiCities = Array.isArray(cityResponse.data) 
                          ? cityResponse.data 
                          : cityResponse.data.cities || cityResponse.data.master_cities || [];
                        
                        const mappedCities = apiCities.map((city) => {
                          const id = city.city_id || city.id || city.value;
                          const label = city.city_name || city.city_label || city.label || city.name || city.city;
                          return { value: String(id), label };
                        }).filter(c => c.value !== undefined && c.value !== null && c.label);
                        
                        // Update only this warehouse's cities list
                        setWarehouseLocationsList(prev => prev.map((w, i) => {
                          if (i === index) {
                            return { ...w, warehouseCities: mappedCities };
                          }
                          return w;
                        }));
                      }
                    } else {
                      console.warn(`Could not find state ID for label: "${warehouse.warehouseState}" in warehouse ${index}. Available states:`, mappedStates.map(s => s.label));
                    }
                  } catch (cityErr) {
                    console.error(`Error loading cities for warehouse ${index}:`, cityErr);
                  }
                }
              } else {
                console.warn(`No states data in response for warehouse ${index + 1} (country: "${warehouse.warehouseCountry}")`);
              }
          } catch (stateErr) {
            console.error(`Error loading states for warehouse ${index + 1}:`, stateErr);
          }
        });
        await Promise.all(promises);
      };
      
      loadWarehouseLocationData();
    }
  }, [
    warehouseLocationsList.length, 
    countriesLoaded, 
    rawCountries?.length,
    // Add dependency on warehouse countries to trigger when warehouse data is loaded
    warehouseLocationsList.map(w => w.warehouseCountry).join(',')
  ]);

  // Update warehouse location entry
  const updateWarehouseLocation = (index, field, value) => {
    setWarehouseLocationsList(prev => prev.map((item, i) => 
      i === index ? { ...item, [field]: value } : item
    ));
  };

  // Handle factory location change for array entries (store labels, not IDs)
  const handleFactoryLocationChangeArray = async (index, name, selected) => {
    if (name === "factoryCountry") {
      // Store country label (from selected option)
      const countryLabel = selected ? selected.label : "";
      const countryId = selected ? selected.value : "";
      
      updateFactoryDetails(index, "factoryCountry", countryLabel); // Store label
      updateFactoryDetails(index, "factoryState", "");
      updateFactoryDetails(index, "factoryCity", "");
      updateFactoryDetails(index, "factoryStates", []);
      updateFactoryDetails(index, "factoryCities", []);
      
      // Load states for this specific factory's country (using ID for API call)
      if (countryId) {
        try {
          setLoadingFactoryStates(true);
          const response = await CommonService.get(`/master/company-State/${countryId}`);
          
          if (response && response.success && response.data) {
            const apiStates = Array.isArray(response.data) 
              ? response.data 
              : response.data.states || response.data.master_states || [];
            
            const mappedStates = apiStates.map((state) => {
              const id = state.state_id || state.id || state.value;
              const label = state.state_name || state.state_label || state.label || state.name || state.state;
              return { value: String(id), label };
            }).filter(s => s.value !== undefined && s.value !== null && s.label);
            
            // Update only this factory's states list
            updateFactoryDetails(index, "factoryStates", mappedStates);
          }
        } catch (error) {
          console.error("Error fetching states for factory:", error);
          updateFactoryDetails(index, "factoryStates", []);
        } finally {
          setLoadingFactoryStates(false);
        }
      }
    } else if (name === "factoryState") {
      // Store state label (from selected option)
      const stateLabel = selected ? selected.label : "";
      const stateId = selected ? selected.value : "";
      
      updateFactoryDetails(index, "factoryState", stateLabel); // Store label
      updateFactoryDetails(index, "factoryCity", "");
      updateFactoryDetails(index, "factoryCities", []);
      
      // Load cities for this specific factory's state (using ID for API call)
      if (stateId) {
        try {
          setLoadingFactoryCities(true);
          const response = await CommonService.get(`/master/company-City/${stateId}`);
          
          if (response && response.success && response.data) {
            const apiCities = Array.isArray(response.data) 
              ? response.data 
              : response.data.cities || response.data.master_cities || [];
            
            const mappedCities = apiCities.map((city) => {
              const id = city.city_id || city.id || city.value;
              const label = city.city_name || city.city_label || city.label || city.name || city.city;
              return { value: String(id), label };
            }).filter(c => c.value !== undefined && c.value !== null && c.label);
            
            // Update only this factory's cities list
            updateFactoryDetails(index, "factoryCities", mappedCities);
          } else {
            updateFactoryDetails(index, "factoryCities", []);
          }
        } catch (error) {
          console.error("Error fetching cities for factory:", error);
          updateFactoryDetails(index, "factoryCities", []);
        } finally {
          setLoadingFactoryCities(false);
        }
      }
    } else if (name === "factoryCity") {
      // Store city label (from selected option)
      const cityLabel = selected ? selected.label : "";
      updateFactoryDetails(index, "factoryCity", cityLabel); // Store label
    } else {
      updateFactoryDetails(index, name, selected ? (selected.value || selected) : "");
    }
  };

  // Handle warehouse location change for array entries (store labels, not IDs - same as factories)
  const handleWarehouseLocationChangeArray = async (index, name, selected) => {
    if (name === "warehouseCountry") {
      // Store country label (from selected option)
      const countryLabel = selected ? selected.label : "";
      const countryId = selected ? selected.value : "";
      
      updateWarehouseLocation(index, "warehouseCountry", countryLabel); // Store label
      updateWarehouseLocation(index, "warehouseState", "");
      updateWarehouseLocation(index, "warehouseCity", "");
      updateWarehouseLocation(index, "warehouseStates", []);
      updateWarehouseLocation(index, "warehouseCities", []);
      
      // Load states for this specific warehouse's country (using ID for API call)
      if (countryId) {
        try {
          setLoadingFactoryStates(true);
          const response = await CommonService.get(`/master/company-State/${countryId}`);
          
          if (response && response.success && response.data) {
            const apiStates = Array.isArray(response.data) 
              ? response.data 
              : response.data.states || response.data.master_states || [];
            
            const mappedStates = apiStates.map((state) => {
              const id = state.state_id || state.id || state.value;
              const label = state.state_name || state.state_label || state.label || state.name || state.state;
              return { value: String(id), label };
            }).filter(s => s.value !== undefined && s.value !== null && s.label);
            
            // Update only this warehouse's states list
            updateWarehouseLocation(index, "warehouseStates", mappedStates);
          }
        } catch (error) {
          console.error("Error fetching states for warehouse:", error);
          updateWarehouseLocation(index, "warehouseStates", []);
        } finally {
          setLoadingFactoryStates(false);
        }
      }
    } else if (name === "warehouseState") {
      // Store state label (from selected option)
      const stateLabel = selected ? selected.label : "";
      const stateId = selected ? selected.value : "";
      
      updateWarehouseLocation(index, "warehouseState", stateLabel); // Store label
      updateWarehouseLocation(index, "warehouseCity", "");
      updateWarehouseLocation(index, "warehouseCities", []);
      
      // Load cities for this specific warehouse's state (using ID for API call)
      if (stateId) {
        try {
          setLoadingFactoryCities(true);
          const response = await CommonService.get(`/master/company-City/${stateId}`);
          
          if (response && response.success && response.data) {
            const apiCities = Array.isArray(response.data) 
              ? response.data 
              : response.data.cities || response.data.master_cities || [];
            
            const mappedCities = apiCities.map((city) => {
              const id = city.city_id || city.id || city.value;
              const label = city.city_name || city.city_label || city.label || city.name || city.city;
              return { value: String(id), label };
            }).filter(c => c.value !== undefined && c.value !== null && c.label);
            
            // Update only this warehouse's cities list
            updateWarehouseLocation(index, "warehouseCities", mappedCities);
          } else {
            updateWarehouseLocation(index, "warehouseCities", []);
          }
        } catch (error) {
          console.error("Error fetching cities for warehouse:", error);
          updateWarehouseLocation(index, "warehouseCities", []);
        } finally {
          setLoadingFactoryCities(false);
        }
      }
    } else if (name === "warehouseCity") {
      // Store city label (from selected option)
      const cityLabel = selected ? selected.label : "";
      updateWarehouseLocation(index, "warehouseCity", cityLabel); // Store label
    } else {
      updateWarehouseLocation(index, name, selected ? (selected.value || selected) : "");
    }
  };
  const [carouselEnabled, setCarouselEnabled] = useState(false);
  const [carouselFiles, setCarouselFiles] = useState([]);
  const [carouselImageUrls, setCarouselImageUrls] = useState([]);
  // Product file upload state
  const [productCatalogueFile, setProductCatalogueFile] = useState(null);
  const [productCatalogueUrl, setProductCatalogueUrl] = useState('');
  const [productVideoFile, setProductVideoFile] = useState(null);
  const [productVideoUrl, setProductVideoUrl] = useState('');
  const [productImageFiles, setProductImageFiles] = useState([]);
  const [productImageUrls, setProductImageUrls] = useState([]);
  const [uploadingProductFiles, setUploadingProductFiles] = useState(false);
  const [customizationRows, setCustomizationRows] = useState(DEFAULT_CUSTOMIZATION_ROWS);
  const [bulkDiscountSlabs, setBulkDiscountSlabs] = useState([
    { id: 1, bulk_min: '', bulk_max: '', bulk_uom: '', bulk_price_no: '', bulk_price_with: '', bulk_tax: '', bulk_currency: '' }
  ]);
  
  // Add More functionality state
  const [colourOptionsList, setColourOptionsList] = useState([
    { id: 1, color: '#ED00BE', imageUrl: '' }
  ]);
  const [dimensionsList, setDimensionsList] = useState([
    { id: 1, height: '', length: '', width: '', uom: '' }
  ]);
  const [inventoryDetailsList, setInventoryDetailsList] = useState([
    { id: 1, qty: '', uom: '', status: '', location: '' }
  ]);
  const [leadTimeList, setLeadTimeList] = useState([
    { id: 1, days: '', min: '', max: '' }
  ]);
  const [faqList, setFaqList] = useState([
    { id: 1, question: '', answer: '' }
  ]);
  const [attributesList, setAttributesList] = useState([
    { id: 1, attribute: '', value: '', unit: '' }
  ]);

  const [descModal, setDescModal] = useState({ visible: false, rowId: null });
  const [descText, setDescText] = useState('');
  const [descFileName, setDescFileName] = useState('');
  const [descFiles, setDescFiles] = useState([]);
  const uploadRef = useRef(null);

  // Product Catalogue state
  const [productCatalogueCollapsed, setProductCatalogueCollapsed] = useState(true);
  const [savedProducts, setSavedProducts] = useState([]);
  const [editingProductId, setEditingProductId] = useState(null);

  useEffect(() => {
    if (!customizationTypesOptions?.length) return;

    setSavedProducts((prev) => {
      if (!prev?.length) return prev;
      let changed = false;
      const next = prev.map((product) => {
        const pd_custom_available = normalizeCustomizationAvailable(
          product.pd_custom_available ?? product.customization_available,
        );
        const pd_custom_type = mapCustomizationTypeForEditValue(
          normalizeCustomizationTypes(product.customization_types)[0] || product.pd_custom_type || '',
          customizationTypesOptions,
        );
        if (
          product.pd_custom_available === pd_custom_available
          && String(product.pd_custom_type) === String(pd_custom_type)
        ) {
          return product;
        }
        changed = true;
        return {
          ...product,
          pd_custom_available,
          pd_custom_type,
          customization_available: pd_custom_available,
        };
      });
      return changed ? next : prev;
    });
  }, [customizationTypesOptions]);

  // Construction & Real Estate section collapse state
  const [creSections, setCreSections] = useState({
    safety: true,
    thermal: true,
    structural: true,
    glass: true,
    hvac: true,
    elevations: true
  });

  const toggleCreSection = (section) => {
    setCreSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  // Tools section collapse state
  const [toolsSections, setToolsSections] = useState({
    power: true
  });

  const toggleToolsSection = (section) => {
    setToolsSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  // Agricultural Products section collapse state
  const [agriSections, setAgriSections] = useState({
    productInfo: true,
    features: true,
    cultivation: true,
    packaging: true
  });

  const toggleAgriSection = (section) => {
    setAgriSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  // Health & Medical section collapse state
  const [healthMedicalSections, setHealthMedicalSections] = useState({
    wheelchair: true,
    device: true,
    ppe: true,
    diagnostics: true,
    tablets: true,
    injectables: true,
    syrup: true
  });

  const toggleHealthMedicalSection = (section) => {
    setHealthMedicalSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  // Luggage Bags & Cases section collapse state
  const [luggageSections, setLuggageSections] = useState({
    attributes: true
  });

  const toggleLuggageSection = (section) => {
    setLuggageSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  // Simple local category data with mapped IDs (replace with API later)
  // Use category data from API (fetched from master_category, master_sub_category, master_sub_sub_category tables)
  // Fallback to empty array if not loaded yet
  const categoryData = apiCategoryData && apiCategoryData.length > 0 ? apiCategoryData : [];
  
  // Debug: Log category data
  useEffect(() => {
    if (categoryData.length > 0) {
      console.log("Category data available:", categoryData.length, "categories");
    } else {
      console.warn("No category data available. Loading:", loadingCategories, "API data:", apiCategoryData);
    }
  }, [categoryData, loadingCategories, apiCategoryData]);

  // Dynamically load subcategories when category is selected using hook function
  useEffect(() => {
    if (!form.pd_cat) {
      // Clear subcategories and sub-subcategories when no category is selected
      fetchSubCategories(null); // Clear subcategories
      return;
    }

    // Use the hook function to fetch subcategories
    fetchSubCategories(form.pd_cat);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.pd_cat]); // Only depend on form.pd_cat, fetchSubCategories is stable (memoized)

  // Dynamically load sub-subcategories when subcategory is selected using hook function
  useEffect(() => {
    if (!form.pd_subcat) {
      // Clear sub-subcategories when no subcategory is selected
      fetchSubSubCategories(null); // Clear sub-subcategories
      return;
    }

    // Use the hook function to fetch sub-subcategories
    fetchSubSubCategories(form.pd_subcat);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.pd_subcat]); // Only depend on form.pd_subcat, fetchSubSubCategories is stable (memoized)

  // Helper function to get category name by ID
  const getCategoryName = (categoryId) => {
    if (!categoryId) return '';
    const category = categoryData.find(c => String(c.id) === String(categoryId));
    return (category?.name || '').toLowerCase();
  };

  // Categories that show Electronics Attributes
  // Check if selected category name matches electronics-related categories (case-insensitive)
  const isElectronicsCategory = (categoryId) => {
    if (!categoryId) return false;
    const categoryName = getCategoryName(categoryId);
    if (!categoryName) return false;
    
    const electronicsKeywords = ['electronics', 'electronic', 'mobile', 'phone', 'appliance', 'renewable', 'energy', 'electrical'];
    return electronicsKeywords.some(keyword => categoryName.includes(keyword));
  };

  // Check if category matches by name (case-insensitive, partial match)
  const isCategoryByName = (categoryId, categoryNames) => {
    if (!categoryId) return false;
    const categoryName = getCategoryName(categoryId);
    if (!categoryName) return false;
    
    const searchNames = Array.isArray(categoryNames) ? categoryNames : [categoryNames];
    return searchNames.some(name => categoryName.includes(name.toLowerCase()));
  };

  // Category-specific attribute section helpers
  const isApparelCategory = (categoryId) => isCategoryByName(categoryId, ['apparel', 'fashion', 'clothing', 'wear']);
  const isShoesCategory = (categoryId) => isCategoryByName(categoryId, ['shoes', 'shoe', 'footwear']);
  const isLuggageCategory = (categoryId) => isCategoryByName(categoryId, ['luggage', 'bag', 'case', 'suitcase']);
  const isFurnitureCategory = (categoryId) => isCategoryByName(categoryId, ['furniture', 'furnishing']);
  const isHomeGardenCategory = (categoryId) => isCategoryByName(categoryId, ['home', 'garden', 'household']);
  const isHomeAppliancesCategory = (categoryId) => isCategoryByName(categoryId, ['appliance', 'home appliance']);
  const isFoodCategory = (categoryId) => isCategoryByName(categoryId, ['food', 'beverage', 'beverages', 'drink']);
  const isCleaningCategory = (categoryId) => isCategoryByName(categoryId, ['cleaning', 'clean', 'detergent']);
  const isPetCategory = (categoryId) => isCategoryByName(categoryId, ['pet', 'animal', 'dog', 'cat']);
  const isHomeCareCategory = (categoryId) => isCategoryByName(categoryId, ['home care', 'homecare']);
  const isToolsCategory = (categoryId) => isCategoryByName(categoryId, ['tool', 'tools', 'equipment']);
  const isAgriculturalCategory = (categoryId) => isCategoryByName(categoryId, ['agricultural', 'agriculture', 'farming', 'crop']);
  const isConstructionCategory = (categoryId) => isCategoryByName(categoryId, ['construction', 'building', 'material']);
  const isIndustrialCategory = (categoryId) => isCategoryByName(categoryId, ['industrial', 'industry', 'equipment']);
  const isBeautyCategory = (categoryId) => isCategoryByName(categoryId, ['beauty', 'cosmetic', 'personal care']);
  const isHealthcareCategory = (categoryId) => isCategoryByName(categoryId, ['healthcare', 'health care', 'medical']);
  const isHealthMedicalCategory = (categoryId) => isCategoryByName(categoryId, ['health', 'medical', 'medicine']);
  const isToysCategory = (categoryId) => isCategoryByName(categoryId, ['toy', 'toys', 'game', 'games']);
  const isOfficeSuppliesCategory = (categoryId) => isCategoryByName(categoryId, ['office', 'supplies', 'stationery']);
  const isBooksCategory = (categoryId) => isCategoryByName(categoryId, ['book', 'books']);
  const isLightsCategory = (categoryId) => isCategoryByName(categoryId, ['light', 'lights', 'lighting', 'lamp']);
  
  // For backward compatibility, create array of electronics category IDs
  const electronicsCategories = categoryData
    .filter(cat => isElectronicsCategory(cat.id))
    .map(cat => String(cat.id));

  const handleCategoryChange = (e) => {
    const value = e.target.value;
    setForm((prev) => ({ ...prev, pd_cat: value, pd_subcat: '', pd_subsubcat: '' }));
  };

  const handleSubcategoryChange = (e) => {
    const value = e.target.value;
    setForm((prev) => ({ ...prev, pd_subcat: value, pd_subsubcat: '' }));
  };

  const handleSubSubcategoryChange = (e) => {
    const value = e.target.value;
    setForm((prev) => ({ ...prev, pd_subsubcat: value }));
  };



  // Customization mapped values - now fetched from API via useProductDetailsMaster hook
  // customizationTypesOptions is available from the hook above

  // Units of Measurement map values - now fetched from API via useProductDetailsMaster hook
  // dimensionUnitOptions is available from the hook above

  // Inventory status map values - now fetched from API via useProductDetailsMaster hook
  // inventoryStatusOptions is available from the hook above

  const warrantyOptions = [
    { id: '1_month', label: '1 Month' },
    { id: '3_months', label: '3 Months' },
    { id: '6_months', label: '6 Months' },
    { id: '1_year', label: '1 Year' },
    { id: '2_years', label: '2 Years' },
    { id: '3_years', label: '3 Years' },
    { id: '5_years', label: '5 Years' }
  ];

  const countryOptions = [
    { id: 'us', label: 'United States' },
    { id: 'cn', label: 'China' },
    { id: 'jp', label: 'Japan' },
    { id: 'kr', label: 'South Korea' },
    { id: 'in', label: 'India' },
    { id: 'de', label: 'Germany' },
    { id: 'tw', label: 'Taiwan' }
  ];

  // Construction & Real Estate attribute mapped values
  const fireRatingUnitOptions = [
    { id: 'min', label: 'min' },
    { id: 'hours', label: 'hours' }
  ];

  const seismicComplianceOptions = [
    { id: 'zone_1', label: 'Zone 1' },
    { id: 'zone_2', label: 'Zone 2' },
    { id: 'zone_3', label: 'Zone 3' },
    { id: 'zone_4', label: 'Zone 4' },
    { id: 'zone_5', label: 'Zone 5' },
    { id: 'compliant', label: 'Compliant' },
    { id: 'non_compliant', label: 'Non-Compliant' }
  ];

  const standardsOptions = [
    { id: 'astm', label: 'ASTM' },
    { id: 'iso', label: 'ISO' },
    { id: 'bs', label: 'BS' },
    { id: 'din', label: 'DIN' },
    { id: 'jis', label: 'JIS' },
    { id: 'en', label: 'EN' },
    { id: 'asme', label: 'ASME' }
  ];

  const greenRatingOptions = [
    { id: 'leed', label: 'LEED' },
    { id: 'breeam', label: 'BREEAM' },
    { id: 'green_star', label: 'Green Star' },
    { id: 'edge', label: 'EDGE' },
    { id: 'none', label: 'None selected' }
  ];

  const waterPermeabilityClassOptions = [
    { id: 'class_1', label: 'Class 1' },
    { id: 'class_2', label: 'Class 2' },
    { id: 'class_3', label: 'Class 3' },
    { id: 'class_4', label: 'Class 4' },
    { id: 'class_5', label: 'Class 5' }
  ];

  const airTightnessOptions = [
    { id: 'level_1', label: 'Level 1' },
    { id: 'level_2', label: 'Level 2' },
    { id: 'level_3', label: 'Level 3' },
    { id: 'level_4', label: 'Level 4' }
  ];

  const glassTypeOptions = [
    { id: 'float', label: 'Float Glass' },
    { id: 'tempered', label: 'Tempered Glass' },
    { id: 'laminated', label: 'Laminated Glass' },
    { id: 'insulated', label: 'Insulated Glass' },
    { id: 'low_e', label: 'Low-E Glass' },
    { id: 'tinted', label: 'Tinted Glass' }
  ];

  const waterTightnessOptions = [
    { id: 'pa_1', label: 'PA 1' },
    { id: 'pa_2', label: 'PA 2' },
    { id: 'pa_3', label: 'PA 3' },
    { id: 'pa_4', label: 'PA 4' },
    { id: 'pa_5', label: 'PA 5' }
  ];

  const northwestShadeOptions = [
    { id: 'none', label: 'None' },
    { id: 'partial', label: 'Partial' },
    { id: 'full', label: 'Full' }
  ];

  const hardwareGradeOptions = [
    { id: 'grade_1', label: 'Grade 1' },
    { id: 'grade_2', label: 'Grade 2' },
    { id: 'grade_3', label: 'Grade 3' },
    { id: 'commercial', label: 'Commercial' },
    { id: 'residential', label: 'Residential' },
    { id: 'industrial', label: 'Industrial' },
    { id: 'premium', label: 'Premium' }
  ];

  const refrigerantTypeOptions = [
    { id: 'r22', label: 'R22' },
    { id: 'r410a', label: 'R410A' },
    { id: 'r134a', label: 'R134a' },
    { id: 'r32', label: 'R32' },
    { id: 'r407c', label: 'R407C' }
  ];

  const hvacCapacityUnitOptions = [
    { id: 'ton', label: 'Ton' },
    { id: 'btu', label: 'BTU' },
    { id: 'kw', label: 'kW' }
  ];

  const doorTypeOptions = [
    { id: 'center_opening', label: 'Center Opening' },
    { id: 'side_opening', label: 'Side Opening' },
    { id: 'two_speed', label: 'Two-Speed' },
    { id: 'sliding', label: 'Sliding' }
  ];

  const driveTypeOptions = [
    { id: 'traction', label: 'Traction' },
    { id: 'hydraulic', label: 'Hydraulic' },
    { id: 'machine_room_less', label: 'Machine Room-Less (MRL)' },
    { id: 'gearless', label: 'Gearless' },
    { id: 'gearless_traction', label: 'Gearless Traction' }
  ];

  const bmsTypeOptions = [
    { id: 'centralized', label: 'Centralized' },
    { id: 'distributed', label: 'Distributed' },
    { id: 'hybrid', label: 'Hybrid' },
    { id: 'cloud_based', label: 'Cloud-Based' }
  ];

  const acousticRatingOptions = [
    { id: 'stc', label: 'STC' },
    { id: 'nrc', label: 'NRC' }
  ];

  // Tools attribute mapped values
  const toolTypeOptions = [
    { id: 'drill', label: 'Drill' },
    { id: 'saw', label: 'Saw' },
    { id: 'grinder', label: 'Grinder' },
    { id: 'sander', label: 'Sander' },
    { id: 'wrench', label: 'Wrench' },
    { id: 'hammer', label: 'Hammer' },
    { id: 'screwdriver', label: 'Screwdriver' },
    { id: 'pliers', label: 'Pliers' }
  ];

  const toolMaterialOptions = [
    { id: 'steel', label: 'Steel' },
    { id: 'aluminum', label: 'Aluminum' },
    { id: 'titanium', label: 'Titanium' },
    { id: 'carbon_steel', label: 'Carbon Steel' },
    { id: 'stainless_steel', label: 'Stainless Steel' },
    { id: 'chrome_vanadium', label: 'Chrome Vanadium' }
  ];

  const handleMaterialOptions = [
    { id: 'rubber', label: 'Rubber' },
    { id: 'plastic', label: 'Plastic' },
    { id: 'wood', label: 'Wood' },
    { id: 'metal', label: 'Metal' },
    { id: 'fiberglass', label: 'Fiberglass' }
  ];

  const toolGradeOptions = [
    { id: 'grade_1', label: 'Grade 1' },
    { id: 'grade_2', label: 'Grade 2' },
    { id: 'grade_3', label: 'Grade 3' },
    { id: 'premium', label: 'Premium' },
    { id: 'professional', label: 'Professional' },
    { id: 'commercial', label: 'Commercial' }
  ];

  const surfaceFinishOptions = [
    { id: 'polished', label: 'Polished' },
    { id: 'brushed', label: 'Brushed' },
    { id: 'matte', label: 'Matte' },
    { id: 'chrome', label: 'Chrome' },
    { id: 'anodized', label: 'Anodized' }
  ];

  const toolStandardsOptions = [
    { id: 'iso', label: 'ISO' },
    { id: 'astm', label: 'ASTM' },
    { id: 'din', label: 'DIN' },
    { id: 'ansi', label: 'ANSI' },
    { id: 'bs', label: 'BS' }
  ];

  const safetyFeaturesOptions = [
    { id: 'safety_lock', label: 'Safety Lock' },
    { id: 'overload_protection', label: 'Overload Protection' },
    { id: 'electric_brake', label: 'Electric Brake' },
    { id: 'soft_start', label: 'Soft Start' },
    { id: 'dust_collection', label: 'Dust Collection' }
  ];

  const powerSourceOptions = [
    { id: 'electric', label: 'Electric' },
    { id: 'battery', label: 'Battery' },
    { id: 'pneumatic', label: 'Pneumatic' },
    { id: 'hydraulic', label: 'Hydraulic' },
    { id: 'gas', label: 'Gas' },
    { id: 'manual', label: 'Manual' }
  ];

  const toolMotorTypeOptions = [
    { id: 'brushless', label: 'Brushless' },
    { id: 'brushed', label: 'Brushed' },
    { id: 'dc', label: 'DC Motor' },
    { id: 'ac', label: 'AC Motor' },
    { id: 'universal', label: 'Universal Motor' }
  ];

  const toolBatteryTypeOptions = [
    { id: 'lithium_ion', label: 'Lithium-Ion' },
    { id: 'lithium_polymer', label: 'Lithium Polymer' },
    { id: 'nickel_cadmium', label: 'Nickel Cadmium' },
    { id: 'nickel_metal_hydride', label: 'Nickel Metal Hydride' }
  ];

  const bladeTipTypeOptions = [
    { id: 'tungsten_carbide', label: 'Tungsten Carbide' },
    { id: 'high_speed_steel', label: 'High Speed Steel' },
    { id: 'diamond', label: 'Diamond' },
    { id: 'ceramic', label: 'Ceramic' },
    { id: 'carbide_tipped', label: 'Carbide Tipped' }
  ];

  // Agricultural Products attribute mapped values
  const varietyOptions = [
    { id: 'wheat', label: 'Wheat' },
    { id: 'rice', label: 'Rice' },
    { id: 'corn', label: 'Corn' },
    { id: 'barley', label: 'Barley' },
    { id: 'oats', label: 'Oats' },
    { id: 'sorghum', label: 'Sorghum' }
  ];

  const productTypeOptions = [
    { id: 'cereal', label: 'Cereal' },
    { id: 'grain', label: 'Grain' },
    { id: 'seed', label: 'Seed' },
    { id: 'pulse', label: 'Pulse' },
    { id: 'oilseed', label: 'Oilseed' },
    { id: 'feed', label: 'Feed' }
  ];

  const agriTypeOptions = [
    { id: 'organic', label: 'Organic' },
    { id: 'conventional', label: 'Conventional' },
    { id: 'non_gmo', label: 'Non-GMO' },
    { id: 'hybrid', label: 'Hybrid' }
  ];

  const agriGradeOptions = [
    { id: 'premium', label: 'Premium' },
    { id: 'grade_a', label: 'Grade A' },
    { id: 'grade_b', label: 'Grade B' },
    { id: 'commercial', label: 'Commercial' },
    { id: 'feed_grade', label: 'Feed Grade' }
  ];

  const keyMachineOptions = [
    { id: 'harvester', label: 'Harvester' },
    { id: 'thresher', label: 'Thresher' },
    { id: 'winnower', label: 'Winnower' },
    { id: 'dehuller', label: 'Dehuller' },
    { id: 'miller', label: 'Miller' }
  ];

  const featureOptions = [
    { id: 'gluten_free', label: 'Gluten Free' },
    { id: 'high_fiber', label: 'High Fiber' },
    { id: 'high_protein', label: 'High Protein' },
    { id: 'vitamin_enriched', label: 'Vitamin Enriched' },
    { id: 'mineral_enriched', label: 'Mineral Enriched' }
  ];

  const agriApplicationOptions = [
    { id: 'food', label: 'Food' },
    { id: 'feed', label: 'Feed' },
    { id: 'biofuel', label: 'Biofuel' },
    { id: 'industrial', label: 'Industrial' },
    { id: 'pharmaceutical', label: 'Pharmaceutical' }
  ];

  const activeIngredientsOptions = [
    { id: 'protein', label: 'Protein' },
    { id: 'carbohydrates', label: 'Carbohydrates' },
    { id: 'fiber', label: 'Fiber' },
    { id: 'vitamins', label: 'Vitamins' },
    { id: 'minerals', label: 'Minerals' }
  ];

  const agriShapeOptions = [
    { id: 'round', label: 'Round' },
    { id: 'oval', label: 'Oval' },
    { id: 'elongated', label: 'Elongated' },
    { id: 'irregular', label: 'Irregular' }
  ];

  const grainSizeUnitOptions = [
    { id: 'mm', label: 'mm' },
    { id: 'cm', label: 'cm' },
    { id: 'inch', label: 'inch' }
  ];

  const cultivationTypeOptions = [
    { id: 'field', label: 'Field' },
    { id: 'greenhouse', label: 'Greenhouse' },
    { id: 'hydroponic', label: 'Hydroponic' },
    { id: 'organic_farming', label: 'Organic Farming' }
  ];

  const processingTypeOptions = [
    { id: 'cleaning', label: 'Cleaning' },
    { id: 'sorting', label: 'Sorting' },
    { id: 'drying', label: 'Drying' },
    { id: 'milling', label: 'Milling' },
    { id: 'polishing', label: 'Polishing' }
  ];

  const preservationProcessOptions = [
    { id: 'sun_drying', label: 'Sun Drying' },
    { id: 'mechanical_drying', label: 'Mechanical Drying' },
    { id: 'irradiation', label: 'Irradiation' },
    { id: 'fumigation', label: 'Fumigation' },
    { id: 'cold_storage', label: 'Cold Storage' }
  ];

  const extractionTypeOptions = [
    { id: 'mechanical', label: 'Mechanical' },
    { id: 'solvent', label: 'Solvent' },
    { id: 'cold_press', label: 'Cold Press' },
    { id: 'steam', label: 'Steam' }
  ];

  const agriStyleOptions = [
    { id: 'whole', label: 'Whole' },
    { id: 'broken', label: 'Broken' },
    { id: 'powdered', label: 'Powdered' },
    { id: 'flaked', label: 'Flaked' }
  ];

  const agriPackagingOptions = [
    { id: 'sack', label: 'Sack' },
    { id: 'bag', label: 'Bag' },
    { id: 'bulk', label: 'Bulk' },
    { id: 'container', label: 'Container' },
    { id: 'pallet', label: 'Pallet' }
  ];

  const agriShelfLifeUnitOptions = [
    { id: 'days', label: 'Days' },
    { id: 'months', label: 'Months' },
    { id: 'years', label: 'Years' }
  ];

  const warrantyUnitOptions = [
    { id: 'months', label: 'Months' },
    { id: 'years', label: 'Years' }
  ];

  // Health & Medical attribute mapped values
  const brakeTypeOptions = [
    { id: 'hand_brake', label: 'Hand Brake' },
    { id: 'push_to_lock', label: 'Push to Lock' },
    { id: 'lever_brake', label: 'Lever Brake' },
    { id: 'disc_brake', label: 'Disc Brake' }
  ];

  const frameMaterialOptions = [
    { id: 'aluminum', label: 'Aluminum' },
    { id: 'steel', label: 'Steel' },
    { id: 'titanium', label: 'Titanium' },
    { id: 'carbon_fiber', label: 'Carbon Fiber' }
  ];

  const foldableOptions = [
    { id: 'yes', label: 'Yes' },
    { id: 'no', label: 'No' }
  ];

  const hmPowerUnitOptions = [
    { id: 'watt', label: 'Watt' },
    { id: 'volt', label: 'Volt' },
    { id: 'amp', label: 'Amp' }
  ];

  const regulatoryApprovalsOptions = [
    { id: 'fda', label: 'FDA' },
    { id: 'ce', label: 'CE' },
    { id: 'iso', label: 'ISO' },
    { id: 'who', label: 'WHO' }
  ];

  const sterilityStatusOptions = [
    { id: 'sterile', label: 'Sterile' },
    { id: 'non_sterile', label: 'Non-Sterile' },
    { id: 'single_use', label: 'Single Use' }
  ];

  const accessoriesIncludedOptions = [
    { id: 'yes', label: 'Yes' },
    { id: 'no', label: 'No' }
  ];

  const sparesAvailabilityOptions = [
    { id: 'available', label: 'Available' },
    { id: 'not_available', label: 'Not Available' },
    { id: 'limited', label: 'Limited' }
  ];

  const safetyStandardsOptions = [
    { id: 'iso_13485', label: 'ISO 13485' },
    { id: 'iso_14971', label: 'ISO 14971' },
    { id: 'iec_60601', label: 'IEC 60601' }
  ];

  const standardsComplianceOptions = [
    { id: 'fda_approved', label: 'FDA Approved' },
    { id: 'ce_marked', label: 'CE Marked' },
    { id: 'iso_certified', label: 'ISO Certified' }
  ];

  const deviceClassOptions = [
    { id: 'class_i', label: 'Class I' },
    { id: 'class_ii', label: 'Class II' },
    { id: 'class_ii_special', label: 'Class II Special' },
    { id: 'class_iii', label: 'Class III' }
  ];

  const maskTypeOptions = [
    { id: 'n95', label: 'N95' },
    { id: 'surgical', label: 'Surgical' },
    { id: 'kn95', label: 'KN95' },
    { id: 'ffp2', label: 'FFP2' },
    { id: 'ffp3', label: 'FFP3' }
  ];

  const valveOptions = [
    { id: 'with_valve', label: 'With Valve' },
    { id: 'without_valve', label: 'Without Valve' }
  ];

  const gloveMaterialOptions = [
    { id: 'nitrile', label: 'Nitrile' },
    { id: 'latex', label: 'Latex' },
    { id: 'vinyl', label: 'Vinyl' },
    { id: 'neoprene', label: 'Neoprene' }
  ];

  const hmFitTypeOptions = [
    { id: 'regular', label: 'Regular' },
    { id: 'small', label: 'Small' },
    { id: 'large', label: 'Large' },
    { id: 'extra_large', label: 'Extra Large' }
  ];

  const complianceStandardOptions = [
    { id: 'astm_f2100', label: 'ASTM F2100' },
    { id: 'en_149', label: 'EN 149' },
    { id: 'niosh', label: 'NIOSH' }
  ];

  const testMethodOptions = [
    { id: 'pcr', label: 'PCR' },
    { id: 'rapid_test', label: 'Rapid Test' },
    { id: 'elisa', label: 'ELISA' },
    { id: 'molecular', label: 'Molecular' }
  ];

  const controlsIncludedOptions = [
    { id: 'yes', label: 'Yes' },
    { id: 'no', label: 'No' }
  ];

  const wasteDisposalClassOptions = [
    { id: 'class_a', label: 'Class A' },
    { id: 'class_b', label: 'Class B' },
    { id: 'biohazard', label: 'Biohazard' }
  ];

  const sampleTypeOptions = [
    { id: 'blood', label: 'Blood' },
    { id: 'urine', label: 'Urine' },
    { id: 'saliva', label: 'Saliva' },
    { id: 'nasal_swab', label: 'Nasal Swab' }
  ];

  const dosageFormOptions = [
    { id: 'tablet', label: 'Tablet' },
    { id: 'capsule', label: 'Capsule' },
    { id: 'syrup', label: 'Syrup' },
    { id: 'injection', label: 'Injection' }
  ];

  const prescriptionTypeOptions = [
    { id: 'prescription', label: 'Prescription' },
    { id: 'otc', label: 'OTC' },
    { id: 'both', label: 'Both' }
  ];

  const routeOfAdministrationOptions = [
    { id: 'iv', label: 'IV' },
    { id: 'im', label: 'IM' },
    { id: 'sc', label: 'SC' },
    { id: 'intramuscular', label: 'Intramuscular' }
  ];

  const diluentRequiredOptions = [
    { id: 'yes', label: 'Yes' },
    { id: 'no', label: 'No' }
  ];

  // Luggage Bags & Cases attribute mapped values
  // All options are now fetched from API and JSON via useLuggageAttribute hook

  // Which rows are visible for each customization type
  // Map customization type IDs/labels to visible row IDs
  const getCustomizationVisibleRows = (customizationTypeValue) => {
    if (!customizationTypeValue) return [];
    
    // Find the customization type option to get its label
    const customizationOption = customizationTypesOptions.find(opt => 
      String(opt.value) === String(customizationTypeValue) || 
      String(opt.label) === String(customizationTypeValue)
    );
    
    const customizationLabel = customizationOption?.label?.toLowerCase() || String(customizationTypeValue).toLowerCase();
    
    // Map labels to row IDs
    const customizationVisibilityMap = {
      'minor customization': ['logo', 'color', 'labels'],
      'minor': ['logo', 'color', 'labels'],
      'drawing': ['sketch', 'color'],
      'sample-based': ['sample_based'],
      'sample based': ['sample_based'],
      'sample': ['sample_based'],
      'full customization': ['logo', 'color', 'labels', 'packing', 'graphic'],
      'full': ['logo', 'color', 'labels', 'packing', 'graphic']
    };
    
    // Try to find matching key (case-insensitive)
    const matchingKey = Object.keys(customizationVisibilityMap).find(key => 
      customizationLabel.includes(key.toLowerCase()) || key.toLowerCase() === customizationLabel
    );
    
    return matchingKey ? customizationVisibilityMap[matchingKey] : [];
  };

  const toggleCustomizationRow = (rowId) => {
    setCustomizationRows((rows) => rows.map(r => r.id === rowId ? { ...r, enabled: !r.enabled } : r));
  };

  const updateCustomizationField = (rowId, field, value) => {
    setCustomizationRows((rows) => rows.map(r => {
      if (r.id === rowId) {
        const updated = { ...r, [field]: value };
        // Auto-calculate priceWithTax when priceNoTax or tax changes
        if (field === 'priceNoTax' || field === 'tax') {
          const priceNoTax = field === 'priceNoTax' ? parseFloat(value) : parseFloat(r.priceNoTax);
          const tax = field === 'tax' ? parseFloat(value) : parseFloat(r.tax);
          if (!isNaN(priceNoTax) && !isNaN(tax) && priceNoTax > 0 && tax >= 0) {
            updated.priceWithTax = (priceNoTax * (1 + tax / 100)).toFixed(2);
          } else {
            updated.priceWithTax = '';
          }
        }
        return updated;
      }
      return r;
    }));
  };

  const renderCustomizationInput = (row, field, forceNonEditable = false) => {
    const isEditable = row.enabled && !forceNonEditable;
    // priceWithTax is always read-only (auto-calculated)
    const isReadOnly = field === 'priceWithTax';
    
    if (!isEditable || isReadOnly) {
      const displayValue = isReadOnly && row.enabled ? (row[field] || '') : '-';
      return <input className="input-pill input-center" value={displayValue} readOnly disabled={!isEditable} style={isReadOnly && row.enabled ? { backgroundColor: '#f5f5f5', cursor: 'not-allowed' } : {}} />;
    }
    return <input className="input-pill" placeholder="" value={row[field]} onChange={(e) => updateCustomizationField(row.id, field, e.target.value)} />;
  };

  const renderDescCell = (row) => {
    if (!row.enabled) return <input className="input-pill input-center" value="-" readOnly disabled />;
    return (
      <div className="input-pill upload-pill" onClick={() => { setDescModal({ visible: true, rowId: row.id }); setDescText(row.desc || ''); }}>
        <span className="upload-icon-only" aria-hidden>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="upload-icon"><path d="M12 3v12"></path><path d="m17 8-5-5-5 5"></path><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path></svg>
        </span>
      </div>
    );
  };

  // Packing material to packing type mapping
  const packingTypeMap = {
    'cardboard': ['standard', 'export', 'retail', 'custom'],
    'plastic': ['standard', 'export', 'bulk', 'retail', 'custom'],
    'wood': ['export', 'bulk', 'custom'],
    'metal': ['export', 'bulk', 'custom'],
    'fabric': ['standard', 'retail', 'custom'],
    'paper': ['standard', 'retail', 'custom'],
    'foam': ['standard', 'retail', 'custom']
  };

  const getAvailablePackingTypes = (material) => {
    if (!material || !packingTypeMap[material]) {
      return ['standard', 'export', 'bulk', 'retail', 'custom'];
    }
    return packingTypeMap[material];
  };

  const onChange = (e) => {
    const { name, value, type } = e.target;
    if (type === 'select-multiple') {
      const selectedValues = Array.from(e.target.selectedOptions, option => option.value);
      setForm(prev => ({ ...prev, [name]: selectedValues }));
    } else {
      // If packing material changes, reset packing type
      if (name === 'packingMaterials') {
        setForm(prev => ({
          ...prev,
          [name]: value,
          packingType: '' // Reset packing type when material changes
        }));
      } else {
        setForm(prev => ({ ...prev, [name]: value }));
      }
    }
  };

  const addProduct = () => {
    const v = productInput.trim();
    if (!v) return;
    if (!products.includes(v)) setProducts(prev => [...prev, v]);
    setProductInput('');
  };

  const removeProduct = (p) => {
    setProducts(prev => prev.filter(x => x !== p));
  };

  const addKeyword = () => {
    const v = keywordInput.trim();
    if (!v) return;
    if (!keywords.includes(v)) setKeywords(prev => [...prev, v]);
    setKeywordInput('');
  };

  const removeKeyword = (k) => {
    setKeywords(prev => prev.filter(x => x !== k));
  };

  // Bulk Discount Slab functions
  const addBulkDiscountSlab = () => {
    if (bulkDiscountSlabs.length < 3) {
      const newId = Math.max(...bulkDiscountSlabs.map(s => s.id), 0) + 1;
      setBulkDiscountSlabs(prev => [...prev, {
        id: newId,
        bulk_min: '',
        bulk_max: '',
        bulk_uom: '',
        bulk_price_no: '',
        bulk_price_with: '',
        bulk_tax: '',
        bulk_currency: ''
      }]);
    }
  };

  const removeBulkDiscountSlab = (id) => {
    if (bulkDiscountSlabs.length > 1) {
      setBulkDiscountSlabs(prev => prev.filter(slab => slab.id !== id));
    }
  };

  const updateBulkDiscountSlab = (id, field, value) => {
    setBulkDiscountSlabs(prev => prev.map(slab =>
      slab.id === id ? { ...slab, [field]: value } : slab
    ));
  };

  // Colour Options functions
  const addColourOption = () => {
    const newId = Math.max(...colourOptionsList.map(c => c.id), 0) + 1;
    setColourOptionsList(prev => [...prev, { id: newId, color: '#ED00BE', imageUrl: '' }]);
  };

  const removeColourOption = (id) => {
    if (colourOptionsList.length > 1) {
      setColourOptionsList(prev => prev.filter(option => option.id !== id));
    }
  };

  const updateColourOption = (id, field, value) => {
    setColourOptionsList(prev => prev.map(option =>
      option.id === id ? { ...option, [field]: value } : option
    ));
  };

  // Dimensions functions
  const addDimension = () => {
    const newId = Math.max(...dimensionsList.map(d => d.id), 0) + 1;
    setDimensionsList(prev => [...prev, { id: newId, height: '', length: '', width: '', uom: '' }]);
  };

  const removeDimension = (id) => {
    if (dimensionsList.length > 1) {
      setDimensionsList(prev => prev.filter(dim => dim.id !== id));
    }
  };

  const updateDimension = (id, field, value) => {
    setDimensionsList(prev => prev.map(dim =>
      dim.id === id ? { ...dim, [field]: value } : dim
    ));
  };

  // Inventory Details functions
  const addInventoryDetail = () => {
    const newId = Math.max(...inventoryDetailsList.map(i => i.id), 0) + 1;
    setInventoryDetailsList(prev => [...prev, { id: newId, qty: '', uom: '', status: '', location: '' }]);
  };

  const removeInventoryDetail = (id) => {
    if (inventoryDetailsList.length > 1) {
      setInventoryDetailsList(prev => prev.filter(inv => inv.id !== id));
    }
  };

  const updateInventoryDetail = (id, field, value) => {
    setInventoryDetailsList(prev => prev.map(inv =>
      inv.id === id ? { ...inv, [field]: value } : inv
    ));
  };

  // Lead Time functions
  const addLeadTime = () => {
    const newId = Math.max(...leadTimeList.map(l => l.id), 0) + 1;
    setLeadTimeList(prev => [...prev, { id: newId, days: '', min: '', max: '' }]);
  };

  const removeLeadTime = (id) => {
    if (leadTimeList.length > 1) {
      setLeadTimeList(prev => prev.filter(lead => lead.id !== id));
    }
  };

  const updateLeadTime = (id, field, value) => {
    setLeadTimeList(prev => prev.map(lead =>
      lead.id === id ? { ...lead, [field]: value } : lead
    ));
  };

  // FAQ functions
  const addFAQ = () => {
    const newId = Math.max(...faqList.map(f => f.id), 0) + 1;
    setFaqList(prev => [...prev, { id: newId, question: '', answer: '' }]);
  };

  const removeFAQ = (id) => {
    if (faqList.length > 1) {
      setFaqList(prev => prev.filter(faq => faq.id !== id));
    }
  };

  const updateFAQ = (id, field, value) => {
    setFaqList(prev => prev.map(faq =>
      faq.id === id ? { ...faq, [field]: value } : faq
    ));
  };

  // Attributes functions
  const addAttribute = () => {
    const newId = Math.max(...attributesList.map(a => a.id), 0) + 1;
    setAttributesList(prev => [...prev, { id: newId, attribute: '', value: '', unit: '' }]);
  };

  const removeAttribute = (id) => {
    if (attributesList.length > 1) {
      setAttributesList(prev => prev.filter(attr => attr.id !== id));
    }
  };

  const updateAttribute = (id, field, value) => {
    setAttributesList(prev => prev.map(attr =>
      attr.id === id ? { ...attr, [field]: value } : attr
    ));
  };

  // Product Catalogue functions
  const handleAddProduct = () => {
    setProductCatalogueCollapsed(false);
    setEditingProductId(null);
    // Reset form to initial state for new product
    setForm(initialState);
    setKeywords([]);
    setCarouselEnabled(false);
    setCarouselFiles([]);
    setCarouselImageUrls([]);
    // Reset "Add More" lists to default
    setDimensionsList([{ id: 1, height: '', length: '', width: '', uom: '' }]);
    setColourOptionsList([{ id: 1, color: '#ED00BE', imageUrl: '' }]);
    setInventoryDetailsList([{ id: 1, qty: '', uom: '', status: '', location: '' }]);
    setLeadTimeList([{ id: 1, days: '', min: '', max: '' }]);
    setFaqList([{ id: 1, question: '', answer: '' }]);
    setAttributesList([{ id: 1, attribute: '', value: '', unit: '' }]);
    // Reset file upload state
    setProductCatalogueFile(null);
    setProductCatalogueUrl('');
    setProductVideoFile(null);
    setProductVideoUrl('');
    setProductImageFiles([]);
    setProductImageUrls([]);
    // Reset Add More lists
    setColourOptionsList([{ id: 1, color: '#ED00BE', imageUrl: '' }]);
    setDimensionsList([{ id: 1, height: '', length: '', width: '', uom: '' }]);
    setInventoryDetailsList([{ id: 1, qty: '', uom: '', status: '', location: '' }]);
    setLeadTimeList([{ id: 1, days: '', min: '', max: '' }]);
    setFaqList([{ id: 1, question: '', answer: '' }]);
    setAttributesList([{ id: 1, attribute: '', value: '', unit: '' }]);
  };

  const handleSaveProduct = async () => {
    // Validate required fields
    if (!form.pd_name || !form.pd_brand || !form.pd_cat || !form.pd_subcat || !form.pd_subsubcat || !form.pd_desc || keywords.length === 0) {
      toast.error('Please fill in all mandatory fields: Product Name, Brand, Product Category, Product Sub-category, Product Sub-Sub Category, Product Description, and at least one Keyword');
      return;
    }
    // Calculate Price With Tax if not already calculated
    if (form.moq_price_notax && form.moq_tax && !form.moq_price_tax) {
      const priceWithoutTax = parseFloat(form.moq_price_notax) || 0;
      const taxPercent = parseFloat(form.moq_tax) || 0;
      const priceWithTax = (priceWithoutTax * (1 + taxPercent / 100)).toFixed(2);
      setForm(prev => ({ ...prev, moq_price_tax: priceWithTax }));
    }
    if (!form.moq_min || !form.moq_uom || !form.moq_price_notax || !form.moq_tax || !form.moq_currency) {
      toast.error('Please fill in all MOQ fields: Minimum Order Quantity, Unit of Measurements, Price (Without Tax), Tax (%), and Currency');
      return;
    }

    // Save to backend first
    await saveProductDetails();
    
    // Note: saveProductDetails now handles updating savedProducts state
    // The form reset is handled in saveProductDetails after successful save
  };

  // Helper function to map status value to match inventoryStatusOptions format
  // Map customization type from backend format (enum string like 'LOGO') to frontend option value (ID)

  const mapStatusForEdit = (statusValue) => {
    if (!statusValue) return '';
    
    // First, try to find in inventoryStatusOptions if available
    if (inventoryStatusOptions && Array.isArray(inventoryStatusOptions) && inventoryStatusOptions.length > 0) {
      const trimmedStatus = typeof statusValue === 'string' ? statusValue.trim() : String(statusValue).trim();
      
      // Debug: Log what we're trying to match
      console.log('mapStatusForEdit called:', {
        original_status: statusValue,
        trimmed_status: trimmedStatus,
        options_count: inventoryStatusOptions.length,
        options_preview: inventoryStatusOptions.slice(0, 2).map(opt => ({ value: opt.value, label: opt.label }))
      });
      
      // Map enum strings to label formats for matching
      // Based on actual API options: "In Stock", "Out of Stock", "Backorder", "Discontinued"
      // Note: LOW_STOCK maps to "Backorder" since it's not a separate option
      const enumToLabelMap = {
        'IN_STOCK': ['In Stock', 'IN STOCK', 'in stock', 'In-Stock'],
        'OUT_OF_STOCK': ['Out of Stock', 'OUT OF STOCK', 'out of stock', 'Out-of-Stock'],
        'LOW_STOCK': ['Backorder', 'BACKORDER', 'backorder'], // LOW_STOCK maps to Backorder
        'DISCONTINUED': ['Discontinued', 'DISCONTINUED', 'discontinued'],
        'BACKORDER': ['Backorder', 'BACKORDER', 'backorder']
      };
      
      // Map enum to the actual option label (for direct matching)
      const enumToOptionLabel = {
        'IN_STOCK': 'In Stock',
        'OUT_OF_STOCK': 'Out of Stock',
        'LOW_STOCK': 'Backorder', // LOW_STOCK should map to Backorder option
        'DISCONTINUED': 'Discontinued',
        'BACKORDER': 'Backorder'
      };
      
      // First, try to find by value (handles both number IDs and string enums)
      // Also check if the option value is the enum string itself (some APIs return enum as value)
      let foundOption = inventoryStatusOptions.find(opt => {
        const optValue = opt.value;
        const optValueStr = String(optValue || '').trim().toUpperCase();
        const statusUpper = trimmedStatus.toUpperCase();
        
        return optValue === statusValue || 
               String(optValue) === String(statusValue) ||
               Number(optValue) === Number(statusValue) ||
               optValueStr === statusUpper; // Match enum strings case-insensitively
      });
      
      // If not found by value, try by label (exact match)
      if (!foundOption && typeof statusValue === 'string') {
        foundOption = inventoryStatusOptions.find(opt => 
          opt.label === trimmedStatus || 
          String(opt.label).toLowerCase().trim() === trimmedStatus.toLowerCase() ||
          String(opt.label).trim() === trimmedStatus
        );
      }
      
      // If still not found and it's an enum string (like "OUT_OF_STOCK"), try to match by label variations
      if (!foundOption && typeof statusValue === 'string') {
        const upperStatus = trimmedStatus.toUpperCase();
        
        // Check if it's an enum format (contains underscore)
        if (upperStatus.includes('_')) {
          // First, try direct mapping to option label (e.g., LOW_STOCK -> "Backorder")
          const mappedLabel = enumToOptionLabel[upperStatus];
          if (mappedLabel) {
            foundOption = inventoryStatusOptions.find(opt => {
              const optLabel = String(opt.label || '').trim();
              return optLabel === mappedLabel || optLabel.toLowerCase() === mappedLabel.toLowerCase();
            });
          }
          
          // If direct mapping didn't work, try label variations
          if (!foundOption) {
            // Get possible label variations for this enum
            const possibleLabels = enumToLabelMap[upperStatus] || [];
            
            // Try to find option by matching label variations
            for (const label of possibleLabels) {
              foundOption = inventoryStatusOptions.find(opt => {
                const optLabel = String(opt.label || '').trim();
                const normalizedOptLabel = optLabel.toLowerCase().replace(/[-\s_]/g, ' ').trim();
                const normalizedSearchLabel = label.toLowerCase().replace(/[-\s_]/g, ' ').trim();
                
                return optLabel === label || 
                       optLabel.toLowerCase() === label.toLowerCase() ||
                       normalizedOptLabel === normalizedSearchLabel ||
                       optLabel.toLowerCase().includes(label.toLowerCase()) ||
                       label.toLowerCase().includes(optLabel.toLowerCase());
              });
              if (foundOption) break;
            }
          }
        } else {
          // Not an enum format, try reverse mapping: convert label-like strings to enum and find
          const labelToEnumMap = {
            'in stock': 'IN_STOCK',
            'out of stock': 'OUT_OF_STOCK',
            'low stock': 'LOW_STOCK',
            'discontinued': 'DISCONTINUED'
          };
          
          const normalizedStatus = trimmedStatus.toLowerCase().replace(/[-\s_]/g, ' ').trim();
          const enumEquivalent = labelToEnumMap[normalizedStatus];
          
          if (enumEquivalent && enumToLabelMap[enumEquivalent]) {
            // Try to find option using the label variations
            for (const label of enumToLabelMap[enumEquivalent]) {
              foundOption = inventoryStatusOptions.find(opt => {
                const optLabel = String(opt.label || '').trim();
                const normalizedOptLabel = optLabel.toLowerCase().replace(/[-\s_]/g, ' ').trim();
                const normalizedSearchLabel = label.toLowerCase().replace(/[-\s_]/g, ' ').trim();
                
                return optLabel === label || 
                       optLabel.toLowerCase() === label.toLowerCase() ||
                       normalizedOptLabel === normalizedSearchLabel ||
                       optLabel.toLowerCase().includes(label.toLowerCase()) ||
                       label.toLowerCase().includes(optLabel.toLowerCase());
              });
              if (foundOption) break;
            }
          }
        }
      }
      
      if (foundOption && foundOption.value !== undefined) {
        // Use the option value to ensure it matches the dropdown format
        console.log('Status mapped successfully:', {
          original: statusValue,
          mapped_value: foundOption.value,
          option_label: foundOption.label
        });
        return foundOption.value;
      } else {
        // Last resort: try multiple matching strategies
        if (typeof statusValue === 'string' && trimmedStatus.includes('_')) {
          const upperStatus = trimmedStatus.toUpperCase();
          
          // Strategy 1: Use direct enum to option label mapping (LOW_STOCK -> "Backorder")
          const mappedLabel = enumToOptionLabel[upperStatus];
          if (mappedLabel) {
            foundOption = inventoryStatusOptions.find(opt => {
              const optLabel = String(opt.label || '').trim();
              return optLabel === mappedLabel || optLabel.toLowerCase() === mappedLabel.toLowerCase();
            });
            
            if (foundOption && foundOption.value !== undefined) {
              console.log('Status mapped by direct enum-to-label mapping:', {
                original: statusValue,
                enum: upperStatus,
                mapped_label: mappedLabel,
                mapped_value: foundOption.value,
                option_label: foundOption.label
              });
              return foundOption.value;
            }
          }
          
          // Strategy 2: Try to find option by converting its label to enum format and comparing
          foundOption = inventoryStatusOptions.find(opt => {
            if (!opt.label) return false;
            const optLabel = String(opt.label).trim();
            // Convert label to enum format (e.g., "Out of Stock" -> "OUT_OF_STOCK")
            const labelAsEnum = optLabel
              .toUpperCase()
              .replace(/[^A-Z0-9\s_-]/g, '')
              .replace(/[\s-]+/g, '_')
              .replace(/_+/g, '_')
              .replace(/^_|_$/g, '');
            
            return labelAsEnum === upperStatus;
          });
          
          // Strategy 3: Try matching by checking if option value is the enum string
          if (!foundOption) {
            foundOption = inventoryStatusOptions.find(opt => {
              const optValue = String(opt.value || '').trim().toUpperCase();
              return optValue === upperStatus;
            });
          }
          
          if (foundOption && foundOption.value !== undefined) {
            console.log('Status mapped by fallback matching:', {
              original: statusValue,
              mapped_value: foundOption.value,
              option_label: foundOption.label,
              matching_strategy: 'enum_conversion_or_partial_match'
            });
            return foundOption.value;
          }
        }
        
        // If still not found, log for debugging with all available options
        const optionsDebug = inventoryStatusOptions.map(opt => {
          const optLabel = String(opt.label || '').trim();
          const optValue = String(opt.value || '').trim();
          const labelAsEnum = optLabel
            .toUpperCase()
            .replace(/[^A-Z0-9\s_-]/g, '')
            .replace(/[\s-]+/g, '_')
            .replace(/_+/g, '_')
            .replace(/^_|_$/g, '');
          const valueAsEnum = optValue
            .toUpperCase()
            .replace(/[^A-Z0-9\s_-]/g, '')
            .replace(/[\s-]+/g, '_')
            .replace(/_+/g, '_')
            .replace(/^_|_$/g, '');
          const targetUpper = trimmedStatus.toUpperCase();
          return { 
            value: opt.value, 
            value_type: typeof opt.value,
            value_string: optValue,
            label: opt.label,
            label_as_enum: labelAsEnum,
            value_as_enum: valueAsEnum,
            label_matches: labelAsEnum === targetUpper,
            value_matches: valueAsEnum === targetUpper,
            exact_value_match: optValue.toUpperCase() === targetUpper
          };
        });
        
        console.warn('Status not found in options after all attempts:', {
          original: statusValue,
          trimmed: trimmedStatus,
          target_enum: trimmedStatus.toUpperCase(),
          is_enum_format: typeof statusValue === 'string' && trimmedStatus.includes('_'),
          available_options: optionsDebug,
          options_summary: optionsDebug.map(opt => `${opt.label} (value: ${opt.value}, type: ${opt.value_type})`).join(', ')
        });
        
        // Last resort: If it's a valid enum but not in options, try to find the closest match
        // or return the enum string itself (the backend might accept it)
        const validEnums = ['IN_STOCK', 'OUT_OF_STOCK', 'LOW_STOCK', 'DISCONTINUED'];
        if (validEnums.includes(trimmedStatus.toUpperCase())) {
          console.warn('Status is a valid enum but not found in options. Returning enum string as-is:', trimmedStatus);
          // Return the enum string - the backend validation should handle it
          return trimmedStatus;
        }
        
        return trimmedStatus;
      }
    } else {
      // Options not available yet, just ensure it's a string
      return typeof statusValue === 'string' ? statusValue.trim() : String(statusValue).trim();
    }
  };

  const handleEditProduct = (product) => {
    console.log('Editing product (full object):', JSON.stringify(product, null, 2));
    setEditingProductId(product.id);
    
    // Extract values with fallbacks - check multiple possible field names
    // Prioritize non-empty values and trim strings
    // Check if value exists and is not empty (handle both undefined and empty string)
    const getProductName = () => {
      if (product.pd_name && typeof product.pd_name === 'string' && product.pd_name.trim()) {
        return product.pd_name.trim();
      }
      if (product.name && typeof product.name === 'string' && product.name.trim()) {
        return product.name.trim();
      }
      // Check all possible variations
      if (product.product_name && typeof product.product_name === 'string' && product.product_name.trim()) {
        return product.product_name.trim();
      }
      return '';
    };
    
    const getProductCategory = () => {
      // First, try direct category fields
      if (product.pd_cat && String(product.pd_cat).trim()) {
        return String(product.pd_cat).trim();
      }
      if (product.category_id) {
        return String(product.category_id);
      }
      if (product.category_map) {
        return String(product.category_map);
      }
      
      // If category is missing but subcategory exists, try to find the parent category
      const subcategoryId = product.pd_subcat || product.subcategory_id;
      if (subcategoryId) {
        // First, try to find in hookSubCategories (if loaded) - they might have category_id field
        if (hookSubCategories && hookSubCategories.length > 0) {
          const foundSub = hookSubCategories.find(sub => String(sub.id) === String(subcategoryId));
          if (foundSub && foundSub.category_id) {
            console.log('Found category from hookSubCategories:', { categoryId: foundSub.category_id, subcategoryId: subcategoryId });
            return String(foundSub.category_id);
          }
        }
        
        // Fallback: Search through categoryData to find which category contains this subcategory
        if (categoryData && categoryData.length > 0) {
          for (const cat of categoryData) {
            if (cat.subs && Array.isArray(cat.subs)) {
              const foundSub = cat.subs.find(sub => String(sub.id) === String(subcategoryId));
              if (foundSub) {
                console.log('Found category from categoryData:', { categoryId: cat.id, subcategoryId: subcategoryId });
                return String(cat.id);
              }
            }
          }
        }
      }
      
      return '';
    };
    
    const getProductSubCategory = () => {
      if (product.pd_subcat && String(product.pd_subcat).trim()) {
        return String(product.pd_subcat).trim();
      }
      if (product.subcategory_id) {
        return String(product.subcategory_id);
      }
      if (product.subcategory_map) {
        return String(product.subcategory_map);
      }
      return '';
    };
    
    const getProductSubSubCategory = () => {
      if (product.pd_subsubcat && String(product.pd_subsubcat).trim()) {
        return String(product.pd_subsubcat).trim();
      }
      if (product.sub_subcategory_id) {
        return String(product.sub_subcategory_id);
      }
      return '';
    };
    
    const productName = getProductName();
    const productCategory = getProductCategory();
    const productSubCategory = getProductSubCategory();
    const productSubSubCategory = getProductSubSubCategory();
    const customizationTypesFromProduct = normalizeCustomizationTypes(product.customization_types);
    const customizationDetailsFromProduct = normalizeCustomizationDetails(product.customization_details);
    const customizationAvailable = normalizeCustomizationAvailable(
      product.pd_custom_available ?? product.customization_available,
    );
    const customizationTypeForEdit = mapCustomizationTypeForEditValue(
      customizationTypesFromProduct[0] || product.pd_custom_type || '',
      customizationTypesOptions,
    );
    
    console.log('Extracted product fields:', { 
      productName, 
      productCategory, 
      productSubCategory, 
      productSubSubCategory,
      'product.pd_name': product.pd_name,
      'product.name': product.name,
      'product.product_name': product.product_name,
      'product.pd_cat': product.pd_cat,
      'product.category_id': product.category_id,
      'product.pd_subcat': product.pd_subcat,
      'product.subcategory_id': product.subcategory_id
    });
    
    // Map all product fields to form, ensuring arrays and nested objects are handled correctly
    // IMPORTANT: Set explicit fields AFTER spreading product to ensure they override
    const formData = {
      ...initialState,
      ...product,
      // Explicitly set product name, category, and subcategory to ensure they're populated (after spreading product)
      pd_name: productName,
      pd_cat: productCategory ? String(productCategory) : '',
      pd_subcat: productSubCategory ? String(productSubCategory) : '',
      pd_subsubcat: productSubSubCategory ? String(productSubSubCategory) : '',
      // Ensure keywords, carouselEnabled, and carouselFiles are excluded from form (handled separately)
      keywords: undefined,
      carouselEnabled: undefined,
      carouselFiles: undefined,
      // Ensure arrays are properly handled
      productImages: Array.isArray(product.pd_images_paths) ? product.pd_images_paths : [],
      // Ensure bulk discount slabs are properly set
      bulkDiscountSlabs: Array.isArray(product.bulkDiscountSlabs) && product.bulkDiscountSlabs.length > 0
        ? product.bulkDiscountSlabs
        : bulkDiscountSlabs,
      // Ensure price negotiable above tier 3 is properly set
      isPriceNegotiableAboveTier3: product.isPriceNegotiableAboveTier3 !== undefined 
        ? product.isPriceNegotiableAboveTier3 
        : (product.is_price_negotiable_above_tier3 !== undefined ? product.is_price_negotiable_above_tier3 : false),
      // Category-specific attributes - extract from nested attributes object (if not already in product)
      // Electronics attributes
      elec_power: product.elec_power || product.attributes?.electronics?.power || '',
      elec_current: product.elec_current || product.attributes?.electronics?.current || '',
      elec_frequency: product.elec_frequency || product.attributes?.electronics?.frequency || '',
      elec_battery: product.elec_battery || product.attributes?.electronics?.battery_capacity || '',
      elec_charging: product.elec_charging || product.attributes?.electronics?.charging_time || '',
      elec_connectivity: product.elec_connectivity || product.attributes?.electronics?.connectivity || '',
      elec_warranty: product.elec_warranty || product.attributes?.electronics?.warranty || '',
      elec_country: product.elec_country || product.attributes?.electronics?.country_of_origin || '',
      elec_compliance: product.elec_compliance || product.attributes?.electronics?.compliance_certificate || '',
      // Shoes attributes
      shoes_size_system: product.shoes_size_system || product.attributes?.shoes?.size_system || '',
      shoes_size: product.shoes_size || product.attributes?.shoes?.size || '',
      shoes_upper_material: product.shoes_upper_material || product.attributes?.shoes?.upper_material || '',
      shoes_insole_type: product.shoes_insole_type || product.attributes?.shoes?.insole_type || '',
      shoes_waterproof: product.shoes_waterproof || product.attributes?.shoes?.waterproof || '',
      shoes_safety_toe: product.shoes_safety_toe || product.attributes?.shoes?.safety_toe || '',
      shoes_arch_support: product.shoes_arch_support ?? product.attributes?.shoes?.arch_support ?? false,
      shoes_esd_compliance: product.shoes_esd_compliance ?? product.attributes?.shoes?.esd_compliance ?? false,
      // Tools attributes
      tool_type: product.tool_type || product.attributes?.tools?.type || '',
      tool_material: product.tool_material || product.attributes?.tools?.material || '',
      tool_handle_material: product.tool_handle_material || product.attributes?.tools?.handle_material || '',
      tool_grade: product.tool_grade || product.attributes?.tools?.grade || '',
      tool_power_source: product.tool_power_source || product.attributes?.tools?.power_source || '',
      tool_voltage: product.tool_voltage || product.attributes?.tools?.voltage || '',
      tool_rated_power: product.tool_rated_power || product.attributes?.tools?.rated_power || '',
      tool_torque: product.tool_torque || product.attributes?.tools?.torque || '',
      // Agricultural attributes
      agri_variety: product.agri_variety || product.attributes?.agricultural?.variety || '',
      agri_product_type: product.agri_product_type || product.attributes?.agricultural?.product_type || '',
      agri_grade: product.agri_grade || product.attributes?.agricultural?.grade || '',
      agri_feature: product.agri_feature || product.attributes?.agricultural?.features || '',
      agri_packaging: product.agri_packaging || product.attributes?.agricultural?.packaging || '',
      pd_custom_available: customizationAvailable,
      pd_custom_type: customizationTypeForEdit,
    };
    
    console.log('Final form data before setForm:', { 
      pd_name: formData.pd_name, 
      pd_cat: formData.pd_cat, 
      pd_subcat: formData.pd_subcat,
      pd_subsubcat: formData.pd_subsubcat,
      pd_custom_available: formData.pd_custom_available,
      pd_custom_type: formData.pd_custom_type,
      customization_details: customizationDetailsFromProduct,
      'formData keys': Object.keys(formData),
      'formData.pd_name type': typeof formData.pd_name,
      'formData.pd_name value': formData.pd_name
    });
    
    setForm(formData);
    setCustomizationRows(
      hydrateCustomizationRowsFromDetails(customizationDetailsFromProduct, DEFAULT_CUSTOMIZATION_ROWS),
    );
    
    // After setting form values, trigger subcategory loading if category is set
    // This ensures subcategories are loaded when editing a product
    if (productCategory) {
      // Use setTimeout to ensure form state is updated first
      setTimeout(() => {
        fetchSubCategories(productCategory);
      }, 0);
    }
    
    // Trigger sub-subcategory loading if subcategory is set
    if (productSubCategory) {
      setTimeout(() => {
        fetchSubSubCategories(productSubCategory);
      }, 100); // Slightly longer delay to ensure subcategories are loaded first
    }
    
    // Fetch packing types if packing materials are set (needed for packing type dropdown)
    // Extract packing materials from packaging_details or formData
    const packingMaterialsValue = (() => {
      // First check packaging_details (from backend)
      const materials = product.packaging_details?.packing_materials;
      if (Array.isArray(materials) && materials.length > 0) {
        return materials[0];
      }
      if (typeof materials === 'string' && materials.trim()) {
        return materials.trim();
      }
      // Fallback to formData (already extracted)
      return formData.packingMaterials || product.packingMaterials || '';
    })();
    
    if (packingMaterialsValue) {
      setTimeout(() => {
        // Find the ID from packagingMaterialsOptions based on the string value
        // fetchPackingTypes expects an ID, not a string value
        let packingMaterialsId = packingMaterialsValue;
        
        // If it's a string, try to find the corresponding ID in packagingMaterialsOptions
        if (typeof packingMaterialsValue === 'string' && packagingMaterialsOptions && packagingMaterialsOptions.length > 0) {
          const foundMaterial = packagingMaterialsOptions.find(opt => 
            opt.value === packingMaterialsValue || 
            opt.label === packingMaterialsValue ||
            String(opt.value).toLowerCase() === packingMaterialsValue.toLowerCase() ||
            String(opt.label).toLowerCase() === packingMaterialsValue.toLowerCase()
          );
          
          if (foundMaterial && foundMaterial.value) {
            packingMaterialsId = foundMaterial.value;
            console.log('Found packing materials ID:', {
              original_value: packingMaterialsValue,
              found_id: packingMaterialsId,
              found_option: foundMaterial
            });
          } else {
            // If not found, try using the value directly (might be an ID already)
            console.log('Packing materials not found in options, using value directly:', {
              packingMaterialsValue,
              available_options: packagingMaterialsOptions?.map(opt => ({ value: opt.value, label: opt.label }))
            });
          }
        }
        
        console.log('Fetching packing types for material when editing:', {
          packingMaterialsValue,
          packingMaterialsId,
          packaging_details: product.packaging_details,
          formData_packingMaterials: formData.packingMaterials
        });
        fetchPackingTypes(packingMaterialsId);
      }, 200); // Delay to ensure form state is updated and packagingMaterialsOptions are loaded
    }
    
    // Force a re-render check after state update
    setTimeout(() => {
      console.log('Form state after setForm (checking via closure):', {
        'Should have pd_name set to': productName,
        'pd_cat': formData.pd_cat,
        'pd_subcat': formData.pd_subcat,
        'pd_subsubcat': formData.pd_subsubcat
      });
    }, 200);
    // Set separate state for keywords, carousel
    setKeywords(Array.isArray(product.keywords) ? product.keywords : (product.keywords ? [product.keywords] : []));
    // Handle carousel toggle - check carousel_slider JSON field, mapped field, and backend field name
    const carouselEnabledValue = (() => {
      // First check if carousel_slider is an object with enabled property
      if (product.carousel_slider && typeof product.carousel_slider === 'object' && !Array.isArray(product.carousel_slider) && 'enabled' in product.carousel_slider) {
        return !!product.carousel_slider.enabled;
      }
      // Then check mapped field
      if (product.carouselEnabled !== undefined) {
        return !!product.carouselEnabled;
      }
      // Finally check backend field name
      if (product.carousel_slider_enabled !== undefined) {
        return !!product.carousel_slider_enabled;
      }
      return false;
    })();
    setCarouselEnabled(carouselEnabledValue);
    setCarouselFiles(product.carouselFiles || []);
    setCarouselImageUrls(Array.isArray(product.carousel_images) ? product.carousel_images : (product.carousel_images ? [product.carousel_images] : []));
    // Set file URLs for display
    setProductCatalogueUrl(product.pd_catalogue_path || product.product_catalogue || '');
    setProductVideoUrl(product.pd_video_path || product.product_video || '');
    setProductImageUrls(Array.isArray(product.pd_images_paths) ? product.pd_images_paths : (product.product_images ? (Array.isArray(product.product_images) ? product.product_images : [product.product_images]) : []));
    
    // Load Add More lists from product data
    // Colour Options
    if (Array.isArray(product.colour_options) && product.colour_options.length > 0) {
      setColourOptionsList(product.colour_options.map((opt, idx) => ({
        id: idx + 1,
        // Backend returns: name (required), hex_code (optional), image_url (optional)
        // Map to frontend: color (from hex_code or name), imageUrl (from image_url)
        color: opt.hex_code || opt.color || opt.name || '#ED00BE',
        imageUrl: opt.image_url || opt.imageUrl || ''
      })));
    } else if (product.pd_colour_options) {
      // Single colour option from form field
      setColourOptionsList([{ id: 1, color: product.pd_colour_options, imageUrl: '' }]);
    } else {
      // Reset to default if no colour options
      setColourOptionsList([{ id: 1, color: '#ED00BE', imageUrl: '' }]);
    }
    
    // Dimensions - handle both dimensions_list (array) and dimensions (single object)
    console.log('Loading dimensions for edit:', {
      dimensions_list: product.dimensions_list,
      dimensions_list_type: Array.isArray(product.dimensions_list) ? 'array' : typeof product.dimensions_list,
      dimensions: product.dimensions,
      dimensions_type: Array.isArray(product.dimensions) ? 'array' : typeof product.dimensions,
      pd_height: product.pd_height,
      pd_length: product.pd_length,
      pd_width: product.pd_width,
      pd_uom: product.pd_uom,
      // Debug: Check unit values in dimensions
      dimensions_unit: product.dimensions?.unit,
      dimensions_list_units: Array.isArray(product.dimensions_list) ? product.dimensions_list.map(d => d.unit) : undefined
    });
    
    if (Array.isArray(product.dimensions_list) && product.dimensions_list.length > 0) {
      // Multiple dimensions from dimensions_list
      console.log('Loading dimensions_list (multiple):', product.dimensions_list);
      setDimensionsList(product.dimensions_list.map((dim, idx) => {
        // Extract unit - handle both 'unit' (backend) and 'uom' (legacy) field names
        let unitValue = dim.unit || dim.uom;
        // Handle if unit is a number (convert to string)
        if (unitValue !== undefined && unitValue !== null) {
          unitValue = typeof unitValue === 'string' ? unitValue.trim() : String(unitValue).trim();
        } else {
          unitValue = '';
        }
        
        console.log(`Dimension ${idx + 1} unit extraction:`, {
          dim_unit: dim.unit,
          dim_uom: dim.uom,
          extracted_unit: unitValue,
          unit_type: typeof unitValue
        });
        
        return {
          id: idx + 1,
          height: dim.height !== undefined && dim.height !== null ? String(dim.height) : '',
          length: dim.length !== undefined && dim.length !== null ? String(dim.length) : '',
          width: dim.width !== undefined && dim.width !== null ? String(dim.width) : '',
          uom: unitValue
        };
      }));
    } else if (product.dimensions && typeof product.dimensions === 'object' && !Array.isArray(product.dimensions)) {
      // Single dimension object
      console.log('Loading dimensions (single object):', product.dimensions);
      // Extract unit - handle both 'unit' (backend) and 'uom' (legacy) field names
      let unitValue = product.dimensions.unit || product.dimensions.uom;
      // Handle if unit is a number (convert to string)
      if (unitValue !== undefined && unitValue !== null) {
        unitValue = typeof unitValue === 'string' ? unitValue.trim() : String(unitValue).trim();
      } else {
        unitValue = '';
      }
      
      console.log('Single dimension unit extraction:', {
        dimensions_unit: product.dimensions.unit,
        dimensions_uom: product.dimensions.uom,
        extracted_unit: unitValue,
        unit_type: typeof unitValue
      });
      
      setDimensionsList([{
        id: 1,
        height: product.dimensions.height !== undefined && product.dimensions.height !== null ? String(product.dimensions.height) : '',
        length: product.dimensions.length !== undefined && product.dimensions.length !== null ? String(product.dimensions.length) : '',
        width: product.dimensions.width !== undefined && product.dimensions.width !== null ? String(product.dimensions.width) : '',
        uom: unitValue
      }]);
    } else if (product.pd_height || product.pd_length || product.pd_width) {
      // Fallback: Single dimension from form fields (legacy)
      console.log('Loading dimensions (legacy form fields)');
      setDimensionsList([{
        id: 1,
        height: product.pd_height ? String(product.pd_height) : '',
        length: product.pd_length ? String(product.pd_length) : '',
        width: product.pd_width ? String(product.pd_width) : '',
        uom: product.pd_uom && typeof product.pd_uom === 'string' ? product.pd_uom.trim() : ''
      }]);
    } else {
      // Reset to default if no dimensions
      console.log('No dimensions found, resetting to default');
      setDimensionsList([{ id: 1, height: '', length: '', width: '', uom: '' }]);
    }
    
    // Inventory Details - handle both inventory_details_list (array) and inventory_details (single object)
    // Inventory Details
    // Backend stores structure: { items: [...] } - no duplication, all entries in items array
    // For backward compatibility, also check top-level properties if items doesn't exist
    // Check for inventory_details_list first (if backend returns it directly)
    // Then check for inventory_details.items (where backend stores multiple inventory details - this is the primary source)
    // Then check for inventory_details as array
    // Finally check for single inventory_details object (for backward compatibility with old data)
    const inventoryData = product.inventory_details_list || 
                         (product.inventory_details?.items && Array.isArray(product.inventory_details.items) && product.inventory_details.items.length > 0
                           ? product.inventory_details.items  // Use items array - contains ALL entries
                           : null) ||
                         (Array.isArray(product.inventory_details) ? product.inventory_details : null) ||
                         (product.inventory_details && typeof product.inventory_details === 'object' && !Array.isArray(product.inventory_details) && product.inventory_details.items
                           ? (Array.isArray(product.inventory_details.items) ? product.inventory_details.items : null)
                           : (product.inventory_details && typeof product.inventory_details === 'object' && !Array.isArray(product.inventory_details) 
                             ? [product.inventory_details] 
                             : []));
    
    if (inventoryData && inventoryData.length > 0) {
      setInventoryDetailsList(inventoryData.map((inv, idx) => {
        // Extract unit_of_measurement - handle various formats
        const unitValue = inv.unit_of_measurement || inv.uom || '';
        console.log('Loading inventory detail unit:', { 
          inventory_index: idx, 
          unit_of_measurement: inv.unit_of_measurement, 
          uom: inv.uom,
          extracted_unit: unitValue,
          full_inventory: inv
        });
        
        // Extract status - map to match inventoryStatusOptions format for proper dropdown selection
        const statusValue = mapStatusForEdit(inv.status);
        console.log('Loading inventory detail status:', { 
          inventory_index: idx, 
          status: inv.status,
          extracted_status: statusValue,
          full_inventory: inv
        });
        
        return {
          id: idx + 1,
          qty: inv.available_quantity || inv.qty || '',
          uom: typeof unitValue === 'string' ? unitValue.trim() : (unitValue ? String(unitValue).trim() : ''),
          status: statusValue,
          location: inv.stock_location || inv.location || ''
        };
      }));
    } else if (product.inv_qty || product.inv_status || product.inv_location) {
      // Single inventory detail from form fields
      setInventoryDetailsList([{
        id: 1,
        qty: product.inv_qty || '',
        uom: product.inv_uom || '',
        status: mapStatusForEdit(product.inv_status),
        location: product.inv_location || ''
      }]);
    }
    
    // Lead Time
    // Backend stores structure: { items: [...] } - no duplication, all entries in items array
    // For backward compatibility, also check top-level properties if items doesn't exist
    // Check for lead_time_list first (if backend returns it directly)
    // Then check for lead_time.items (where backend stores multiple lead times - this is the primary source)
    // Then check for lead_time as array
    // Finally check for single lead_time object (for backward compatibility with old data) or form fields
    const leadTimeData = product.lead_time_list || 
                        (product.lead_time?.items && Array.isArray(product.lead_time.items) && product.lead_time.items.length > 0 
                          ? product.lead_time.items  // Use items array - contains ALL entries
                          : null) ||
                        (Array.isArray(product.lead_time) ? product.lead_time : null);
    
    if (leadTimeData && leadTimeData.length > 0) {
      // Load all entries from items array (or lead_time_list)
      console.log('Loading lead time data:', {
        source: product.lead_time_list ? 'lead_time_list' : (product.lead_time?.items ? 'lead_time.items' : 'other'),
        count: leadTimeData.length,
        data: leadTimeData
      });
      setLeadTimeList(leadTimeData.map((lead, idx) => ({
        id: idx + 1,
        days: lead.lead_time_days || lead.days || '',
        min: lead.min_quantity || lead.min || '',
        max: lead.max_quantity || lead.max || ''
      })));
    } else if (product.lead_time && typeof product.lead_time === 'object' && !Array.isArray(product.lead_time)) {
      // Single lead time object (for backward compatibility with old data that has top-level properties)
      // Check if it has items property but items is empty, or if it has direct properties
      if (product.lead_time.items && Array.isArray(product.lead_time.items) && product.lead_time.items.length > 0) {
        // Items exists and has data - should have been caught above, but handle just in case
        setLeadTimeList(product.lead_time.items.map((lead, idx) => ({
          id: idx + 1,
          days: lead.lead_time_days || lead.days || '',
          min: lead.min_quantity || lead.min || '',
          max: lead.max_quantity || lead.max || ''
        })));
      } else if (product.lead_time.lead_time_days !== undefined || product.lead_time.min_quantity !== undefined || product.lead_time.max_quantity !== undefined) {
        // Has top-level properties (old format) - load as single entry
        setLeadTimeList([{
          id: 1,
          days: product.lead_time.lead_time_days || product.lead_time.days || '',
          min: product.lead_time.min_quantity || product.lead_time.min || '',
          max: product.lead_time.max_quantity || product.lead_time.max || ''
        }]);
      }
    } else if (product.lead_days || product.lead_min || product.lead_max) {
      // Single lead time from form fields (legacy)
      setLeadTimeList([{
        id: 1,
        days: product.lead_days || '',
        min: product.lead_min || '',
        max: product.lead_max || ''
      }]);
    }
    
    // FAQ
    if (Array.isArray(product.faq) && product.faq.length > 0) {
      setFaqList(product.faq.map((faq, idx) => ({
        id: idx + 1,
        question: faq.question || faq.q || '',
        answer: faq.answer || faq.a || ''
      })));
    } else if (product.faq_q || product.faq_a) {
      // Single FAQ from form fields
      setFaqList([{
        id: 1,
        question: product.faq_q || '',
        answer: product.faq_a || ''
      }]);
    }
    
    // Other Attributes
    console.log('Loading other_attributes for edit:', {
      other_attributes: product.other_attributes,
      other_attributes_type: Array.isArray(product.other_attributes) ? 'array' : typeof product.other_attributes,
      pd_attr: product.pd_attr,
      pd_attr_val: product.pd_attr_val,
      pd_attr_unit: product.pd_attr_unit
    });
    
    if (Array.isArray(product.other_attributes) && product.other_attributes.length > 0) {
      console.log('Loading other_attributes (array):', product.other_attributes);
      setAttributesList(product.other_attributes.map((attr, idx) => {
        // Extract unit - handle both string and ensure it's properly extracted
        let unitValue = attr.unit;
        if (unitValue !== undefined && unitValue !== null) {
          unitValue = typeof unitValue === 'string' ? unitValue.trim() : String(unitValue).trim();
        } else {
          unitValue = '';
        }
        
        console.log(`Attribute ${idx + 1} unit extraction:`, {
          attr_unit: attr.unit,
          extracted_unit: unitValue,
          unit_type: typeof unitValue
        });
        
        return {
          id: idx + 1,
          attribute: attr.attribute_name || attr.attribute || '',
          value: attr.attribute_value || attr.value || '',
          unit: unitValue
        };
      }));
    } else if (product.pd_attr || product.pd_attr_val) {
      // Single attribute from form fields (legacy)
      console.log('Loading other_attributes (legacy form fields)');
      let unitValue = product.pd_attr_unit;
      if (unitValue !== undefined && unitValue !== null) {
        unitValue = typeof unitValue === 'string' ? unitValue.trim() : String(unitValue).trim();
      } else {
        unitValue = '';
      }
      
      setAttributesList([{
        id: 1,
        attribute: product.pd_attr || '',
        value: product.pd_attr_val || '',
        unit: unitValue
      }]);
    } else {
      // Reset to default if no attributes
      console.log('No other_attributes found, resetting to default');
      setAttributesList([{ id: 1, attribute: '', value: '', unit: '' }]);
    }
    setProductVideoUrl(product.pd_video_path || product.product_video || '');
    setProductImageUrls(Array.isArray(product.pd_images_paths) ? product.pd_images_paths : (product.product_images ? (Array.isArray(product.product_images) ? product.product_images : [product.product_images]) : []));
    // Set bulk discount slabs if available
    if (Array.isArray(product.bulkDiscountSlabs) && product.bulkDiscountSlabs.length > 0) {
      setBulkDiscountSlabs(product.bulkDiscountSlabs.map((slab, idx) => {
        // Extract unit_of_measurements - handle both plural and singular for backward compatibility
        const unitValue = slab.unit_of_measurements || slab.unit_of_measurement || slab.bulk_uom || '';
        console.log('Loading bulk discount slab unit:', { 
          slab_index: idx, 
          unit_of_measurements: slab.unit_of_measurements, 
          unit_of_measurement: slab.unit_of_measurement, 
          bulk_uom: slab.bulk_uom,
          extracted_unit: unitValue,
          full_slab: slab
        });
        
        return {
          id: idx + 1,
          bulk_min: slab.min_units || slab.bulk_min || '',
          bulk_max: slab.max_units || slab.bulk_max || '',
          bulk_uom: typeof unitValue === 'string' ? unitValue.trim() : (unitValue ? String(unitValue).trim() : ''),
          bulk_price_no: slab.price_without_tax || slab.bulk_price_no || '',
          bulk_price_with: slab.price_with_tax || slab.bulk_price_with || '',
          bulk_tax: slab.tax_percentage || slab.bulk_tax || '',
          bulk_currency: slab.currency || slab.bulk_currency || ''
        };
      }));
    }
    setProductCatalogueCollapsed(false);
    // Scroll to top of form
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDeleteProduct = async (productId) => {
    if (window.confirm('Are you sure you want to delete this product?')) {
      // Check if productId is a numeric ID from backend
      if (productId && productId.toString().match(/^\d+$/)) {
        try {
          const response = await CommonService.delete(`/profile/product/${productId}`);
          if (response && response.success) {
            toast.success(response.message || 'Product deleted successfully');
            setSavedProducts(prev => prev.filter(p => p.id !== productId));
            if (editingProductId === productId) {
              setForm(initialState);
              setKeywords([]);
              setCarouselEnabled(false);
              setCarouselFiles([]);
              setCarouselImageUrls([]);
              setEditingProductId(null);
              setProductCatalogueCollapsed(true);
            }
          } else {
            toast.error("Product deletion failed");
          }
        } catch (err) {
          console.error("Error deleting product:", err);
          const message = err?.response?.data?.message || "Product deletion failed. Please try again.";
          toast.error(message);
        }
      } else {
        // If it's a local-only product (not saved to backend yet), just remove from local state
        setSavedProducts(prev => prev.filter(p => p.id !== productId));
        if (editingProductId === productId) {
          setForm(initialState);
          setCustomizationRows(DEFAULT_CUSTOMIZATION_ROWS.map((row) => ({ ...row })));
          setKeywords([]);
          setCarouselEnabled(false);
          setCarouselFiles([]);
          setCarouselImageUrls([]);
          setEditingProductId(null);
          setProductCatalogueCollapsed(true);
        }
      }
    }
  };

  const handleCancelProduct = () => {
    setForm(initialState);
    setKeywords([]);
    setCarouselEnabled(false);
    setCarouselFiles([]);
    setCarouselImageUrls([]);
    setEditingProductId(null);
    setProductCatalogueCollapsed(true);
    // Reset "Add More" lists to default
    setDimensionsList([{ id: 1, height: '', length: '', width: '', uom: '' }]);
    setColourOptionsList([{ id: 1, color: '#ED00BE', imageUrl: '' }]);
    setInventoryDetailsList([{ id: 1, qty: '', uom: '', status: '', location: '' }]);
    setLeadTimeList([{ id: 1, days: '', min: '', max: '' }]);
    setFaqList([{ id: 1, question: '', answer: '' }]);
    setAttributesList([{ id: 1, attribute: '', value: '', unit: '' }]);
    // Reset file upload state
    setProductCatalogueFile(null);
    setProductCatalogueUrl('');
    setProductVideoFile(null);
    setProductVideoUrl('');
    setProductImageFiles([]);
    setProductImageUrls([]);
    // Reset Add More lists
    setColourOptionsList([{ id: 1, color: '#ED00BE', imageUrl: '' }]);
    setDimensionsList([{ id: 1, height: '', length: '', width: '', uom: '' }]);
    setInventoryDetailsList([{ id: 1, qty: '', uom: '', status: '', location: '' }]);
    setLeadTimeList([{ id: 1, days: '', min: '', max: '' }]);
    setFaqList([{ id: 1, question: '', answer: '' }]);
    setAttributesList([{ id: 1, attribute: '', value: '', unit: '' }]);
  };

  // Helper function to get full image URL from access path
  const getImageUrl = (accessPath) => {
    if (!accessPath) return '';
    // If already a full URL, return as is
    if (accessPath.startsWith('http://') || accessPath.startsWith('https://')) {
      return accessPath;
    }
    // If relative path, prepend base URL (static files are served from root, not /api/v1)
    const baseUrl = 'http://localhost:3000';
    return accessPath.startsWith('/') ? `${baseUrl}${accessPath}` : `${baseUrl}/${accessPath}`;
  };

  // Upload file to backend and return URL
  const uploadFile = async (file, fileType, category = 'company') => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('category', category);
      formData.append('companyName', form.companyName || 'default');
      formData.append('fileType', fileType);

      // Don't set Content-Type header - axios will set it automatically with boundary
      const response = await CommonService.post('/upload/single', formData);

      if (response && response.success && response.data) {
        // Return the access path (URL) from the response
        const accessPath = response.data.accessPath || response.data.filePath || '';
        // Convert to full URL for display
        return getImageUrl(accessPath);
      }
      throw new Error(response?.message || 'Upload failed');
    } catch (error) {
      console.error('File upload error:', error);
      const errorMessage = error?.response?.data?.message || error?.response?.data?.errors?.[0] || error?.message || `Failed to upload ${fileType}`;
      toast.error(errorMessage);
      throw error;
    }
  };

  // Handle media file uploads (company logo, banner, brochure, video)
  const handleMediaFileChange = async (fileType, e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setUploading(true);
      const fileUrl = await uploadFile(file, fileType);
      setMediaFiles(prev => ({
        ...prev,
        [fileType]: fileUrl
      }));
      toast.success(`${fileType.replace('_', ' ')} uploaded successfully`);
    } catch (error) {
      console.error(`Error uploading ${fileType}:`, error);
    } finally {
      setUploading(false);
    }
  };

  // Handle certificate file upload
  const handleCertificateFileChange = async (index, e) => {
    const file = e.target.files?.[0] || null;
    if (!file) return;

    try {
      setUploading(true);
      const fileUrl = await uploadFile(file, `certificate_${index}_${Date.now()}`, 'company');
      
      // Update the specific certificate's attachment URL
      updateCertificate(index, 'certificateAttachmentUrl', fileUrl);
      
      toast.success('Certificate attachment uploaded successfully');
    } catch (error) {
      console.error('Error uploading certificate attachment:', error);
      toast.error('Failed to upload certificate attachment');
    } finally {
      setUploading(false);
    }
  };

  // Handle product catalogue file upload
  const handleProductCatalogueUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validate file type
    const allowedTypes = ['.pdf', '.doc', '.docx'];
    const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
    if (!allowedTypes.includes(fileExtension)) {
      toast.error('Please upload a PDF, DOC, or DOCX file');
      return;
    }

    try {
      setUploadingProductFiles(true);
      const fileUrl = await uploadFile(file, 'product_catalogue', 'product');
      setProductCatalogueUrl(fileUrl);
      setProductCatalogueFile(file);
      setForm(prev => ({ ...prev, pd_catalogue_path: fileUrl }));
      toast.success('Product catalogue uploaded successfully');
    } catch (error) {
      console.error('Error uploading product catalogue:', error);
    } finally {
      setUploadingProductFiles(false);
    }
  };

  // Handle product video file upload
  const handleProductVideoUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validate file type
    const allowedExtensions = ['.mp4', '.mov', '.avi', '.mkv', '.webm'];
    const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      toast.error('Please upload a video file (MP4, MOV, AVI, MKV, or WEBM)');
      e.target.value = '';
      return;
    }

    // Validate file size (100 MB)
    const maxSize = 100 * 1024 * 1024; // 100 MB in bytes
    if (file.size > maxSize) {
      toast.error('File size must be less than 100 MB');
      e.target.value = '';
      return;
    }

    try {
      setUploadingProductFiles(true);
      const fileUrl = await uploadFile(file, 'product_video', 'product');
      setProductVideoUrl(fileUrl);
      setProductVideoFile(file);
      setForm(prev => ({ ...prev, pd_video_path: fileUrl }));
      toast.success('Product video uploaded successfully');
    } catch (error) {
      console.error('Error uploading product video:', error);
    } finally {
      setUploadingProductFiles(false);
    }
  };

  // Handle the single active product image. A newly uploaded image replaces
  // the current UI value; the backend deletes the old stored file only after
  // the product update succeeds.
  const handleProductImagesUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    if (files.length > 1) {
      toast.error('Please select one product image. The new image will replace the existing image.');
      e.target.value = '';
      return;
    }

    // Validate file types
    const allowedTypes = ['.jpg', '.jpeg', '.png', '.webp', '.gif', '.avif'];
    const invalidFiles = files.filter(file => {
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
      return !allowedTypes.includes(fileExtension);
    });

    if (invalidFiles.length > 0) {
      toast.error('Please upload a PNG, JPG, JPEG, WEBP, GIF, or AVIF image');
      e.target.value = '';
      return;
    }

    try {
      setUploadingProductFiles(true);
      const uploadedUrl = await uploadFile(files[0], 'product_image', 'product');
      const newUrls = [uploadedUrl];
      setProductImageUrls(newUrls);
      setProductImageFiles([files[0]]);
      setForm(prev => ({ 
        ...prev, 
        pd_images_paths: newUrls,
        productImages: newUrls
      }));
      toast.success('Product image uploaded successfully');
    } catch (error) {
      console.error('Error uploading product images:', error);
    } finally {
      setUploadingProductFiles(false);
      // Reset input
      e.target.value = '';
    }
  };

  // Remove product image
  const handleRemoveProductImage = (index) => {
    const newUrls = productImageUrls.filter((_, i) => i !== index);
    const newFiles = productImageFiles.filter((_, i) => i !== index);
    setProductImageUrls(newUrls);
    setProductImageFiles(newFiles);
    setForm(prev => ({ 
      ...prev, 
      pd_images_paths: newUrls,
      productImages: newUrls
    }));
  };

  // Handle carousel images upload
  const handleCarouselImagesUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    // Check if adding these files would exceed the limit of 5
    const currentCount = carouselImageUrls.length;
    const remainingSlots = 5 - currentCount;
    if (files.length > remainingSlots) {
      toast.error(`You can only upload ${remainingSlots} more image(s). Maximum limit is 5 images.`);
      e.target.value = '';
      return;
    }

    // Validate file types
    const allowedTypes = ['.jpg', '.jpeg', '.png'];
    const invalidFiles = files.filter(file => {
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
      return !allowedTypes.includes(fileExtension);
    });

    if (invalidFiles.length > 0) {
      toast.error('Please upload only JPG, JPEG, or PNG files');
      e.target.value = '';
      return;
    }

    // Validate file sizes (1 MB each)
    const maxSize = 1 * 1024 * 1024; // 1 MB in bytes
    const oversizedFiles = files.filter(file => file.size > maxSize);
    if (oversizedFiles.length > 0) {
      toast.error('Each image must be less than 1 MB');
      e.target.value = '';
      return;
    }

    try {
      setUploadingProductFiles(true);
      const uploadPromises = files.map(file => uploadFile(file, 'carousel_image', 'product'));
      const uploadedUrls = await Promise.all(uploadPromises);
      
      const newUrls = [...carouselImageUrls, ...uploadedUrls];
      setCarouselImageUrls(newUrls);
      setCarouselFiles([...carouselFiles, ...files]);
      setForm(prev => ({ 
        ...prev, 
        carousel_images: newUrls
      }));
      toast.success(`${files.length} carousel image(s) uploaded successfully`);
    } catch (error) {
      console.error('Error uploading carousel images:', error);
      toast.error('Failed to upload carousel images. Please try again.');
    } finally {
      setUploadingProductFiles(false);
      // Reset input
      e.target.value = '';
    }
  };

  // Remove carousel image
  const handleRemoveCarouselImage = (index) => {
    const newUrls = carouselImageUrls.filter((_, i) => i !== index);
    const newFiles = carouselFiles.filter((_, i) => i !== index);
    setCarouselImageUrls(newUrls);
    setCarouselFiles(newFiles);
    setForm(prev => ({ 
      ...prev, 
      carousel_images: newUrls
    }));
    toast.success('Carousel image removed');
  };

  const onFileChange = (e) => {
    // Legacy handler - can be used for other file types if needed
    const files = Array.from(e.target.files || []);
    console.log('selected files', files);
  };

  const handleSave = () => {
    console.log('save', { ...form, products });
    alert('Saved (demo)');
  };

  const handleNext = () => {
    const currentTab = parseInt(activeTab);
    if (currentTab < 5) {
      setActiveTab((currentTab + 1).toString());
    }
  };

  const handleBack = () => {
    const currentTab = parseInt(activeTab);
    if (currentTab > 1) {
      setActiveTab((currentTab - 1).toString());
    }
  };


  // Helper for post
  const parseNumber = (v) => {
    if (v === null || v === undefined || v === "") return undefined;
    const n = Number(String(v).replace(/[^0-9.-]+/g, ""));
    return Number.isFinite(n) ? n : undefined;
  };
  const isEmpty = (v) =>
    v === undefined ||
    v === null ||
    (typeof v === "string" && v.trim() === "") ||
    (Array.isArray(v) && v.length === 0) ||
    (typeof v === "object" && !Array.isArray(v) && Object.keys(v).length === 0);

  const pickDefined = (obj) => {
    const out = {};
    Object.keys(obj || {}).forEach((k) => {
      if (!isEmpty(obj[k])) out[k] = obj[k];
    });
    return Object.keys(out).length ? out : undefined;
  };

  const cleanObjectDeep = (o) => {
    if (Array.isArray(o)) {
      const arr = o
        .map((i) => cleanObjectDeep(i))
        .filter((i) => !isEmpty(i));
      return arr.length ? arr : undefined;
    }
    if (typeof o === "object" && o !== null) {
      const out = {};
      Object.keys(o).forEach((k) => {
        const v = cleanObjectDeep(o[k]);
        if (!isEmpty(v)) out[k] = v;
      });
      return Object.keys(out).length ? out : undefined;
    }
    return o;
  };


  // company profile
  function buildJsonPayloadForCompanyDetails() {
    // Get existing seller_profile if available (from loaded profile)
    const existingSellerProfile = profileData?.seller_profile || {};
    
    return {
      // company details
      company_name: form.companyName || "",
      designation: form.designation || "",
      company_type_id: form.trader ? Number(form.trader) : (form.companyTypeId ? Number(form.companyTypeId) : undefined),
      tax_number: form.gstNumber || form.taxNumber || "",
      registration_number: form.registrationNumber || "",
      website: form.website || "",
      number_of_employees: form.noOfEmployees || "",
      establishment_year: form.yearEstablished ? Number(form.yearEstablished) : undefined,
      company_description: form.companyDescription || "",
      // Main product
      main_products: Array.isArray(products) ? products : [],
      // contact details
      contact_details: {
        alternate_contact_name: form.altContactName || "",
        alternate_contact_number: form.altContact && String(form.altContact).trim() !== "" ? String(form.altContact).trim() : "N/A", // Required field, use "N/A" if empty
        alternate_email: form.altEmail || ""
      },
      // address - convert IDs to labels
      address: {
        address: form.address || "",
        landmark: form.landmark && String(form.landmark).trim() !== "" ? String(form.landmark).trim() : "N/A", // Required field, use "N/A" if empty
        city: form.city ? (cities.find(c => String(c.value) === String(form.city))?.label || form.city) : "",
        state: form.state ? (states.find(s => String(s.value) === String(form.state))?.label || form.state) : "",
        country: form.country ? (countries.find(c => String(c.value) === String(form.country))?.label || form.country) : "",
        timezone: form.timezone && String(form.timezone).trim() !== "" ? String(form.timezone).trim() : "UTC", // Required field, default to UTC if empty
        pincode: form.pincode || ""
      },
      // bank details
      bank_details: {
        account_holder_name: form.accountHolder || "",
        account_number: form.accountNumber || "",
        bank_name: form.bankName || "",
        branch_name: form.branchName || "",
        ifsc_code: form.ifsc || "",
        swift_code: form.swift || ""
      }, 
      // trading information
      annual_turnover: form.totalRevenue || "",
      export_percentage: form.exportPercentage ? Number(form.exportPercentage) : undefined,
      overseas_address: form.overseasAddress
        ? {
            address: form.overseasAddress,
            landmark: form.overseasLandmark || undefined,
            city: form.overseasCity || undefined,
            state: form.overseasState || undefined,
            country: form.overseasCountry || undefined
          }
        : undefined,
      iec_number: form.iecNumber || "",

      // seller_profile - preserve existing data, add export_percentage if provided
      // The detailed seller_profile data (factory, quality, product) is saved separately via other endpoints
      seller_profile: {
        ...existingSellerProfile,
        // Update export_percentage if provided in form
        ...(form.exportPercentage ? { export_percentage: Number(form.exportPercentage) } : {})
      },
      company_role: form.companyRole || "SELLER",
      currency: form.currency && String(form.currency).trim() !== "" ? String(form.currency).trim() : "USD", // Must be a string, default to USD
      // social_media: {
      //   "linkedin": "https://linkedin.com/company/techmfg",
      //   "twitter": "https://twitter.com/techmfg",
      //   "facebook": "https://facebook.com/techmfg"
      // },
      media: {
        company_logo: mediaFiles.company_logo || undefined,
        profile_banner: mediaFiles.profile_banner || undefined,
        brochure: mediaFiles.brochure || undefined,
        company_video: mediaFiles.company_video || undefined
      },
      certifications: (form.certificateTitle || form.certificationCompany || form.certificateStartDate || form.certificateEndDate) 
        ? [{
            name: form.certificateTitle || '',
            issuer: form.certificationCompany || '',
            issued_date: form.certificateStartDate || '',
            validity: form.certificateEndDate || '',
            attachment_url: form.certificateAttachmentUrl || undefined
          }].filter(cert => cert.name || cert.issuer || cert.validity)
        : (Array.isArray(form.certifications) ? form.certifications : []),
      languages: Array.isArray(form.languages) ? form.languages : [],
      target_markets: Array.isArray(form.target_markets) ? form.target_markets : [],
      export_import_details: {},
    };
  }

  const saveCompanyProfiles = async () => {
    const payload = buildJsonPayloadForCompanyDetails();
    console.log("payload......", payload);
    
    try {
      // First, check if profile already exists (double-check to prevent duplicates)
      let existingCompanyId = companyId || companyIdRef.current;
      
      if (!existingCompanyId) {
        try {
          const checkResponse = await CommonService.get('/company/my-profile');
          if (checkResponse && checkResponse.success && checkResponse.data) {
            existingCompanyId = checkResponse.data.company_id || checkResponse.data.id;
            if (existingCompanyId) {
              updateCompanyId(existingCompanyId);
            }
          }
        } catch (checkErr) {
          // No existing profile found, proceed with create
          console.log('No existing profile found, will create new one');
        }
      }

      let response;
      if (existingCompanyId) {
        // Update existing profile
        response = await CommonService.put(`/company/profile/${existingCompanyId}`, payload);
        if (response && response.success) {
          toast.success(response.message || 'Company profile updated successfully');
          // Ensure companyId is set
          if (!companyId && !companyIdRef.current) {
            updateCompanyId(existingCompanyId);
          }
          setIsCompanyProfileSaved(true); // Mark as saved
          const params = new URLSearchParams(window.location.search);
          const onboarding = params.get('onboarding');
          if (onboarding === 'logistics') {
            navigate('/logistics-profile/edit?onboarding=logistics');
            return existingCompanyId;
          }

          const user = StorageService.getUser();
          const isSeller = user?.company_role === 'SELLER' || user?.user_type === 'Seller' || user?.user_type_id === 2;
          if (isSeller) setShowContractManufacturerModal(true);
          return existingCompanyId;
          } else {
          toast.error("Company Profile update failed");
          setIsCompanyProfileSaved(false);
          return null;
        }
      } else {
        // Create new profile (only if no existing profile found)
        response = await CommonService.post("/company/profile", payload);
        if (response && response.success) {
          const newCompanyId = response.data?.company_id || response.data?.id || null;
          if (newCompanyId) {
            updateCompanyId(newCompanyId);
            toast.success(response.message || 'Company profile created successfully');
            setIsCompanyProfileSaved(true); // Mark as saved
            const params = new URLSearchParams(window.location.search);
            const onboarding = params.get('onboarding');
            if (onboarding === 'logistics') {
              navigate('/logistics-profile/edit?onboarding=logistics');
              return newCompanyId;
            }

            const user = StorageService.getUser();
            const isSeller = user?.company_role === 'SELLER' || user?.user_type === 'Seller' || user?.user_type_id === 2;
            if (isSeller) setShowContractManufacturerModal(true);
            return newCompanyId;
          } else {
            toast.error("Company Profile created but no ID returned");
            setIsCompanyProfileSaved(false);
            return null;
          }
        } else {
          toast.error("Company Profile creation failed");
          setIsCompanyProfileSaved(false);
          return null;
        }
      }
    } catch (err) {
      console.error('API Error:', err);
      console.error('Error Response:', err?.response?.data);
      
      // Handle duplicate key errors or existing record errors
      if (err?.response?.status === 409 || err?.response?.data?.message?.toLowerCase().includes('duplicate') || 
          err?.response?.data?.message?.toLowerCase().includes('already exists')) {
        // Profile already exists, try to load it and update instead
        try {
          const checkResponse = await CommonService.get('/company/my-profile');
          if (checkResponse && checkResponse.success && checkResponse.data) {
            const existingId = checkResponse.data.company_id || checkResponse.data.id;
            if (existingId) {
              updateCompanyId(existingId);
              // Retry as update
              const updateResponse = await CommonService.put(`/company/profile/${existingId}`, payload);
              if (updateResponse && updateResponse.success) {
                toast.success('Company profile updated successfully');
                const user = StorageService.getUser();
                const isSeller = user?.company_role === 'SELLER' || user?.user_type === 'Seller' || user?.user_type_id === 2;
                if (isSeller) setShowContractManufacturerModal(true);
                return existingId;
              }
            }
          }
        } catch (retryErr) {
          console.error('Error retrying as update:', retryErr);
        }
      }
      
      const message = err?.response?.data?.message || 
        (companyId || companyIdRef.current ? "Company Profile update failed. Please try again." : "Company Profile creation failed. Please try again.");
      
      // Show detailed validation errors
      if (err?.response?.data?.errors && Array.isArray(err.response.data.errors)) {
        toast.error(err.response.data.errors.join(', '));
      } else {
        toast.error(message);
      }
      setIsCompanyProfileSaved(false); // Mark as not saved on error
      return null;
    }
  }


  //factory details
  function buildFactoryPayload() {
    // normalize arrays
    const modeOfTransportArr = Array.isArray(form.modeOfTransport)
      ? form.modeOfTransport
      : form.modeOfTransport
        ? [String(form.modeOfTransport).toUpperCase()]
        : [];

    const paymentMethodsArr = Array.isArray(form.paymentMethods)
      ? form.paymentMethods
      : form.paymentMethod
        ? [form.paymentMethod]
        : [];

    // port data object
    const portData = {
      primary_port: form.nearestPort || form.port_primary || "",
      alternate_port: form.alternatePort || form.port_alternate || ""
    };

    // production capacity string (prefer explicit field)
    const productionCapacity = form.productionCapacity
      ? String(form.productionCapacity)
      : form.annualOutput
        ? `${form.annualOutput} units/month`
        : "";

    // factory details - map over array
    // Only include factories that have at least factory_name and address (required fields)
    const factorySections = factoryDetailsList
      .filter(factory => {
        const hasName = factory.factoryName && factory.factoryName.trim() !== '';
        const hasAddress = factory.factoryAddress && factory.factoryAddress.trim() !== '';
        return hasName && hasAddress;
      })
      .map(factory => {
        const areaSizeNum = factory.factorySize !== undefined && factory.factorySize !== null && factory.factorySize !== '' 
          ? Number(factory.factorySize) 
          : undefined;
        
        // Ensure all required fields are present (validation requires them)
        // Factory Details stores Country/State/City as labels (names) directly
        return {
          factory_name: factory.factoryName || "",
          area_size: areaSizeNum !== undefined && areaSizeNum > 0 ? areaSizeNum : (areaSizeNum === 0 ? 0 : 1), // Default to 1 if not provided (required field)
          area_unit: factory.factoryUnit || "sq ft", // Default unit if not provided (required field)
          workers_count: parseNumber(factory.noOfEmployees) ?? 0, // Default to 0 if not provided (required field)
          total_qc_staff: parseNumber(factory.noOfQualityStaff) ?? 0, // Default to 0 if not provided (required field)
          total_rd_staff: parseNumber(factory.noOfRDStaff) ?? 0, // Default to 0 if not provided (required field)
          total_production_lines: parseNumber(factory.totalProductionLines) ?? 0, // Default to 0 if not provided (required field)
          annual_output: factory.annualOutput ? String(factory.annualOutput) : "N/A", // Default value if not provided (required field)
          average_lead_time_production: parseNumber(factory.averageLeadTime) ?? 0, // Default to 0 if not provided (required field)
          address: factory.factoryAddress || "",
          // Store labels directly (no conversion needed - Factory Details uses labels, not IDs)
          country: factory.factoryCountry || "",
          state: factory.factoryState || "",
          city: factory.factoryCity || "",
          pincode: factory.factoryPincode || ""
        };
      });

    // Use first factory for backward compatibility, or create a merged object
    const legacyAreaSize = form.factorySize !== undefined && form.factorySize !== null && form.factorySize !== ''
      ? Number(form.factorySize)
      : (form.area_size ? Number(form.area_size) : undefined);
    
    const factorySection = factorySections[0] || {
      factory_name: form.factoryName || "",
      area_size: legacyAreaSize !== undefined && legacyAreaSize > 0 ? legacyAreaSize : undefined,
      area_unit: form.factoryUnit || form.area_unit || "",
      workers_count: parseNumber(form.noOfEmployees) || parseNumber(form.workers_count) || undefined,
      total_qc_staff: parseNumber(form.noOfQualityStaff) || parseNumber(form.total_qc_staff) || undefined,
      total_rd_staff: parseNumber(form.noOfRDStaff) || parseNumber(form.total_rd_staff) || undefined,
      total_production_lines: parseNumber(form.totalProductionLines) || parseNumber(form.total_production_lines) || undefined,
      annual_output: form.annualOutput ? String(form.annualOutput) : (form.annual_output || ""),
      average_lead_time_production: parseNumber(form.averageLeadTime) || parseNumber(form.average_lead_time) || undefined,
      address: form.factoryAddress || "",
      country: form.factoryCountry ? (countries.find(c => String(c.value) === String(form.factoryCountry))?.label || form.factoryCountry) : "",
      state: form.factoryState ? (states.find(s => String(s.value) === String(form.factoryState))?.label || form.factoryState) : "",
      city: form.factoryCity ? (cities.find(c => String(c.value) === String(form.factoryCity))?.label || form.factoryCity || "") : "",
      pincode: form.factoryPincode || ""
    };

    //  Warehouse Location - map over array
    // Convert IDs to labels (same as Company Profile Address section)
    // Filter to only include warehouses with required fields (warehouse_name, warehouse_address, warehouse_country, warehouse_state, warehouse_city)
    const warehouseSections = warehouseLocationsList
      .filter(warehouse => {
        const hasName = warehouse.warehouseName && warehouse.warehouseName.trim() !== '';
        const hasAddress = warehouse.warehouseAddress && warehouse.warehouseAddress.trim() !== '';
        const hasCountry = warehouse.warehouseCountry && String(warehouse.warehouseCountry).trim() !== '';
        const hasState = warehouse.warehouseState && String(warehouse.warehouseState).trim() !== '';
        const hasCity = warehouse.warehouseCity && String(warehouse.warehouseCity).trim() !== '';
        return hasName && hasAddress && hasCountry && hasState && hasCity;
      })
      .map(warehouse => {
        // Warehouse Details stores Country/State/City as labels (names) directly
        // Use labels directly (no conversion needed since we store labels)
        return {
          warehouse_name: String(warehouse.warehouseName || ""),
          warehouse_stock_quantity: parseNumber(warehouse.stockQuantity) || 0,
          warehouse_address: String(warehouse.warehouseAddress || ""),
          warehouse_country: warehouse.warehouseCountry || "",
          warehouse_state: String(warehouse.warehouseState || ""),
          warehouse_city: String(warehouse.warehouseCity || ""),
          warehouse_pincode: String(warehouse.warehousePincode || "")
        };
      });

    // Use first warehouse for backward compatibility
    const warehouseSection = warehouseSections[0] || {
      warehouse_name: form.warehouseName || "",
      warehouse_stock_quantity: parseNumber(form.stockQuantity) || parseNumber(form.warehouseStockQuantity) || parseNumber(form.warehouse_stock_quantity) || 0,
      warehouse_address: form.warehouseAddress || "",
      warehouse_country: form.warehouseCountry ? (countries.find(c => String(c.value) === String(form.warehouseCountry))?.label || form.warehouseCountry) : "",
      warehouse_state: form.warehouseState ? (states.find(s => String(s.value) === String(form.warehouseState))?.label || form.warehouseState) : "",
      warehouse_city: form.warehouseCity ? (cities.find(c => String(c.value) === String(form.warehouseCity))?.label || form.warehouseCity || "") : "",
      warehouse_pincode: form.warehousePincode || ""
    };

    // Supply Chain Logistics
    const logisticsSection = {
      port_data: portData, // keep structured port_data first (primary/alternate)
      nearest_port: form.nearestPort || "",
      distance_port: parseNumber(form.factoryToPortDistance) || parseNumber(form.distance_port) || undefined,
      nearest_airport: form.nearestAirport || "",
      distance_airport: parseNumber(form.factoryToAirportDistance) || parseNumber(form.distance_airport) || undefined,
      highway_name: form.nearestHighway || "test",
      highway_distance: parseNumber(form.factoryToHighwayDistance) || parseNumber(form.highway_distance) || undefined
    };

    // Shipping Information
    const shippingSection = {
      shipping_information: form.shippingInformation || form.shipping_information || "Available for all domestic and international shipping",
      shipping_terms: String(form.shippingTerms || form.shipping_terms || ""),
      mode_of_transport: modeOfTransportArr,
      dispatch_location: String(form.dispatchLocation || form.dispatch_location || "")
    };

    // Accepted Payment Methods
    const paymentSection = {
      payment_methods: Array.isArray(paymentMethodsArr) && paymentMethodsArr.length > 0 
        ? paymentMethodsArr.map(m => String(m)) 
        : undefined, // Only include if array has items
      payment_schedule: form.paymentSchedule ? String(form.paymentSchedule) : undefined,
      late_payment_policy: String(form.latePaymentPolicy || ""),
      currency: String(form.paymentCurrency || form.currency || "USD")
    };

    // Refund Policy
    const refundSection = {
      refund_policy: !!(form.refundPolicy !== undefined ? form.refundPolicy : (form.refund_policy || false)),
      refund_policy_description: form.refundPolicyDescription || form.refundPolicy || form.refund_policy_description || ""
    };

    // Certifications
    const certificationsSection = {
      certifications: Array.isArray(form.certifications)
        ? form.certifications
        : Array.isArray(form.certificationList)
          ? form.certificationList
          : (form.certificationsText ? form.certificationsText.split(",").map(s => s.trim()).filter(Boolean) : [])
    };

    // Build payload based on whether we have factory sections or legacy structure
    const payload = {
      ...logisticsSection,
      ...shippingSection,
      ...paymentSection,
      ...refundSection,
      ...certificationsSection
    };

    // Use factory_details array if we have factory sections, otherwise use legacy structure
    if (factorySections.length > 0) {
      // Use array structure - this is preferred
      payload.factory_details = factorySections;
      
      // Also include warehouse_locations if we have warehouses
      if (warehouseSections.length > 0) {
        payload.warehouse_locations = warehouseSections;
      }
    } else {
      // Use legacy single-factory structure
      // Only include if factory_name and address are present (required for legacy)
      if (factorySection.factory_name && factorySection.address) {
        Object.assign(payload, factorySection);
      }
      
      // Include warehouse section if present
      if (warehouseSection.warehouse_name || warehouseSection.warehouse_address) {
        Object.assign(payload, warehouseSection);
      }
    }

    // Clean up undefined and null values, but keep empty strings for fields that need to be saved
    // Important: Don't remove fields that are part of factory_details or warehouse_locations arrays
    Object.keys(payload).forEach(key => {
      const value = payload[key];
      
      // Always keep factory_details and warehouse_locations arrays
      if (key === 'factory_details' || key === 'warehouse_locations') {
        return; // Keep these arrays
      }
      
      // Keep required legacy fields even if empty
      if (key === 'factory_name' || key === 'address') {
        return; // Keep these fields
      }
      
      // Keep string fields that must be strings (even if empty) - validation requires them to be strings
      const stringFields = ['shipping_terms', 'dispatch_location', 'late_payment_policy', 'currency', 'nearest_port', 'nearest_airport', 'highway_name', 'shipping_information'];
      if (stringFields.includes(key)) {
        // Ensure it's a string, even if empty
        if (value === undefined || value === null) {
          payload[key] = '';
        } else {
          payload[key] = String(value);
        }
        return; // Keep these fields
      }
      
      // Keep numeric fields even if 0 or undefined (they might be 0)
      const numericFields = ['distance_port', 'distance_airport', 'highway_distance'];
      if (numericFields.includes(key)) {
        if (value === undefined || value === null) {
          delete payload[key]; // Remove if truly undefined/null
        }
        return; // Keep if it has a value (including 0)
      }
      
      // For payment_methods array, ensure all items are strings
      if (key === 'payment_methods' && Array.isArray(value)) {
        if (value.length === 0) {
          // Keep empty array as undefined (backend will handle it)
          payload[key] = undefined;
        } else {
          // Ensure all items are strings
          payload[key] = value.map(m => String(m));
        }
        return;
      }
      
      // Keep objects (like port_data) even if they have some empty values
      if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
        // Clean nested object but keep the object itself
        Object.keys(value).forEach(nestedKey => {
          if (value[nestedKey] === undefined || value[nestedKey] === null) {
            delete value[nestedKey];
          }
        });
        // For port_data, keep it even if empty
        if (key === 'port_data') {
          return; // Keep these objects even if empty
        }
        // For other objects, remove if empty
        if (Object.keys(value).length === 0) {
          delete payload[key];
        }
        return;
      }
      
      // Remove only undefined and null (keep empty strings for important fields)
      if (value === undefined || value === null) {
        delete payload[key];
      }
      
      // Remove empty arrays (except payment_methods which is handled above, and factory_details/warehouse_locations)
      if (Array.isArray(value) && value.length === 0 && key !== 'factory_details' && key !== 'warehouse_locations') {
        delete payload[key];
      }
    });

    return payload;
  }
  const saveFactoryDetails = async (maybeCompanyId) => {
    const payload = buildFactoryPayload();
    console.log(maybeCompanyId, "payload......", payload);
    const idNow = companyIdRef.current;
    if (!idNow) {
      toast.error("Please Create Company Profile first");
      return;
    }
    try {
      // Save factory_details and warehouse_locations to factory_profile table
      // The payload already includes factory_details and warehouse_locations arrays
      // along with logistics, shipping, payment, and refund data
      
      let response;
      if (factoryId || factoryIdRef.current) {
        // Update existing factory profile using company_id
        response = await CommonService.put(`/profile/company/${idNow}/factory`, payload);
        if (response && response.success) {
          toast.success(response.message || 'Factory details updated successfully');
          setIsFactoryDetailsSaved(true);
          return factoryId || factoryIdRef.current;
        } else {
          toast.error("Factory Profile update failed");
          setIsFactoryDetailsSaved(false);
          return null;
        }
      } else {
        // Create new factory profile
        response = await CommonService.post(`/profile/company/${idNow}/factory`, payload);
        if (response && response.success) {
          const newFactoryId = response.data?.factory_id || response.data?.id || null;
          if (newFactoryId) {
            setFactoryIdState(newFactoryId);
            factoryIdRef.current = newFactoryId;
          }
          toast.success(response.message || 'Factory details saved successfully');
          setIsFactoryDetailsSaved(true);
          return newFactoryId;
        } else {
          toast.error("Factory Profile creation failed");
          setIsFactoryDetailsSaved(false);
          return null;
        }
      }
    } catch (err) {
      console.log('Factory save error:', err);
      console.log('Error response:', err?.response?.data);
      
      // Show detailed validation errors
      if (err?.response?.data?.errors && Array.isArray(err.response.data.errors)) {
        toast.error(`Validation failed: ${err.response.data.errors.join(', ')}`);
      } else {
        const message = err?.response?.data?.message || "Factory Profile operation failed. Please try again.";
        toast.error(message);
      }
      setIsFactoryDetailsSaved(false);
      return null;
    }
  }

  // quality
  function buildQualityPayload() {
    // Filter and map certificates - only include certificates with all required fields
    const validCertificates = certificatesList
      .filter(cert => 
        cert.certificateTitle && cert.certificateTitle.trim() !== '' &&
        cert.certificationCompany && cert.certificationCompany.trim() !== '' &&
        cert.certificateStartDate && cert.certificateStartDate.trim() !== '' &&
        cert.certificateEndDate && cert.certificateEndDate.trim() !== ''
      )
      .map(cert => {
        // Ensure dates are in ISO format (YYYY-MM-DD)
        const dateIssued = cert.certificateStartDate ? new Date(cert.certificateStartDate).toISOString().split('T')[0] : cert.certificateStartDate;
        const expiryDate = cert.certificateEndDate ? new Date(cert.certificateEndDate).toISOString().split('T')[0] : cert.certificateEndDate;
        
        return {
          name: cert.certificateTitle.trim(),
          issuer: cert.certificationCompany.trim(),
          date_issued: dateIssued,
          expiry_date: expiryDate,
          certificate_number: cert.certificateDetails && cert.certificateDetails.trim() !== '' ? cert.certificateDetails.trim() : undefined,
          attachment_path: cert.certificateAttachmentUrl && cert.certificateAttachmentUrl.trim() !== '' ? cert.certificateAttachmentUrl.trim() : undefined,
          status: "ACTIVE"
        };
      });

    const payload = {
      // 1️⃣ QUALITY PROCESS (UI ORDER)
      quality_process_description: form.qualityControlProcess && form.qualityControlProcess.trim() !== '' ? form.qualityControlProcess.trim() : "",
    };

    // 2️⃣ CERTIFICATES (supports multiple) - only include if we have valid certificates
    // Backend expects array or undefined (optional field)
    if (validCertificates.length > 0) {
      payload.quality_certifications = validCertificates;
    }
    // If no valid certificates, don't include the field (backend will handle it)

    console.log('Quality payload built:', payload);
    return payload;
  }
  const saveQualityDetails = async () => {
    const payload = buildQualityPayload();
    console.log("Quality payload:", payload);
    const idNow = companyIdRef.current;
    if (!idNow) {
      toast.error("Please Create Company Profile first");
      return;
    }
    try {
      let response;
      if (qualityId || qualityIdRef.current) {
        // Update existing quality profile
        const qualityIdToUse = qualityId || qualityIdRef.current;
        response = await CommonService.put(`/profile/quality/${qualityIdToUse}`, payload);
        if (response && response.success) {
          toast.success(response.message || 'Quality details updated successfully');
          setIsQualityDetailsSaved(true);
          return qualityIdToUse;
        } else {
          toast.error("Quality Profile update failed");
          setIsQualityDetailsSaved(false);
          return null;
        }
      } else {
        // Create new quality profile
        response = await CommonService.post(`/profile/company/${idNow}/quality`, payload);
        if (response && response.success) {
          const newQualityId = response.data?.quality_id || response.data?.qualityId || response.data?.id || null;
          if (newQualityId) {
            setQualityIdState(newQualityId);
            qualityIdRef.current = newQualityId;
          }
          toast.success(response.message || 'Quality details saved successfully');
          setIsQualityDetailsSaved(true);
          return newQualityId;
        } else {
          toast.error("Quality Profile creation failed");
          setIsQualityDetailsSaved(false);
          return null;
        }
      }
    } catch (err) {
      console.log('Quality save error:', err);
      console.log('Error response:', err?.response?.data);
      if (err?.response?.data?.errors && Array.isArray(err.response.data.errors)) {
        toast.error(`Validation failed: ${err.response.data.errors.join(', ')}`);
      } else {
        const message = err?.response?.data?.message || "Quality Profile operation failed. Please try again.";
        toast.error(message);
      }
      setIsQualityDetailsSaved(false);
      return null;
    }
  }

  // Load existing quality details
  // Load existing product details from product_profile table
  const loadProductDetails = async (companyIdToLoad) => {
    const idNow = companyIdToLoad || companyIdRef.current;
    if (!idNow) return;
    
    try {
      const response = await CommonService.get(`/profile/company/${idNow}/products`);
      if (response && response.success && response.data) {
        const products = Array.isArray(response.data) ? response.data : [response.data];
        
        if (products.length > 0) {
          // Map backend products to frontend format
          console.log('Products loaded from backend:', products.map(p => ({
            id: p.product_id || p.id,
            name: p.name || p.product_name,
            dimensions: p.dimensions,
            dimensions_list: p.dimensions_list,
            dimensions_type: typeof p.dimensions,
            dimensions_list_type: Array.isArray(p.dimensions_list) ? 'array' : typeof p.dimensions_list
          })));
          
          const mappedProducts = products.map(product => ({
            id: product.product_id?.toString() || product.id?.toString() || Date.now().toString(),
            // Check both backend field names (name, category_id) and frontend field names (pd_name, pd_cat)
            // Prefer non-empty values - check name field first as backend returns it
            pd_name: (product.name && typeof product.name === 'string' && product.name.trim()) 
              || (product.pd_name && typeof product.pd_name === 'string' && product.pd_name.trim()) 
              || '',
            // Also preserve the original name field for reference
            name: product.name || product.pd_name || '',
            pd_brand: (product.brand && typeof product.brand === 'string' && product.brand.trim()) 
              || (product.pd_brand && typeof product.pd_brand === 'string' && product.pd_brand.trim()) 
              || '',
            // For category: prioritize category_id from backend, then pd_cat, and preserve both
            pd_cat: (product.category_id ? String(product.category_id) : '') 
              || (product.pd_cat && String(product.pd_cat).trim()) 
              || '',
            // Also preserve category_id for reference
            category_id: product.category_id ? String(product.category_id) : (product.pd_cat ? String(product.pd_cat) : undefined),
            // For subcategory: prioritize subcategory_id from backend, then pd_subcat, and preserve both
            pd_subcat: (product.subcategory_id ? String(product.subcategory_id) : '') 
              || (product.pd_subcat && String(product.pd_subcat).trim()) 
              || '',
            // Also preserve subcategory_id for reference
            subcategory_id: product.subcategory_id ? String(product.subcategory_id) : (product.pd_subcat ? String(product.pd_subcat) : undefined),
            // For sub-subcategory: prioritize sub_subcategory_id from backend, then pd_subsubcat, and preserve both
            pd_subsubcat: (product.sub_subcategory_id ? String(product.sub_subcategory_id) : '') 
              || (product.pd_subsubcat && String(product.pd_subsubcat).trim()) 
              || '',
            // Also preserve sub_subcategory_id for reference
            sub_subcategory_id: product.sub_subcategory_id ? String(product.sub_subcategory_id) : (product.pd_subsubcat ? String(product.pd_subsubcat) : undefined),
            pd_model: product.model_number || '',
            pd_hsn: product.hsn_code || '',
            pd_taxcode: product.tax_code || '',
            pd_desc: product.description || '',
            keywords: Array.isArray(product.keywords) ? product.keywords : (product.keywords ? [product.keywords] : []),
            pd_main_product: product.main_products || false,
            pd_catalogue_path: product.product_catalogue || '',
            pd_video_path: product.product_video || '',
            pd_images_paths: Array.isArray(product.product_images) ? product.product_images : (product.product_images ? [product.product_images] : []),
            carousel_images: Array.isArray(product.carousel_images) ? product.carousel_images : (product.carousel_images ? [product.carousel_images] : []),
            // Extract carousel enabled from carousel_slider JSON field or fallback to carousel_slider_enabled
            carouselEnabled: (() => {
              // Check if carousel_slider is an object with enabled property
              if (product.carousel_slider && typeof product.carousel_slider === 'object' && !Array.isArray(product.carousel_slider) && 'enabled' in product.carousel_slider) {
                return !!product.carousel_slider.enabled;
              }
              // Fallback to carousel_slider_enabled field if it exists
              if (product.carousel_slider_enabled !== undefined) {
                return !!product.carousel_slider_enabled;
              }
              return false;
            })(),
            // MOQ - Backend may return moq as number or object
            moq_min: product.moq?.min_quantity || (typeof product.moq === 'number' ? product.moq : '') || '',
            moq_uom: product.moq?.unit_of_measurement || product.moq_unit_of_measurement || product.moq_unit_of_measurements || '',
            moq_price_tax: product.moq?.price_with_tax || product.price_with_tax || '',
            moq_price_notax: product.moq?.price_without_tax || product.price_without_tax || '',
            moq_tax: product.moq?.tax_percentage || product.moq_tax_percentage || product.tax_percentage || '',
            moq_currency: product.moq?.currency || product.currency || '',
            // Dimensions - preserve both legacy fields and new structure
            pd_height: product.dimensions?.height || '',
            pd_length: product.dimensions?.length || '',
            pd_width: product.dimensions?.width || '',
            pd_uom: product.dimensions?.unit || '',
            // Preserve dimensions and dimensions_list for "Add More" functionality
            dimensions: product.dimensions || undefined,
            dimensions_list: product.dimensions_list || undefined,
            // Inventory Details
            inv_qty: product.inventory_details?.available_quantity || '',
            inv_uom: product.inventory_details?.unit_of_measurement || '',
            inv_status: product.inventory_details?.status || '',
            inv_location: product.inventory_details?.stock_location || '',
            // Lead Time
            lead_days: product.lead_time?.lead_time_days || '',
            lead_min: product.lead_time?.min_quantity || '',
            lead_max: product.lead_time?.max_quantity || '',
            // Packaging Details
            unitsPerCarton: product.packaging_details?.units_per_carton || '',
            grossWeight: product.packaging_details?.gross_weight?.value || '',
            grossWeight_unit: product.packaging_details?.gross_weight?.unit || '',
            netWeight: product.packaging_details?.net_weight?.value || '',
            netWeight_unit: product.packaging_details?.net_weight?.unit || '',
            // Extract packing materials - handle array and string
            packingMaterials: (() => {
              const materials = product.packaging_details?.packing_materials;
              console.log('Loading packing materials:', { materials, type: typeof materials, isArray: Array.isArray(materials), full_packaging_details: product.packaging_details });
              if (Array.isArray(materials) && materials.length > 0) {
                return materials[0]; // Get first material
              }
              if (typeof materials === 'string' && materials.trim()) {
                return materials.trim();
              }
              return '';
            })(),
            // Extract packing type
            packingType: (() => {
              const type = product.packaging_details?.packing_type;
              console.log('Loading packing type:', { type, type_of: typeof type, full_packaging_details: product.packaging_details });
              if (type && typeof type === 'string' && type.trim()) {
                return type.trim();
              }
              return '';
            })(),
            // Extract labelling - treat as string map value (not boolean)
            labelling: (() => {
              const label = product.packaging_details?.labeling;
              console.log('Loading labelling:', { 
                label, 
                type: typeof label, 
                full_packaging_details: product.packaging_details,
                has_labeling: 'labeling' in (product.packaging_details || {}),
                packaging_details_keys: product.packaging_details ? Object.keys(product.packaging_details) : []
              });
              // Return as string value (map value from Select)
              if (label !== undefined && label !== null) {
                if (typeof label === 'string' && label.trim()) {
                  return label.trim();
                }
                // Handle legacy boolean values - convert to string if needed
                if (typeof label === 'boolean') {
                  return label ? 'Yes' : 'No'; // Convert boolean to string representation
                }
                // Handle number/string conversions
                if (label === 'true' || label === true || label === 1 || label === '1') return 'Yes';
                if (label === 'false' || label === false || label === 0 || label === '0') return 'No';
              }
              // If labeling field doesn't exist or is undefined, return empty string
              return ''; // Return empty string if not found
            })(),
            // Bulk Discount Slabs
            bulkDiscountSlabs: product.bulk_discount_slabs || [],
            // Other attributes
            pd_attr: product.other_attributes?.[0]?.attribute_name || '',
            pd_attr_val: product.other_attributes?.[0]?.attribute_value || '',
            pd_attr_unit: product.other_attributes?.[0]?.unit || '',
            // Category-specific attributes - extract from nested attributes object
            // Electronics attributes
            elec_power: product.attributes?.electronics?.power || '',
            elec_current: product.attributes?.electronics?.current || '',
            elec_frequency: product.attributes?.electronics?.frequency || '',
            elec_battery: product.attributes?.electronics?.battery_capacity || '',
            elec_charging: product.attributes?.electronics?.charging_time || '',
            elec_connectivity: product.attributes?.electronics?.connectivity || '',
            elec_warranty: product.attributes?.electronics?.warranty || '',
            elec_country: product.attributes?.electronics?.country_of_origin || '',
            elec_compliance: product.attributes?.electronics?.compliance_certificate || '',
            // Shoes attributes
            shoes_size_system: product.attributes?.shoes?.size_system || '',
            shoes_size: product.attributes?.shoes?.size || '',
            shoes_upper_material: product.attributes?.shoes?.upper_material || '',
            shoes_insole_type: product.attributes?.shoes?.insole_type || '',
            shoes_waterproof: product.attributes?.shoes?.waterproof || '',
            shoes_safety_toe: product.attributes?.shoes?.safety_toe || '',
            shoes_arch_support: product.attributes?.shoes?.arch_support || false,
            shoes_esd_compliance: product.attributes?.shoes?.esd_compliance || false,
            // Tools attributes
            tool_type: product.attributes?.tools?.type || '',
            tool_material: product.attributes?.tools?.material || '',
            tool_handle_material: product.attributes?.tools?.handle_material || '',
            tool_grade: product.attributes?.tools?.grade || '',
            tool_power_source: product.attributes?.tools?.power_source || '',
            tool_voltage: product.attributes?.tools?.voltage || '',
            tool_rated_power: product.attributes?.tools?.rated_power || '',
            tool_torque: product.attributes?.tools?.torque || '',
            // Agricultural attributes
            agri_variety: product.attributes?.agricultural?.variety || '',
            agri_product_type: product.attributes?.agricultural?.product_type || '',
            agri_grade: product.attributes?.agricultural?.grade || '',
            agri_feature: product.attributes?.agricultural?.features || '',
            agri_packaging: product.attributes?.agricultural?.packaging || '',
            // Customization
            customization_available: normalizeCustomizationAvailable(product.customization_available),
            customization_types: normalizeCustomizationTypes(product.customization_types),
            customization_details: normalizeCustomizationDetails(product.customization_details),
            pd_custom_available: normalizeCustomizationAvailable(product.customization_available),
            pd_custom_type: mapCustomizationTypeForEditValue(
              normalizeCustomizationTypes(product.customization_types)[0] || '',
              customizationTypesOptions,
            ),
            // Preserve all other fields from backend
            // BUT exclude fields we've already explicitly mapped to avoid overwriting with empty values
            // Also exclude 'attributes' as it's not allowed in the save payload
            ...Object.fromEntries(
              Object.entries(product).filter(([key]) => 
                !['pd_name', 'pd_brand', 'pd_cat', 'pd_subcat', 'pd_subsubcat', 'name', 'brand', 'category_id', 'subcategory_id', 'sub_subcategory_id', 'attributes'].includes(key)
              )
            )
          }));
          
          setSavedProducts(mappedProducts);
        }
      }
    } catch (err) {
      console.log('No existing product details found or error loading products:', err);
      // Don't show error toast as this is expected for new users
    }
  };

  const loadQualityDetails = async (companyIdToLoad) => {
    const idNow = companyIdToLoad || companyIdRef.current;
    if (!idNow) return;
    
    try {
      const response = await CommonService.get(`/profile/company/${idNow}/quality`);
      if (response && response.success && response.data) {
        // Handle both single object and array response
        const qualityDataArray = Array.isArray(response.data) ? response.data : [response.data];
        
        if (qualityDataArray.length > 0) {
          // Use the first quality profile (there should typically be one per company)
          const qualityData = qualityDataArray[0];
          
          // Set quality ID
          if (qualityData.quality_id) {
            setQualityIdState(qualityData.quality_id);
            qualityIdRef.current = qualityData.quality_id;
          }
          
          // Set quality control process
          if (qualityData.quality_process_description) {
            setForm(prev => ({
              ...prev,
              qualityControlProcess: qualityData.quality_process_description
            }));
          }
          
          // Load certificates
          if (qualityData.quality_certifications && Array.isArray(qualityData.quality_certifications) && qualityData.quality_certifications.length > 0) {
            const mappedCertificates = qualityData.quality_certifications.map(cert => ({
              certificateTitle: cert.name || cert.title || '',
              certificationCompany: cert.issuer || '',
              certificateStartDate: cert.date_issued || '',
              certificateEndDate: cert.expiry_date || '',
              certificateDetails: cert.certificate_number || cert.details || '',
              certificateAttachmentUrl: cert.attachment_path || cert.attachment_url || ''
            }));
            
            setCertificatesList(mappedCertificates.length > 0 ? mappedCertificates : [{
              certificateTitle: '',
              certificationCompany: '',
              certificateStartDate: '',
              certificateEndDate: '',
              certificateDetails: '',
              certificateAttachmentUrl: ''
            }]);
          } else {
            // If no certificates, ensure at least one empty entry
            setCertificatesList([{
              certificateTitle: '',
              certificationCompany: '',
              certificateStartDate: '',
              certificateEndDate: '',
              certificateDetails: '',
              certificateAttachmentUrl: ''
            }]);
          }
          
          setIsQualityDetailsSaved(true);
        } else {
          // No quality data found, initialize with empty certificate list
          setCertificatesList([{
            certificateTitle: '',
            certificationCompany: '',
            certificateStartDate: '',
            certificateEndDate: '',
            certificateDetails: '',
            certificateAttachmentUrl: ''
          }]);
          setIsQualityDetailsSaved(false);
        }
      }
    } catch (err) {
      console.log('No existing quality details found or error loading quality:', err);
      // Don't show error toast as this is expected for new users
      setIsQualityDetailsSaved(false);
      // Initialize with empty certificate list
      setCertificatesList([{
        certificateTitle: '',
        certificationCompany: '',
        certificateStartDate: '',
        certificateEndDate: '',
        certificateDetails: '',
        certificateAttachmentUrl: ''
      }]);
    }
  }

  //product
  function prepareProductFormData(form = {}, extras = {}, files = {}) {
    // ---------- Product Details (UI order) ----------
    const payload = {};

    Object.assign(
      payload,
      pickDefined({
        // Product Details section (top)
        name: form.pd_name,
        brand: form.pd_brand,
        // Ensure category IDs are always strings (backend validation requires strings, not numbers)
        // Convert to string explicitly and ensure it's not a number
        category_id: (() => {
          const val = form.pd_cat;
          if (val === undefined || val === null || val === '') return undefined;
          const strVal = String(val).trim();
          // Ensure it's a string, not a number
          return strVal !== '' ? strVal : undefined;
        })(),
        subcategory_id: (() => {
          const val = form.pd_subcat;
          if (val === undefined || val === null || val === '') return undefined;
          const strVal = String(val).trim();
          return strVal !== '' ? strVal : undefined;
        })(),
        sub_subcategory_id: (() => {
          const val = form.pd_subsubcat;
          if (val === undefined || val === null || val === '') return undefined;
          const strVal = String(val).trim();
          return strVal !== '' ? strVal : undefined;
        })(),
        model_number: form.pd_model,
        hsn_code: form.pd_hsn,
        tax_code: form.pd_taxcode,
        description: form.pd_desc,
        keywords: extras.keywords || form.pd_keywords,
        main_products: (() => {
          // main_products should be an array of product names/strings
          if (Array.isArray(extras.mainProducts)) {
            return extras.mainProducts.filter(p => p && typeof p === 'string');
          }
          if (extras.mainProducts && typeof extras.mainProducts === 'string') {
            return [extras.mainProducts];
          }
          if (form.pd_main_product && typeof form.pd_main_product === 'string') {
            return [form.pd_main_product];
          }
          // Use products state if available (array of product names)
          if (Array.isArray(products) && products.length > 0) {
            return products.filter(p => p && typeof p === 'string');
          }
          return [];
        })(),
        product_catalogue: productCatalogueUrl || form.pd_catalogue_path || form.product_catalogue, // string path if already uploaded
        product_video: productVideoUrl || form.pd_video_path || form.product_video,
        product_images: productImageUrls.length > 0 ? productImageUrls : (form.pd_images_paths || form.product_images || []),
        carousel_images: carouselImageUrls && carouselImageUrls.length > 0 ? carouselImageUrls : (extras.carouselFilesMeta || form.carousel_images),
        colour_options: form.pd_colour_options || undefined,
        // customization_available must always be a boolean (true or false), not undefined
        customization_available: typeof form.pd_custom_available === 'boolean' ? form.pd_custom_available : !!form.pd_custom_available,
        customization_types: (() => {
          if (!form.pd_custom_available) return undefined;
          const customTypeValue = form.pd_custom_type || (extras.customization_types && extras.customization_types[0]);
          const backendEnum = resolveCustomizationBackendEnum(customTypeValue, customizationTypesOptions);
          return backendEnum ? [backendEnum] : undefined;
        })(),
        customization_details: form.pd_custom_available
          ? buildCustomizationDetailsPayload(extras.customizationRows || [])
          : undefined,
      })
    );

    // ---------- Add Attributes ----------
    if (!isEmpty(form.pd_attr) || !isEmpty(form.pd_attr_val)) {
      payload.other_attributes = payload.other_attributes || [];
      payload.other_attributes.push(
        pickDefined({
          attribute_name: form.pd_attr,
          attribute_value: form.pd_attr_val,
          unit: form.pd_attr_unit
        })
      );
    }

    // ---------- Colour Options ----------
    if (colourOptionsList && colourOptionsList.length > 0) {
      const validColours = colourOptionsList
        .filter(opt => {
          // Only include options that have a color value (required by backend)
          // Color is required, image is optional
          const colorValue = opt.color && typeof opt.color === 'string' ? opt.color.trim() : '';
          return colorValue && colorValue.length > 0; // Must have a non-empty color value
        })
        .map(opt => {
          const colorValue = opt.color && typeof opt.color === 'string' ? opt.color.trim() : '';
          // Backend requires 'name' field (string), 'hex_code' (optional string), 'image_url' (optional string)
          // 'name' should be the color name/hex code, 'hex_code' should be the hex code
          const hexCode = colorValue.startsWith('#') ? colorValue : undefined;
          return pickDefined({
            name: colorValue, // Backend requires 'name' field - use color value (required)
            hex_code: hexCode, // Optional: only set if it's a hex code (starts with #)
            image_url: opt.imageUrl && typeof opt.imageUrl === 'string' && opt.imageUrl.trim() ? opt.imageUrl.trim() : undefined
          });
        })
        .filter(opt => opt && opt.name); // Only include options with a name (required by backend)
      
      if (validColours.length > 0) {
        payload.colour_options = validColours;
        console.log('Colour options being saved:', validColours);
      } else {
        console.log('No valid colour options to save. colourOptionsList:', colourOptionsList);
      }
    } else {
      console.log('No colour options in list');
    }

    // ---------- Dimensions ----------
    if (dimensionsList && dimensionsList.length > 0) {
      const validDims = dimensionsList
        .filter(dim => dim.height || dim.length || dim.width)
        .map(dim => {
          const parsed = pickDefined({
            height: dim.height ? parseFloat(dim.height) : undefined,
            length: dim.length ? parseFloat(dim.length) : undefined,
            width: dim.width ? parseFloat(dim.width) : undefined,
            unit: dim.uom && typeof dim.uom === 'string' && dim.uom.trim() ? dim.uom.trim() : undefined
          });
          // Only include if at least one dimension value is valid
          return (parsed && (parsed.height || parsed.length || parsed.width)) ? parsed : null;
        })
        .filter(dim => dim !== null);
      if (validDims.length > 0) {
        // Single dimension - send as object (not array)
        if (validDims.length === 1) {
          payload.dimensions = validDims[0];
        } else {
          // Multiple dimensions - send as dimensions_list array
          payload.dimensions_list = validDims;
        }
      }
    } else {
      // Fallback to form fields for backward compatibility
      const dims = pickDefined({
        height: form.pd_height ? parseFloat(form.pd_height) : undefined,
        length: form.pd_length ? parseFloat(form.pd_length) : undefined,
        width: form.pd_width ? parseFloat(form.pd_width) : undefined,
        unit: form.pd_uom && typeof form.pd_uom === 'string' && form.pd_uom.trim() ? form.pd_uom.trim() : undefined
      });
      if (dims && (dims.height || dims.length || dims.width) && dims.unit) {
        payload.dimensions = dims;
      }
    }

    // ---------- Category-specific Attributes (examples) ----------
    const attributes = {};

    // Electronics example - check if category is electronics-related
    const selectedCategory = categoryData.find(c => String(c.id) === String(form.pd_cat));
    const isElectronics = selectedCategory && isElectronicsCategory(form.pd_cat);
    if (isElectronics) {
      attributes.electronics = pickDefined({
        power: form.elec_power,
        current: form.elec_current,
        frequency: form.elec_frequency,
        battery_capacity: form.elec_battery,
        charging_time: form.elec_charging,
        connectivity: form.elec_connectivity,
        warranty: form.elec_warranty,
        country_of_origin: form.elec_country,
        compliance_certificate: form.elec_compliance
      });
    }

    // Shoes example - check by category name
    const selectedCategoryName = selectedCategory?.name?.toLowerCase() || '';
    if (selectedCategoryName.includes('shoes') || selectedCategoryName.includes('shoe')) {
      attributes.shoes = pickDefined({
        size_system: form.shoes_size_system,
        size: form.shoes_size,
        upper_material: form.shoes_upper_material,
        insole_type: form.shoes_insole_type,
        waterproof: form.shoes_waterproof,
        safety_toe: form.shoes_safety_toe,
        arch_support: !!form.shoes_arch_support,
        esd_compliance: !!form.shoes_esd_compliance
      });
    }

    // Tools example - check by category name
    if (selectedCategoryName.includes('tools') || selectedCategoryName.includes('tool')) {
      attributes.tools = pickDefined({
        type: form.tool_type,
        material: form.tool_material,
        handle_material: form.tool_handle_material,
        grade: form.tool_grade,
        power_source: form.tool_power_source,
        voltage: form.tool_voltage,
        rated_power: form.tool_rated_power,
        torque: form.tool_torque
      });
    }

    // Agricultural products example - check by category name
    if (selectedCategoryName.includes('agricultural') || selectedCategoryName.includes('agriculture')) {
      attributes.agricultural = pickDefined({
        variety: form.agri_variety,
        product_type: form.agri_product_type,
        grade: form.agri_grade,
        features: form.agri_feature,
        packaging: form.agri_packaging
      });
    }

    // Note: 'attributes' field is not allowed by backend validation schema
    // Category-specific attributes are handled separately if needed
    // if (Object.keys(attributes).length) payload.attributes = cleanObjectDeep(attributes);

    // ---------- MOQ ----------
    // Backend expects: moq (number), moq_unit_of_measurements (string), price_without_tax (number), price_with_tax (number), tax_percentage (number), currency (string)
    if (form.moq_min) {
      payload.moq = parseNumber(form.moq_min) || undefined;
    }
    if (form.moq_uom) {
      // Handle both string values and Select option objects/numeric indices
      let unitValue = form.moq_uom;
      
      // Handle Select option object
      if (unitValue && typeof unitValue === 'object' && unitValue.value) {
        unitValue = unitValue.value;
      }
      
      // Handle numeric value - look up in dimensionUnitOptions
      if (typeof unitValue === 'number' && dimensionUnitOptions && Array.isArray(dimensionUnitOptions)) {
        const foundByValue = findOption(dimensionUnitOptions, unitValue, 'value');
        if (foundByValue) {
          if (foundByValue.value && typeof foundByValue.value === 'string') {
            unitValue = foundByValue.value;
          } else if (foundByValue.label && typeof foundByValue.label === 'string') {
            unitValue = foundByValue.label;
          } else if (foundByValue.value) {
            unitValue = String(foundByValue.value);
          }
        } else {
          const optionAtIndex = dimensionUnitOptions[unitValue];
          if (optionAtIndex) {
            if (typeof optionAtIndex === 'object' && optionAtIndex.value && typeof optionAtIndex.value === 'string') {
              unitValue = optionAtIndex.value;
            } else if (typeof optionAtIndex === 'object' && optionAtIndex.label && typeof optionAtIndex.label === 'string') {
              unitValue = optionAtIndex.label;
            } else if (typeof optionAtIndex === 'string') {
              unitValue = optionAtIndex;
            }
          }
        }
      }
      
      const unitStr = typeof unitValue === 'string' ? unitValue.trim() : String(unitValue).trim();
      if (unitStr && unitStr !== '') {
        payload.moq_unit_of_measurement = unitStr;
        payload.moq_unit_of_measurements = unitStr; // Also set for backward compatibility
      }
    }
    if (form.moq_price_notax) {
      payload.price_without_tax = parseNumber(form.moq_price_notax) || undefined;
    }
    // Calculate Price With Tax if not already set
    if (form.moq_price_notax && form.moq_tax) {
      const priceWithoutTax = parseFloat(form.moq_price_notax) || 0;
      const taxPercent = parseFloat(form.moq_tax) || 0;
      const calculatedPriceWithTax = priceWithoutTax * (1 + taxPercent / 100);
      payload.price_with_tax = calculatedPriceWithTax;
    } else if (form.moq_price_tax) {
      payload.price_with_tax = parseNumber(form.moq_price_tax) || undefined;
    }
    if (form.moq_tax) {
      payload.moq_tax_percentage = parseNumber(form.moq_tax) || undefined;
      // Also set tax_percentage for backward compatibility if needed
      payload.tax_percentage = parseNumber(form.moq_tax) || undefined;
    }
    if (form.moq_currency) {
      payload.currency = typeof form.moq_currency === 'string' ? form.moq_currency.trim() : String(form.moq_currency || '');
    }

    // ---------- Packaging Details ----------
    // Extract packing materials - handle Select option objects and numeric values
    let packingMaterialsValue = form.packingMaterials;
    if (packingMaterialsValue && typeof packingMaterialsValue === 'object' && packingMaterialsValue.value) {
      packingMaterialsValue = packingMaterialsValue.value;
    }
    // Handle numeric value - look up in packagingMaterialsOptions
    if (typeof packingMaterialsValue === 'number' && packagingMaterialsOptions && Array.isArray(packagingMaterialsOptions)) {
      const foundByValue = findOption(packagingMaterialsOptions, packingMaterialsValue, 'value');
      if (foundByValue && foundByValue.value && typeof foundByValue.value === 'string') {
        packingMaterialsValue = foundByValue.value;
      } else if (foundByValue && foundByValue.label && typeof foundByValue.label === 'string') {
        packingMaterialsValue = foundByValue.label;
      }
    }
    const packingMaterialsStr = packingMaterialsValue && typeof packingMaterialsValue === 'string' && packingMaterialsValue.trim() 
      ? packingMaterialsValue.trim() 
      : undefined;
    
    // Extract packing type - handle Select option objects and numeric values
    let packingTypeValue = form.packingType;
    if (packingTypeValue && typeof packingTypeValue === 'object' && packingTypeValue.value) {
      packingTypeValue = packingTypeValue.value;
    }
    // Handle numeric value - look up in packingTypesOptions
    if (typeof packingTypeValue === 'number' && packingTypesOptions && Array.isArray(packingTypesOptions)) {
      const foundByValue = findOption(packingTypesOptions, packingTypeValue, 'value');
      if (foundByValue && foundByValue.value && typeof foundByValue.value === 'string') {
        packingTypeValue = foundByValue.value;
      } else if (foundByValue && foundByValue.label && typeof foundByValue.label === 'string') {
        packingTypeValue = foundByValue.label;
      }
    }
    const packingTypeStr = packingTypeValue && typeof packingTypeValue === 'string' && packingTypeValue.trim() 
      ? packingTypeValue.trim() 
      : undefined;
    
    // Extract labelling - handle Select option objects and numeric values (treat as string map value)
    let labellingValue = form.labelling;
    console.log('Extracting labelling value:', { 
      form_labelling: form.labelling, 
      type: typeof form.labelling,
      labellingOptions: labellingOptions?.map(opt => ({ value: opt.value, label: opt.label }))
    });
    
    if (labellingValue && typeof labellingValue === 'object' && labellingValue.value !== undefined) {
      labellingValue = labellingValue.value;
      console.log('Extracted from object:', labellingValue);
    }
    // Handle numeric value - look up in labellingOptions
    if (typeof labellingValue === 'number' && labellingOptions && Array.isArray(labellingOptions)) {
      const foundByValue = findOption(labellingOptions, labellingValue, 'value');
      if (foundByValue && foundByValue.value !== undefined) {
        labellingValue = foundByValue.value;
        console.log('Found by numeric value:', labellingValue);
      } else if (foundByValue && foundByValue.label && typeof foundByValue.label === 'string') {
        labellingValue = foundByValue.label;
        console.log('Found by label:', labellingValue);
      }
    }
    // Keep as string (map value), not boolean - ensure we handle empty strings correctly
    let labellingStr;
    if (labellingValue !== undefined && labellingValue !== null && labellingValue !== '') {
      if (typeof labellingValue === 'string' && labellingValue.trim()) {
        labellingStr = labellingValue.trim();
      } else if (typeof labellingValue === 'string') {
        // Empty string after trim - don't include
        labellingStr = undefined;
      } else {
        // Convert to string if it's not already
        labellingStr = String(labellingValue).trim() || undefined;
      }
    } else {
      labellingStr = undefined;
    }
    console.log('Final labellingStr:', { labellingStr, type: typeof labellingStr });
    
    // Build packaging_details object - ensure labeling is included if it has a value
    const packagingDetailsObj = {
      units_per_carton: form.unitsPerCarton ? parseInt(form.unitsPerCarton) : undefined,
      gross_weight: !isEmpty(form.grossWeight) ? { 
        value: parseNumber(form.grossWeight), 
        unit: form.grossWeight_unit || undefined 
      } : undefined,
      net_weight: !isEmpty(form.netWeight) ? { 
        value: parseNumber(form.netWeight), 
        unit: form.netWeight_unit || undefined 
      } : undefined,
      packing_materials: packingMaterialsStr ? [packingMaterialsStr] : undefined,
      packing_type: packingTypeStr,
      labeling: labellingStr // Save as string (map value), not boolean
    };
    
    // Use pickDefined but explicitly preserve labeling if it has a value
    payload.packaging_details = pickDefined(packagingDetailsObj);
    
    // Explicitly add labeling if it was filtered out but has a value
    if (labellingStr && labellingStr.trim() && (!payload.packaging_details || !payload.packaging_details.labeling)) {
      if (!payload.packaging_details) {
        payload.packaging_details = {};
      }
      payload.packaging_details.labeling = labellingStr;
      console.log('Explicitly added labeling to packaging_details:', labellingStr);
    }
    
    // Debug log to verify packaging_details are being saved
    if (payload.packaging_details) {
      console.log('Packaging details being saved:', JSON.stringify(payload.packaging_details, null, 2));
      console.log('Packaging details - labeling field:', {
        labeling: payload.packaging_details.labeling,
        labeling_type: typeof payload.packaging_details.labeling,
        has_labeling: 'labeling' in payload.packaging_details,
        labellingStr: labellingStr,
        form_labelling: form.labelling
      });
    }

    // ---------- Price Negotiable Above Tier 3 ----------
    if (form.isPriceNegotiableAboveTier3 !== undefined) {
      payload.is_price_negotiable_above_tier3 = !!form.isPriceNegotiableAboveTier3;
    }

    // ---------- Bulk Discount Slabs ----------
    const slabs =
      Array.isArray(extras.bulkDiscounts) && extras.bulkDiscounts.length
        ? extras.bulkDiscounts
          .filter((s) => {
            const minUnits = s.min_units || s.bulk_min;
            const maxUnits = s.max_units || s.bulk_max;
            // Backend requires min_units and max_units, and max_units > min_units
            if (!minUnits || !maxUnits) return false;
            const min = parseInt(minUnits);
            const max = parseInt(maxUnits);
            return !isNaN(min) && !isNaN(max) && min >= 1 && max > min;
          })
          .map((s) => {
            const minUnits = parseInt(s.min_units || s.bulk_min);
            const maxUnits = parseInt(s.max_units || s.bulk_max);
            // Calculate Price With Tax if not already set
            const priceWithoutTax = s.price_without_tax || s.bulk_price_no ? parseNumber(s.price_without_tax || s.bulk_price_no) : undefined;
            const taxPercent = s.tax_percentage || s.bulk_tax ? parseNumber(s.tax_percentage || s.bulk_tax) : undefined;
            let priceWithTax = s.price_with_tax || s.bulk_price_with ? parseNumber(s.price_with_tax || s.bulk_price_with) : undefined;
            
            // Auto-calculate if price without tax and tax percentage are available
            if (priceWithoutTax && taxPercent && !priceWithTax) {
              priceWithTax = priceWithoutTax * (1 + taxPercent / 100);
            }
            
            // Extract unit_of_measurements - handle Select option objects and numeric values
            let unitValue = s.unit_of_measurements || s.bulk_uom;
            if (unitValue && typeof unitValue === 'object' && unitValue.value) {
              unitValue = unitValue.value;
            }
            // Handle numeric value - look up in dimensionUnitOptions
            if (typeof unitValue === 'number' && dimensionUnitOptions && Array.isArray(dimensionUnitOptions)) {
              const foundByValue = findOption(dimensionUnitOptions, unitValue, 'value');
              if (foundByValue && foundByValue.value && typeof foundByValue.value === 'string') {
                unitValue = foundByValue.value;
              } else if (foundByValue && foundByValue.label && typeof foundByValue.label === 'string') {
                unitValue = foundByValue.label;
              } else {
                // Try to get by index
                const optionAtIndex = dimensionUnitOptions[unitValue];
                if (optionAtIndex) {
                  if (typeof optionAtIndex === 'object' && optionAtIndex.value && typeof optionAtIndex.value === 'string') {
                    unitValue = optionAtIndex.value;
                  } else if (typeof optionAtIndex === 'object' && optionAtIndex.label && typeof optionAtIndex.label === 'string') {
                    unitValue = optionAtIndex.label;
                  } else if (typeof optionAtIndex === 'string') {
                    unitValue = optionAtIndex;
                  }
                }
              }
            }
            const unitStr = unitValue && typeof unitValue === 'string' && unitValue.trim() 
              ? unitValue.trim() 
              : undefined;
            
            return pickDefined({
              min_units: minUnits,
              max_units: maxUnits,
              unit_of_measurements: unitStr,
              price_without_tax: priceWithoutTax,
              price_with_tax: priceWithTax,
              tax_percentage: taxPercent,
              currency: (s.currency || s.bulk_currency) ? (typeof (s.currency || s.bulk_currency) === 'string' ? (s.currency || s.bulk_currency).trim() : String(s.currency || s.bulk_currency || '')) : undefined,
              discount_percentage: s.discount_percentage ? parseNumber(s.discount_percentage) : undefined
            });
          })
        : !isEmpty(form.bulk_min) || !isEmpty(form.bulk_max)
          ? (() => {
            const minUnits = parseInt(form.bulk_min);
            const maxUnits = parseInt(form.bulk_max);
            if (isNaN(minUnits) || isNaN(maxUnits) || minUnits < 1 || maxUnits <= minUnits) {
              return undefined;
            }
            // Extract unit_of_measurements - handle Select option objects and numeric values
            let unitValue = form.bulk_uom;
            if (unitValue && typeof unitValue === 'object' && unitValue.value) {
              unitValue = unitValue.value;
            }
            // Handle numeric value - look up in dimensionUnitOptions
            if (typeof unitValue === 'number' && dimensionUnitOptions && Array.isArray(dimensionUnitOptions)) {
              const foundByValue = findOption(dimensionUnitOptions, unitValue, 'value');
              if (foundByValue && foundByValue.value && typeof foundByValue.value === 'string') {
                unitValue = foundByValue.value;
              } else if (foundByValue && foundByValue.label && typeof foundByValue.label === 'string') {
                unitValue = foundByValue.label;
              } else {
                // Try to get by index
                const optionAtIndex = dimensionUnitOptions[unitValue];
                if (optionAtIndex) {
                  if (typeof optionAtIndex === 'object' && optionAtIndex.value && typeof optionAtIndex.value === 'string') {
                    unitValue = optionAtIndex.value;
                  } else if (typeof optionAtIndex === 'object' && optionAtIndex.label && typeof optionAtIndex.label === 'string') {
                    unitValue = optionAtIndex.label;
                  } else if (typeof optionAtIndex === 'string') {
                    unitValue = optionAtIndex;
                  }
                }
              }
            }
            const unitStr = unitValue && typeof unitValue === 'string' && unitValue.trim() 
              ? unitValue.trim() 
              : undefined;
            
            return [
              pickDefined({
                min_units: minUnits,
                max_units: maxUnits,
                unit_of_measurements: unitStr,
                price_without_tax: form.bulk_price_no ? parseNumber(form.bulk_price_no) : undefined,
                price_with_tax: (form.bulk_price_no && form.bulk_tax) 
                  ? (parseNumber(form.bulk_price_no) * (1 + parseNumber(form.bulk_tax) / 100))
                  : (form.bulk_price_with ? parseNumber(form.bulk_price_with) : undefined),
                tax_percentage: form.bulk_tax ? parseNumber(form.bulk_tax) : undefined,
                currency: form.bulk_currency ? (typeof form.bulk_currency === 'string' ? form.bulk_currency.trim() : String(form.bulk_currency || '')) : undefined
              })
            ];
          })()
          : undefined;

    if (slabs && slabs.length > 0) {
      payload.bulk_discount_slabs = cleanObjectDeep(slabs);
    }

    // ---------- Colour Options ----------
    if (colourOptionsList && colourOptionsList.length > 0) {
      payload.colour_options = colourOptionsList
        .filter(opt => opt.color || opt.imageUrl)
        .map(opt => pickDefined({
          name: opt.color || 'Unnamed Color', // Backend requires 'name', not 'color'
          hex_code: opt.color && opt.color.startsWith('#') ? opt.color : undefined,
          image_url: opt.imageUrl || undefined
        }));
    }

    // ---------- Dimensions ----------
    if (dimensionsList && dimensionsList.length > 0) {
      const validDims = dimensionsList
        .filter(dim => {
          // Include if at least one dimension value (height, length, or width) is provided
          const hasHeight = dim.height && !isNaN(parseFloat(dim.height)) && parseFloat(dim.height) > 0;
          const hasLength = dim.length && !isNaN(parseFloat(dim.length)) && parseFloat(dim.length) > 0;
          const hasWidth = dim.width && !isNaN(parseFloat(dim.width)) && parseFloat(dim.width) > 0;
          return hasHeight || hasLength || hasWidth;
        })
        .map(dim => {
          const height = dim.height && !isNaN(parseFloat(dim.height)) && parseFloat(dim.height) > 0 ? parseFloat(dim.height) : undefined;
          const length = dim.length && !isNaN(parseFloat(dim.length)) && parseFloat(dim.length) > 0 ? parseFloat(dim.length) : undefined;
          const width = dim.width && !isNaN(parseFloat(dim.width)) && parseFloat(dim.width) > 0 ? parseFloat(dim.width) : undefined;
          // Extract unit - ensure it's a non-empty string
          // Handle string values, Select option objects, and numeric indices
          let unitValue = dim.uom;
          
          // Handle Select option object
          if (unitValue && typeof unitValue === 'object' && unitValue.value) {
            unitValue = unitValue.value;
          }
          
          // Handle numeric value - look up in dimensionUnitOptions using findOption helper
          if (typeof unitValue === 'number' && dimensionUnitOptions && Array.isArray(dimensionUnitOptions)) {
            // Try to find the option by value (if the number is the value itself)
            const foundByValue = findOption(dimensionUnitOptions, unitValue, 'value');
            if (foundByValue) {
              // Prefer value, but use label if value is still a number
              if (foundByValue.value && typeof foundByValue.value === 'string') {
                unitValue = foundByValue.value;
              } else if (foundByValue.label && typeof foundByValue.label === 'string') {
                unitValue = foundByValue.label;
              } else if (foundByValue.value) {
                // If value exists but is a number, convert to string
                unitValue = String(foundByValue.value);
              }
            } else {
              // Try as array index (0-based)
              const optionAtIndex = dimensionUnitOptions[unitValue];
              if (optionAtIndex) {
                if (typeof optionAtIndex === 'object') {
                  // Prefer string value, fallback to label, then convert to string
                  if (optionAtIndex.value && typeof optionAtIndex.value === 'string') {
                    unitValue = optionAtIndex.value;
                  } else if (optionAtIndex.label && typeof optionAtIndex.label === 'string') {
                    unitValue = optionAtIndex.label;
                  } else if (optionAtIndex.value) {
                    unitValue = String(optionAtIndex.value);
                  }
                } else if (typeof optionAtIndex === 'string') {
                  unitValue = optionAtIndex;
                }
              }
            }
          }
          
          // Convert to string and trim - ensure it's a valid non-empty string
          let unit = undefined;
          if (unitValue !== undefined && unitValue !== null && unitValue !== '') {
            const unitStr = typeof unitValue === 'string' ? unitValue.trim() : String(unitValue).trim();
            if (unitStr && unitStr !== '') {
              unit = unitStr;
            }
          }
          
          // Backend schema: height, length, width, unit are all optional
          // But we should include the dimension if at least one value is present
          // IMPORTANT: Always include unit if it has a value, even if other fields are missing
          const parsed = {};
          if (height !== undefined) parsed.height = height;
          if (length !== undefined) parsed.length = length;
          if (width !== undefined) parsed.width = width;
          if (unit !== undefined && unit !== '') parsed.unit = unit; // Always include unit if it has a value
          
          // Debug log to verify unit is being captured
          if (dim.uom) {
            console.log('Dimension unit extraction:', { 
              original: dim.uom, 
              type: typeof dim.uom, 
              extracted: unit,
              parsed: parsed 
            });
          }
          
          // Only include if at least one dimension value is present (height, length, or width)
          // Unit is optional but should be included if provided
          return (parsed && (parsed.height || parsed.length || parsed.width)) ? parsed : undefined;
        })
        .filter(dim => dim !== undefined);
      
      if (validDims.length > 0) {
        if (validDims.length === 1) {
          // Single dimension - send as object under 'dimensions'
          payload.dimensions = validDims[0];
          console.log('Dimensions being saved (single):', JSON.stringify(payload.dimensions, null, 2));
        } else {
          // Multiple dimensions - send as array under 'dimensions_list'
          payload.dimensions_list = validDims;
          console.log('Dimensions being saved (multiple):', JSON.stringify(payload.dimensions_list, null, 2));
        }
      } else {
        console.log('No valid dimensions to save. dimensionsList:', dimensionsList);
      }
    }

    // ---------- Inventory Details ----------
    if (inventoryDetailsList && inventoryDetailsList.length > 0) {
      const validInventory = inventoryDetailsList
        .filter(inv => inv.qty || inv.uom || inv.status || inv.location)
        .map(inv => {
          // Extract unit_of_measurement - handle Select option objects and numeric values
          let unitValue = inv.uom;
          console.log('Extracting inventory unit:', { 
            inventory_id: inv.id,
            original_uom: inv.uom, 
            type: typeof inv.uom 
          });
          
          if (unitValue && typeof unitValue === 'object' && unitValue.value) {
            unitValue = unitValue.value;
            console.log('Extracted from object:', unitValue);
          }
          
          // Handle numeric value - look up in dimensionUnitOptions
          if (typeof unitValue === 'number' && dimensionUnitOptions && Array.isArray(dimensionUnitOptions)) {
            const foundByValue = findOption(dimensionUnitOptions, unitValue, 'value');
            if (foundByValue && foundByValue.value && typeof foundByValue.value === 'string') {
              unitValue = foundByValue.value;
              console.log('Found by numeric value:', unitValue);
            } else if (foundByValue && foundByValue.label && typeof foundByValue.label === 'string') {
              unitValue = foundByValue.label;
              console.log('Found by label:', unitValue);
            } else {
              // Try to get by index
              const optionAtIndex = dimensionUnitOptions[unitValue];
              if (optionAtIndex) {
                if (typeof optionAtIndex === 'object' && optionAtIndex.value && typeof optionAtIndex.value === 'string') {
                  unitValue = optionAtIndex.value;
                } else if (typeof optionAtIndex === 'object' && optionAtIndex.label && typeof optionAtIndex.label === 'string') {
                  unitValue = optionAtIndex.label;
                } else if (typeof optionAtIndex === 'string') {
                  unitValue = optionAtIndex;
                }
                console.log('Found by index:', unitValue);
              }
            }
          }
          
          const unitStr = unitValue && typeof unitValue === 'string' && unitValue.trim() 
            ? unitValue.trim() 
            : undefined;
          
          console.log('Final inventory unit:', { 
            inventory_id: inv.id,
            unitStr, 
            type: typeof unitStr 
          });
          
          // Extract status - handle Select option objects and ensure it's a valid enum value
          let statusFinal = inv.status;
          console.log('Extracting inventory status:', { 
            inventory_id: inv.id,
            original_status: inv.status, 
            original_type: typeof inv.status,
            inventoryStatusOptions_available: !!inventoryStatusOptions,
            inventoryStatusOptions_count: inventoryStatusOptions?.length || 0
          });
          
          // Handle Select option objects (react-select returns { value, label } object)
          if (statusFinal && typeof statusFinal === 'object' && !Array.isArray(statusFinal)) {
            if (statusFinal.value !== undefined) {
              statusFinal = statusFinal.value;
              console.log('Extracted from Select option object:', { 
                original_object: inv.status,
                extracted_value: statusFinal,
                extracted_type: typeof statusFinal
              });
            } else {
              console.warn('Status is an object but has no value property:', { 
                inventory_id: inv.id,
                status_object: statusFinal
              });
              statusFinal = undefined;
            }
          }
          
          // If status is empty string, null, or undefined, skip processing
          if (!statusFinal || statusFinal === '' || statusFinal === null || statusFinal === undefined) {
            console.log('Status is empty, skipping processing:', { inventory_id: inv.id, original: inv.status });
            statusFinal = undefined;
          } else {
              console.log('Status value to process:', { 
                inventory_id: inv.id,
                statusFinal, 
                type: typeof statusFinal,
                is_number: typeof statusFinal === 'number',
                is_string: typeof statusFinal === 'string'
              });
              
              // Try to convert status to valid enum - handle both numeric IDs and string values
              // First, try to find in inventoryStatusOptions if available
              if (inventoryStatusOptions && Array.isArray(inventoryStatusOptions) && inventoryStatusOptions.length > 0) {
                // Try to find by value (handles both number IDs and string enums)
                let foundOption = inventoryStatusOptions.find(opt => 
                  opt.value === statusFinal || 
                  String(opt.value) === String(statusFinal) ||
                  Number(opt.value) === Number(statusFinal)
                );
                
                // If not found by value, try by label
                if (!foundOption && typeof statusFinal === 'string') {
                  foundOption = inventoryStatusOptions.find(opt => 
                    opt.label === statusFinal || 
                    String(opt.label).toLowerCase().trim() === statusFinal.toLowerCase().trim() ||
                    String(opt.label).trim() === statusFinal.trim()
                  );
                }
                
                if (foundOption) {
                  // If option value is already a valid enum string, use it
                  if (foundOption.value && typeof foundOption.value === 'string' && ['IN_STOCK', 'OUT_OF_STOCK', 'LOW_STOCK', 'DISCONTINUED'].includes(foundOption.value)) {
                    statusFinal = foundOption.value;
                    console.log('Found valid enum from option value:', { 
                      inventory_id: inv.id,
                      original: inv.status,
                      found: statusFinal
                    });
                  } else if (foundOption.label) {
                    // Map label to enum value
                    const labelToEnum = {
                      'In Stock': 'IN_STOCK',
                      'Out of Stock': 'OUT_OF_STOCK',
                      'Low Stock': 'LOW_STOCK',
                      'Discontinued': 'DISCONTINUED',
                      'IN STOCK': 'IN_STOCK',
                      'OUT OF STOCK': 'OUT_OF_STOCK',
                      'LOW STOCK': 'LOW_STOCK',
                      'DISCONTINUED': 'DISCONTINUED',
                      'in stock': 'IN_STOCK',
                      'out of stock': 'OUT_OF_STOCK',
                      'low stock': 'LOW_STOCK',
                      'discontinued': 'DISCONTINUED',
                      'In-Stock': 'IN_STOCK',
                      'Out-of-Stock': 'OUT_OF_STOCK',
                      'Low-Stock': 'LOW_STOCK'
                    };
                    const labelLower = foundOption.label.toLowerCase().trim();
                    const mappedStatus = labelToEnum[foundOption.label] || 
                                       labelToEnum[labelLower] ||
                                       labelToEnum[foundOption.label.replace(/\s+/g, ' ').trim()];
                    
                    if (mappedStatus) {
                      statusFinal = mappedStatus;
                      console.log('Mapped label to enum:', { 
                        inventory_id: inv.id,
                        original: inv.status,
                        label: foundOption.label,
                        mapped: statusFinal
                      });
                    }
                  }
                }
              }
              
              // If still not a valid enum, try fallback mappings for numeric IDs
              if (!['IN_STOCK', 'OUT_OF_STOCK', 'LOW_STOCK', 'DISCONTINUED'].includes(statusFinal)) {
                const idToEnumFallback = {
                  1: 'IN_STOCK',
                  2: 'OUT_OF_STOCK',
                  3: 'LOW_STOCK',
                  4: 'DISCONTINUED'
                };
                
                if (typeof statusFinal === 'number' && idToEnumFallback[statusFinal]) {
                  statusFinal = idToEnumFallback[statusFinal];
                  console.log('Mapped numeric ID to enum using fallback:', { 
                    inventory_id: inv.id,
                    original: inv.status,
                    mapped: statusFinal 
                  });
                } else if (typeof statusFinal === 'string') {
                  // Try direct string mapping for common variations
                  const statusMap = {
                    'IN STOCK': 'IN_STOCK',
                    'OUT OF STOCK': 'OUT_OF_STOCK',
                    'LOW STOCK': 'LOW_STOCK',
                    'DISCONTINUED': 'DISCONTINUED',
                    'In Stock': 'IN_STOCK',
                    'Out of Stock': 'OUT_OF_STOCK',
                    'Low Stock': 'LOW_STOCK',
                    'in stock': 'IN_STOCK',
                    'out of stock': 'OUT_OF_STOCK',
                    'low stock': 'LOW_STOCK',
                    'discontinued': 'DISCONTINUED',
                    'in_stock': 'IN_STOCK',
                    'out_of_stock': 'OUT_OF_STOCK',
                    'low_stock': 'LOW_STOCK'
                  };
                  const upperStatus = statusFinal.toUpperCase().trim();
                  statusFinal = statusMap[statusFinal] || statusMap[upperStatus] || statusFinal;
                }
              }
            }
          
          console.log('Final inventory status:', {
            inventory_id: inv.id,
            statusFinal, 
            type: typeof statusFinal 
          });
          
          // Build inventory item object - ensure unit_of_measurement and status are always included if they have values
          const inventoryItem = {};
          
          // Add available_quantity if present
          if (inv.qty) {
            const qty = parseFloat(inv.qty);
            if (!isNaN(qty)) {
              inventoryItem.available_quantity = qty;
            }
          }
          
          // Always include unit_of_measurement if it has a value (even if it's the only field)
          if (unitStr && unitStr.trim()) {
            inventoryItem.unit_of_measurement = unitStr.trim();
          }
          
          // Always include status if it was selected (has a value)
          // If statusFinal is a valid enum, use it; otherwise, try to preserve the original value
          if (statusFinal && typeof statusFinal === 'string' && ['IN_STOCK', 'OUT_OF_STOCK', 'LOW_STOCK', 'DISCONTINUED'].includes(statusFinal)) {
            inventoryItem.status = statusFinal;
            console.log('Status assigned (valid enum):', { status: statusFinal, inventory_id: inv.id, original: inv.status });
          } else if (inv.status && inv.status !== '' && inv.status !== null && inv.status !== undefined) {
            // Status was selected but conversion failed - try one more time to find it in options
            // This ensures we don't lose status values that were selected
            if (inventoryStatusOptions && Array.isArray(inventoryStatusOptions)) {
              const foundOption = inventoryStatusOptions.find(opt => 
                opt.value === inv.status || 
                String(opt.value) === String(inv.status) ||
                Number(opt.value) === Number(inv.status) ||
                opt.label === inv.status ||
                String(opt.label).toLowerCase().trim() === String(inv.status).toLowerCase().trim()
              );
              
              if (foundOption && foundOption.value) {
                // If option value is a valid enum string, use it
                if (typeof foundOption.value === 'string' && ['IN_STOCK', 'OUT_OF_STOCK', 'LOW_STOCK', 'DISCONTINUED'].includes(foundOption.value)) {
                  inventoryItem.status = foundOption.value;
                  console.log('Status assigned (from option lookup):', { 
                    status: foundOption.value, 
                    inventory_id: inv.id, 
                    original: inv.status 
                  });
                } else if (foundOption.label) {
                  // Map label to enum
                  const labelToEnum = {
                    'In Stock': 'IN_STOCK',
                    'Out of Stock': 'OUT_OF_STOCK',
                    'Low Stock': 'LOW_STOCK',
                    'Discontinued': 'DISCONTINUED',
                    'IN STOCK': 'IN_STOCK',
                    'OUT OF STOCK': 'OUT_OF_STOCK',
                    'LOW STOCK': 'LOW_STOCK',
                    'DISCONTINUED': 'DISCONTINUED',
                    'in stock': 'IN_STOCK',
                    'out of stock': 'OUT_OF_STOCK',
                    'low stock': 'LOW_STOCK',
                    'discontinued': 'DISCONTINUED'
                  };
                  const mapped = labelToEnum[foundOption.label] || labelToEnum[foundOption.label.toLowerCase().trim()];
                  if (mapped) {
                    inventoryItem.status = mapped;
                    console.log('Status assigned (from label mapping):', { 
                      status: mapped, 
                      inventory_id: inv.id, 
                      original: inv.status,
                      label: foundOption.label
                    });
                  } else {
                    console.warn('Status provided but could not be mapped to valid enum:', { 
                      inventory_id: inv.id,
                      original_status: inv.status,
                      found_option: foundOption,
                      valid_statuses: ['IN_STOCK', 'OUT_OF_STOCK', 'LOW_STOCK', 'DISCONTINUED']
                    });
                  }
                }
              } else {
                console.warn('Status provided but not found in options:', { 
                  inventory_id: inv.id,
                  original_status: inv.status,
                  status_type: typeof inv.status,
                  available_options: inventoryStatusOptions?.map(opt => ({ value: opt.value, label: opt.label }))
                });
              }
            } else {
              console.warn('Status provided but options not available:', { 
                inventory_id: inv.id,
                original_status: inv.status,
                status_type: typeof inv.status
              });
            }
          }
          
          // Add stock_location if present
          if (inv.location && typeof inv.location === 'string' && inv.location.trim()) {
            inventoryItem.stock_location = inv.location.trim();
          }
          
          // Only return if there's at least one field
          if (Object.keys(inventoryItem).length > 0) {
            console.log('Final inventory item:', { 
              inventory_id: inv.id,
              inventoryItem,
              has_unit: !!inventoryItem.unit_of_measurement,
              has_status: !!inventoryItem.status
            });
            return inventoryItem;
          }
          
          console.log('Skipping inventory item - no valid fields:', { 
            inventory_id: inv.id,
            qty: inv.qty,
            unitStr,
            statusFinal,
            location: inv.location
          });
          
          return undefined;
        })
        .filter(inv => inv !== undefined && (inv.available_quantity !== undefined || inv.unit_of_measurement || inv.status || inv.stock_location));
      if (validInventory.length > 0) {
        // Always send as inventory_details_list array for consistency with backend format { items: [...] }
        // Backend service will convert inventory_details_list to inventory_details = { items: [...] }
        payload.inventory_details_list = validInventory;
        // For backward compatibility, also set inventory_details for single items (but backend prefers inventory_details_list)
        if (validInventory.length === 1) {
          payload.inventory_details = validInventory[0];
        }
      }
    } else {
      // Fallback to form fields for backward compatibility
      const inv = pickDefined({
        available_quantity: form.inv_qty ? parseFloat(form.inv_qty) : undefined,
        unit_of_measurement: form.inv_uom || undefined,
        status: form.inv_status || undefined,
        stock_location: form.inv_location || undefined
      });
      if (inv) payload.inventory_details = inv;
    }

    // ---------- Lead Time ----------
    if (leadTimeList && leadTimeList.length > 0) {
      const validLeadTimes = leadTimeList
        .filter(lead => {
          // Keep entries that have at least one field filled
          const hasDays = lead.days !== undefined && lead.days !== null && lead.days !== '';
          const hasMin = lead.min !== undefined && lead.min !== null && lead.min !== '';
          const hasMax = lead.max !== undefined && lead.max !== null && lead.max !== '';
          return hasDays || hasMin || hasMax;
        })
        .map(lead => {
          // Parse values, handling empty strings and NaN
          // Note: 0 is a valid value, so we preserve it
          const parseNumber = (val) => {
            if (val === undefined || val === null || val === '') return undefined;
            // Handle 0 as a valid value
            if (val === 0 || val === '0') return 0;
            const parsed = typeof val === 'number' ? val : parseFloat(String(val));
            return isNaN(parsed) ? undefined : parsed;
          };
          
          const parseInteger = (val) => {
            if (val === undefined || val === null || val === '') return undefined;
            // Handle 0 as a valid value
            if (val === 0 || val === '0') return 0;
            const parsed = typeof val === 'number' ? val : parseInt(String(val), 10);
            return isNaN(parsed) ? undefined : parsed;
          };
          
          const result = pickDefined({
            lead_time_days: parseInteger(lead.days),
            min_quantity: parseNumber(lead.min),
            max_quantity: parseNumber(lead.max)
          });
          
          return result;
        })
        .filter(lead => {
          // Keep entries that have at least one valid field after parsing
          return lead !== undefined && 
                 (lead.lead_time_days !== undefined || 
                  lead.min_quantity !== undefined || 
                  lead.max_quantity !== undefined);
        });
      
      if (validLeadTimes.length > 0) {
        // Always send lead_time_list when we have entries from the list
        // Backend will handle merging first entry into lead_time and storing full array in lead_time.items
        // This ensures edit functionality works correctly by always having lead_time.items available
        payload.lead_time_list = validLeadTimes;
        console.log('Lead Time payload:', {
          leadTimeList_length: leadTimeList.length,
          validLeadTimes_length: validLeadTimes.length,
          validLeadTimes: validLeadTimes,
          payload_lead_time_list: payload.lead_time_list
        });
      } else {
        console.log('No valid lead times found:', {
          leadTimeList: leadTimeList,
          leadTimeList_length: leadTimeList?.length
        });
      }
    } else {
      // Fallback to form fields for backward compatibility
      const parseNumber = (val) => {
        if (val === undefined || val === null || val === '') return undefined;
        const parsed = typeof val === 'number' ? val : parseFloat(val);
        return isNaN(parsed) ? undefined : parsed;
      };
      
      const parseInteger = (val) => {
        if (val === undefined || val === null || val === '') return undefined;
        const parsed = typeof val === 'number' ? val : parseInt(val);
        return isNaN(parsed) ? undefined : parsed;
      };
      
      const lead = pickDefined({
        lead_time_days: parseInteger(form.lead_days),
        min_quantity: parseNumber(form.lead_min),
        max_quantity: parseNumber(form.lead_max)
      });
      if (lead) payload.lead_time = lead;
    }

    // ---------- FAQ ----------
    if (faqList && faqList.length > 0) {
      const validFAQs = faqList
        .filter(faq => faq.question && faq.question.trim() && faq.answer && faq.answer.trim())
        .map(faq => ({
          question: faq.question.trim(),
          answer: faq.answer.trim()
        }));
      if (validFAQs.length > 0) {
        payload.faq = validFAQs;
        payload.faq_list = validFAQs; // Also set faq_list for consistency
      }
    } else if (Array.isArray(extras.faqList) && extras.faqList.length) {
      const validFAQs = extras.faqList
        .filter(f => f.q && f.q.trim() && f.a && f.a.trim())
        .map(f => ({
          question: f.q.trim(),
          answer: f.a.trim()
        }));
      if (validFAQs.length > 0) {
        payload.faq = validFAQs;
      }
    } else if (form.faq_q && form.faq_q.trim() && form.faq_a && form.faq_a.trim()) {
      payload.faq = [{ question: form.faq_q.trim(), answer: form.faq_a.trim() }];
    }

    // ---------- Other Attributes ----------
    if (attributesList && attributesList.length > 0) {
      const validAttributes = attributesList
        .filter(attr => attr.attribute && attr.attribute.trim() && attr.value && attr.value.trim())
        .map(attr => {
          // Extract unit - handle string values, Select option objects, and numeric indices
          let unitValue = attr.unit;
          
          // Handle Select option object
          if (unitValue && typeof unitValue === 'object' && unitValue.value) {
            unitValue = unitValue.value;
          }
          
          // Handle numeric value - look up in attributeUnitOptions using findOption helper
          if (typeof unitValue === 'number' && attributeUnitOptions && Array.isArray(attributeUnitOptions)) {
            // Try to find the option by value (if the number is the value itself)
            const foundByValue = findOption(attributeUnitOptions, unitValue, 'value');
            if (foundByValue) {
              // Prefer string value, but use label if value is still a number
              if (foundByValue.value && typeof foundByValue.value === 'string') {
                unitValue = foundByValue.value;
              } else if (foundByValue.label && typeof foundByValue.label === 'string') {
                unitValue = foundByValue.label;
              } else if (foundByValue.value) {
                // If value exists but is a number, convert to string
                unitValue = String(foundByValue.value);
              }
            } else {
              // Try as array index (0-based)
              const optionAtIndex = attributeUnitOptions[unitValue];
              if (optionAtIndex) {
                if (typeof optionAtIndex === 'object') {
                  // Prefer string value, fallback to label, then convert to string
                  if (optionAtIndex.value && typeof optionAtIndex.value === 'string') {
                    unitValue = optionAtIndex.value;
                  } else if (optionAtIndex.label && typeof optionAtIndex.label === 'string') {
                    unitValue = optionAtIndex.label;
                  } else if (optionAtIndex.value) {
                    unitValue = String(optionAtIndex.value);
                  }
                } else if (typeof optionAtIndex === 'string') {
                  unitValue = optionAtIndex;
                }
              }
            }
          }
          
          // Convert to string and trim - ensure it's a valid non-empty string
          let unit = undefined;
          if (unitValue !== undefined && unitValue !== null && unitValue !== '') {
            const unitStr = typeof unitValue === 'string' ? unitValue.trim() : String(unitValue).trim();
            if (unitStr && unitStr !== '') {
              unit = unitStr;
            }
          }
          
          // Debug log to verify unit is being captured
          if (attr.unit) {
            console.log('Other Attribute unit extraction:', { 
              original: attr.unit, 
              type: typeof attr.unit, 
              extracted: unit,
              attribute: attr.attribute
            });
          }
          
          return {
            attribute_name: attr.attribute.trim(),
            attribute_value: attr.value.trim(),
            unit: unit // Include unit if it has a value, otherwise undefined (optional field)
          };
        })
        .filter(attr => attr.attribute_name && attr.attribute_value); // Only include attributes with name and value
      
      if (validAttributes.length > 0) {
        payload.other_attributes = validAttributes;
        payload.attributes_list = validAttributes; // Also set attributes_list for consistency
        console.log('Other attributes being saved:', JSON.stringify(validAttributes, null, 2));
      }
    } else if (form.pd_attr && form.pd_attr.trim() && form.pd_attr_val && form.pd_attr_val.trim()) {
      // Handle legacy single attribute
      let unitValue = form.pd_attr_unit;
      // Handle numeric value lookup
      if (typeof unitValue === 'number' && attributeUnitOptions && Array.isArray(attributeUnitOptions)) {
        const foundByValue = findOption(attributeUnitOptions, unitValue, 'value');
        if (foundByValue && foundByValue.value && typeof foundByValue.value === 'string') {
          unitValue = foundByValue.value;
        } else if (foundByValue && foundByValue.label && typeof foundByValue.label === 'string') {
          unitValue = foundByValue.label;
        }
      }
      const unit = unitValue && typeof unitValue === 'string' && unitValue.trim() ? unitValue.trim() : undefined;
      
      payload.other_attributes = [{
        attribute_name: form.pd_attr.trim(),
        attribute_value: form.pd_attr_val.trim(),
        unit: unit
      }];
    }

    // ---------- Carousel toggle ----------
    // Store carousel toggle in carousel_slider JSON field since there's no separate column
    // Format: { enabled: boolean, images: [...] } or just { enabled: boolean }
    // Always save the toggle state (even if false) to ensure it's persisted
    const carouselEnabledValue = typeof extras.carouselEnabled !== "undefined" 
      ? extras.carouselEnabled 
      : (typeof form.carouselEnabled !== "undefined" ? form.carouselEnabled : false);
    const enabled = !!carouselEnabledValue;
    
    // Initialize or update carousel_slider object with enabled flag
    if (payload.carousel_slider && typeof payload.carousel_slider === 'object' && !Array.isArray(payload.carousel_slider)) {
      // Merge enabled flag into existing carousel_slider object
      payload.carousel_slider.enabled = enabled;
    } else {
      // Create new carousel_slider object with enabled flag
      payload.carousel_slider = { enabled: enabled };
    }
    // Also set carousel_slider_enabled for backward compatibility (even though it won't be saved to DB)
    payload.carousel_slider_enabled = enabled;

    // ---------- Currency, packaging final touches ----------
    if (form.pd_currency) {
      payload.currency = typeof form.pd_currency === 'string' ? form.pd_currency.trim() : String(form.pd_currency || '');
    }

    // Clean payload deeply and remove 'attributes' field if present (not allowed by backend)
    const cleanedPayload = cleanObjectDeep(payload) || {};
    if (cleanedPayload.attributes !== undefined) {
      delete cleanedPayload.attributes;
    }
    
    // Preserve dimensions_list if it exists (cleanObjectDeep might remove it if array is empty)
    if (payload.dimensions_list && Array.isArray(payload.dimensions_list) && payload.dimensions_list.length > 0) {
      cleanedPayload.dimensions_list = payload.dimensions_list;
    }
    // Preserve dimensions if it exists (single dimension object)
    if (payload.dimensions && typeof payload.dimensions === 'object' && !Array.isArray(payload.dimensions)) {
      cleanedPayload.dimensions = payload.dimensions;
    }
    // Preserve other_attributes if it exists (cleanObjectDeep might remove it if array is empty or has undefined units)
    if (payload.other_attributes && Array.isArray(payload.other_attributes) && payload.other_attributes.length > 0) {
      cleanedPayload.other_attributes = payload.other_attributes;
    }
    // Preserve packaging_details if it exists (cleanObjectDeep might remove it)
    if (payload.packaging_details && typeof payload.packaging_details === 'object') {
      cleanedPayload.packaging_details = payload.packaging_details;
    }
    
    // Preserve inventory_details and inventory_details_list if they exist (cleanObjectDeep might remove unit_of_measurement or status)
    if (payload.inventory_details && typeof payload.inventory_details === 'object') {
      cleanedPayload.inventory_details = payload.inventory_details;
    }
    if (payload.inventory_details_list && Array.isArray(payload.inventory_details_list) && payload.inventory_details_list.length > 0) {
      cleanedPayload.inventory_details_list = payload.inventory_details_list;
    }
    
    // Ensure customization_available is always included as a boolean (required by backend)
    // cleanObjectDeep might remove false values, so we need to explicitly include it
    if (payload.customization_available !== undefined) {
      cleanedPayload.customization_available = typeof payload.customization_available === 'boolean' 
        ? payload.customization_available 
        : !!payload.customization_available;
    } else {
      // Default to false if not set
      cleanedPayload.customization_available = false;
    }
    if (payload.customization_types !== undefined) {
      cleanedPayload.customization_types = payload.customization_types;
    }
    if (payload.customization_details !== undefined) {
      cleanedPayload.customization_details = payload.customization_details;
    }
    
    // Ensure category IDs are strings (backend validation requires strings, not numbers)
    // Convert to strings and ensure they remain strings (not numbers)
    if (cleanedPayload.category_id !== undefined && cleanedPayload.category_id !== null && cleanedPayload.category_id !== '') {
      cleanedPayload.category_id = String(cleanedPayload.category_id);
      // Double-check: if it can be parsed as a number, ensure it's stored as a string
      if (!isNaN(cleanedPayload.category_id) && typeof cleanedPayload.category_id !== 'string') {
        cleanedPayload.category_id = String(cleanedPayload.category_id);
      }
    }
    if (cleanedPayload.subcategory_id !== undefined && cleanedPayload.subcategory_id !== null && cleanedPayload.subcategory_id !== '') {
      cleanedPayload.subcategory_id = String(cleanedPayload.subcategory_id);
      if (!isNaN(cleanedPayload.subcategory_id) && typeof cleanedPayload.subcategory_id !== 'string') {
        cleanedPayload.subcategory_id = String(cleanedPayload.subcategory_id);
      }
    }
    if (cleanedPayload.sub_subcategory_id !== undefined && cleanedPayload.sub_subcategory_id !== null && cleanedPayload.sub_subcategory_id !== '') {
      cleanedPayload.sub_subcategory_id = String(cleanedPayload.sub_subcategory_id);
      if (!isNaN(cleanedPayload.sub_subcategory_id) && typeof cleanedPayload.sub_subcategory_id !== 'string') {
        cleanedPayload.sub_subcategory_id = String(cleanedPayload.sub_subcategory_id);
      }
    }
    
    const jsonPayload = cleanedPayload;
    
    // Final verification: ensure category IDs are strings before stringifying
    // This is critical because JSON.stringify will serialize numbers as numbers
    if (jsonPayload.category_id !== undefined && jsonPayload.category_id !== null) {
      jsonPayload.category_id = String(jsonPayload.category_id);
    }
    if (jsonPayload.subcategory_id !== undefined && jsonPayload.subcategory_id !== null) {
      jsonPayload.subcategory_id = String(jsonPayload.subcategory_id);
    }
    if (jsonPayload.sub_subcategory_id !== undefined && jsonPayload.sub_subcategory_id !== null) {
      jsonPayload.sub_subcategory_id = String(jsonPayload.sub_subcategory_id);
    }
    
    // Ensure customization_available is always a boolean in the final payload (required by backend)
    if (jsonPayload.customization_available === undefined || jsonPayload.customization_available === null) {
      jsonPayload.customization_available = false;
    } else {
      jsonPayload.customization_available = !!jsonPayload.customization_available;
    }
    
    // Ensure customization_types is preserved if it exists (array of strings)
    // Only include if customization_available is true and types array is not empty
    if (jsonPayload.customization_available && jsonPayload.customization_types) {
      // Ensure it's an array of strings with valid enum values
      if (Array.isArray(jsonPayload.customization_types)) {
        jsonPayload.customization_types = jsonPayload.customization_types
          .filter(type => type && typeof type === 'string' && CUSTOMIZATION_BACKEND_TYPES.includes(type))
          .map(type => String(type));
        
        // If array becomes empty after filtering, remove it
        if (jsonPayload.customization_types.length === 0) {
          delete jsonPayload.customization_types;
        }
      } else {
        // If it's not an array, try to convert it
        const typeStr = String(jsonPayload.customization_types);
        if (CUSTOMIZATION_BACKEND_TYPES.includes(typeStr)) {
          jsonPayload.customization_types = [typeStr];
        } else {
          delete jsonPayload.customization_types;
        }
      }
    } else if (!jsonPayload.customization_available) {
      // If customization is not available, remove customization_types
      delete jsonPayload.customization_types;
    } else if (jsonPayload.customization_available && (!jsonPayload.customization_types || (Array.isArray(jsonPayload.customization_types) && jsonPayload.customization_types.length === 0))) {
      // If customization is available but no types are selected, remove customization_types
      // Backend expects either a valid array with types or undefined/null, not an empty array
      delete jsonPayload.customization_types;
    }
    
    // Debug: Log the category IDs, customization_available, customization_types, and dimensions to verify they're correct
    console.log('Category IDs, customization, and dimensions before JSON.stringify:', {
      category_id: jsonPayload.category_id,
      category_id_type: typeof jsonPayload.category_id,
      subcategory_id: jsonPayload.subcategory_id,
      subcategory_id_type: typeof jsonPayload.subcategory_id,
      sub_subcategory_id: jsonPayload.sub_subcategory_id,
      sub_subcategory_id_type: typeof jsonPayload.sub_subcategory_id,
      customization_available: jsonPayload.customization_available,
      customization_available_type: typeof jsonPayload.customization_available,
      customization_types: jsonPayload.customization_types,
      customization_types_type: Array.isArray(jsonPayload.customization_types) ? 'array' : typeof jsonPayload.customization_types,
      dimensions: jsonPayload.dimensions,
      dimensions_type: Array.isArray(jsonPayload.dimensions) ? 'array' : typeof jsonPayload.dimensions,
      dimensions_list: jsonPayload.dimensions_list,
      dimensions_list_type: Array.isArray(jsonPayload.dimensions_list) ? 'array' : typeof jsonPayload.dimensions_list,
      dimensions_list_length: Array.isArray(jsonPayload.dimensions_list) ? jsonPayload.dimensions_list.length : 'N/A'
    });

    // ---------- Build FormData ----------
    const formData = new FormData();
    
    // Final check: Create a new object with explicit string conversion for category IDs
    // This ensures JSON.stringify will serialize them as strings (with quotes)
    const finalPayload = { ...jsonPayload };
    if (finalPayload.category_id !== undefined && finalPayload.category_id !== null) {
      finalPayload.category_id = String(finalPayload.category_id);
    }
    if (finalPayload.subcategory_id !== undefined && finalPayload.subcategory_id !== null) {
      finalPayload.subcategory_id = String(finalPayload.subcategory_id);
    }
    if (finalPayload.sub_subcategory_id !== undefined && finalPayload.sub_subcategory_id !== null) {
      finalPayload.sub_subcategory_id = String(finalPayload.sub_subcategory_id);
    }
    
    const payloadString = JSON.stringify(finalPayload);
    
    // Verify in the JSON string that category IDs are quoted (strings)
    // In JSON, strings have quotes, numbers don't: "category_id":"123" (string) vs "category_id":123 (number)
    console.log('JSON payload string (checking category IDs):', payloadString);
    console.log('Category IDs in final payload:', {
      category_id: finalPayload.category_id,
      category_id_type: typeof finalPayload.category_id,
      subcategory_id: finalPayload.subcategory_id,
      subcategory_id_type: typeof finalPayload.subcategory_id,
      sub_subcategory_id: finalPayload.sub_subcategory_id,
      sub_subcategory_id_type: typeof finalPayload.sub_subcategory_id
    });
    
    formData.append("payload", payloadString);

    // Attach files (if present)
    if (files.catalogueFile) formData.append("catalogue_file", files.catalogueFile);
    if (files.videoFile) formData.append("video_file", files.videoFile);

    if (Array.isArray(files.productImages)) {
      files.productImages.slice(0, 5).forEach((f, idx) => formData.append(`product_images[${idx}]`, f));
    }

    if (Array.isArray(files.certificateFiles)) {
      files.certificateFiles.forEach((f, idx) => formData.append(`certificates[${idx}]`, f));
    }

    if (Array.isArray(files.carouselFiles)) {
      files.carouselFiles.slice(0, 5).forEach((f, idx) => formData.append(`carousel_images[${idx}]`, f));
    }

    if (Array.isArray(files.customizationFiles)) {
      files.customizationFiles.forEach((f, idx) => formData.append(`customization_files[${idx}]`, f));
    }

    return { formData, jsonPayload };
  }
  // Save current product to backend
  async function saveProductDetails() {
    // Validate required fields
    if (!form.pd_name || !form.pd_brand || !form.pd_cat || !form.pd_subcat || !form.pd_subsubcat || !form.pd_desc || keywords.length === 0) {
      toast.error('Please fill in all mandatory fields: Product Name, Brand, Product Category, Product Sub-category, Product Sub-Sub Category, Product Description, and at least one Keyword');
      return;
    }
    // Calculate Price With Tax if not already calculated
    if (form.moq_price_notax && form.moq_tax && !form.moq_price_tax) {
      const priceWithoutTax = parseFloat(form.moq_price_notax) || 0;
      const taxPercent = parseFloat(form.moq_tax) || 0;
      const priceWithTax = (priceWithoutTax * (1 + taxPercent / 100)).toFixed(2);
      setForm(prev => ({ ...prev, moq_price_tax: priceWithTax }));
    }
    if (!form.moq_min || !form.moq_uom || !form.moq_price_notax || !form.moq_tax || !form.moq_currency) {
      toast.error('Please fill in all MOQ fields: Minimum Order Quantity, Unit of Measurements, Price (Without Tax), Tax (%), and Currency');
      return;
    }

    if (!companyId) {
      toast.error("Please Create Company Profile first");
      return;
    }

    // Gather extras & files from component state
    const extras = {
      keywords: keywords || [],
      mainProducts: form.pd_main_product || false,
      customizationRows: customizationRows || [],
      bulkDiscounts: bulkDiscountSlabs || [],
      faqList: faqList || [],
      carouselEnabled: carouselEnabled || false,
      electronicsCategories: [] // TODO: Add electronics categories if needed
    };

    const files = {
      catalogueFile: productCatalogueFile || null,
      videoFile: productVideoFile || null,
      productImages: productImageFiles || [],
      certificateFiles: [], // Customization certificate files handled separately
      carouselFiles: carouselFiles || [],
      customizationFiles: [] // Customization files handled separately
    };

    const { formData, jsonPayload } = prepareProductFormData(form, extras, files);
    console.log("Product FormData:", formData, "JSON payload:", jsonPayload);
    
    try {
      let response;
      if (editingProductId && editingProductId.toString().match(/^\d+$/)) {
        // Update existing product (if editingProductId is a numeric ID from backend)
        response = await CommonService.put(`/profile/product/${editingProductId}`, jsonPayload);
        if (response && response.success) {
          toast.success(response.message || 'Product updated successfully');
          // Reload products from backend to ensure we have the latest data with all fields
          await loadProductDetails(companyId);
          setIsProductDetailsSaved(true);
          setEditingProductId(null);
          setProductCatalogueCollapsed(true);
          
          // Reset form after successful save
          setForm(initialState);
          setCustomizationRows(DEFAULT_CUSTOMIZATION_ROWS.map((row) => ({ ...row })));
          setKeywords([]);
          setCarouselEnabled(false);
          setCarouselFiles([]);
          setCarouselImageUrls([]);
        } else {
          toast.error("Product Profile update failed");
          setIsProductDetailsSaved(false);
        }
      } else {
        // Create new product
        response = await CommonService.post(`/profile/company/${companyId}/product`, jsonPayload);
        if (response && response.success) {
          const newProductId = response.data.productId || response.data.id || 0;
          toast.success(response.message || 'Product created successfully');
          
          // Reload products from backend to ensure we have the latest data with all fields
          // This ensures inventory, lead time, packaging, and other nested fields are properly loaded
          await loadProductDetails(companyId);
          
          setIsProductDetailsSaved(true);
          setEditingProductId(null);
          setProductCatalogueCollapsed(true);
          
          // Reset form after successful save
          setForm(initialState);
          setCustomizationRows(DEFAULT_CUSTOMIZATION_ROWS.map((row) => ({ ...row })));
          setKeywords([]);
          setCarouselEnabled(false);
          setCarouselFiles([]);
          setCarouselImageUrls([]);
        } else {
          toast.error("Product Profile creation failed");
          setIsProductDetailsSaved(false);
        }
      }
    } catch (err) {
      console.error("Error saving product:", err);
      // Show detailed validation errors
      if (err?.response?.data?.errors && Array.isArray(err.response.data.errors)) {
        const errorMessages = err.response.data.errors.map(e => 
          typeof e === 'string' ? e : (e.message || JSON.stringify(e))
        );
        toast.error(`Validation failed: ${errorMessages.join(', ')}`);
      } else {
        const message = err?.response?.data?.message || "Product Profile save failed. Please try again.";
        toast.error(message);
      }
      setIsProductDetailsSaved(false);
    }
  }



  return (
    <div className="seller-profile container-fluid">
      <div className="row">
        <main className="col-12 sp-main">
          {/* Sticky Header Section */}
          <div className="sp-header-sticky">
            {/* Breadcrumb Navigation */}
            <nav aria-label="breadcrumb" className="sp-breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/" className="breadcrumb-link">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Seller Profile
                </li>
              </ol>
            </nav>

            {/* Main Heading Section */}
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h1 className="sp-main-title">Seller Profile</h1>
                <p className="sp-subtitle">Manage your company profile, factory details, and product catalogue</p>
              </div>
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => navigate('/buyer-profile')}
              >
                Buyer Profile
              </button>
            </div>
          </div>

          <Tabs className="sp-card" activeKey={activeTab} onChange={setActiveTab}>
            <TabPane tab={<span><span className="tab-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path><path d="M10 6h4"></path><path d="M10 10h4"></path><path d="M10 14h4"></path><path d="M10 18h4"></path></svg></span> Company Details</span>} key="1">
              <div className="container-fluid">
                <section className="sp-section">
                  <div className="sp-subcard">
                    <h6 className="sp-section-title">🏢 Company</h6>
                    <div className="row g-2">
                      <div className="col-12 col-md-6 col-lg-3">
                        <input className="input-pill" placeholder="Name of the Company *" name="companyName" value={form.companyName} onChange={onChange} required />
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <input className="input-pill" placeholder="Designation *" name="designation" value={form.designation} onChange={onChange} required />
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <Select
                          className="input-pill p-0"
                          name="trader"
                          placeholder="Business Type *"
                          options={businessTypeOptions}
                          onChange={(opt) => onChange({ target: { name: "trader", value: opt?.value || "" } })}
                          value={findOption(businessTypeOptions, form.trader)}
                          isClearable
                        />
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <input className="input-pill" placeholder="GST Number" name="gstNumber" value={form.gstNumber} onChange={onChange} />
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <input className="input-pill" placeholder="Company Registration Number *" name="registrationNumber" value={form.registrationNumber} onChange={onChange} required />
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <input className="input-pill" placeholder="Website (https://example.com)" name="website" value={form.website} onChange={onChange} />
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <input type="number" className="input-pill" placeholder="No of Employees *" name="noOfEmployees" value={form.noOfEmployees} onChange={onChange} required min="0" />
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <input className="input-pill" placeholder="Year Established (YYYY)" name="yearEstablished" value={form.yearEstablished} onChange={onChange} />
                      </div>
                    </div>
                    <div className="row g-2">
                      <div className="col-12 col-md-12 col-lg-12">
                        <textarea className="input-area" placeholder="Company Description" name="companyDescription" value={form.companyDescription} onChange={onChange} />
                      </div>
                    </div>

                    <div className="row g-2">
                      <div className="col-12 col-md-6 col-lg-3">
                        <div className="file-upload-component">
                          <div className="file-title">Company Logo <span className="required-asterisk">*</span></div>
                          <label className="file-box">
                            <div className="file-content">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="upload-icon">
                                <path d="M12 3v12"></path>
                                <path d="m17 8-5-5-5 5"></path>
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                              </svg>
                              <span className="choose-text">Choose file</span>
                            </div>
                            <Modal
                              title="Customization"
                              open={descModal.visible}
                              onCancel={() => setDescModal({ visible: false, rowId: null })}
                              footer={[
                                <button key="cancel" type="button" className="btn cus-btn-outline-primary" onClick={() => setDescModal({ visible: false, rowId: null })}>Cancel</button>,
                                <button key="save" type="button" className="btn  cus-btn-add" onClick={() => { if (descModal.rowId) updateCustomizationField(descModal.rowId, 'desc', descText); setDescModal({ visible: false, rowId: null }); }}>Send</button>
                              ]}
                            >
                              <div className="custom-desc-modal">
                                <div className="desc-box">
                                  <div className="desc-label">Description</div>
                                  <textarea id="custom-desc-area" className="input-area" rows="6" placeholder="Writing entries: 100 words min, 1000 words max" value={descText} onChange={(e) => setDescText(e.target.value)} />
                                  <hr className="desc-sep" />
                                  <div className="file-upload-component">
                                    <div className="input-pill upload-pill" onClick={(e) => { const input = e.currentTarget.querySelector('input[type=file]'); if (input) input.click(); }}>
                                      <span className="upload-icon-only" aria-hidden>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="upload-icon"><path d="M12 3v12"></path><path d="m17 8-5-5-5 5"></path><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path></svg>
                                      </span>
                                      <span className="choose-text ms-2">Upload Documents / Images For Customization Reference (max 1MB) ({descFiles.length}/3)</span>
                                      <input ref={uploadRef} type="file" className="d-none" accept=".jpg,.jpeg,.png,.pdf" multiple onChange={(e) => {
                                        const files = Array.from(e.target.files || []).slice(0, 3);
                                        setDescFiles(files);
                                        setDescFileName(files[0] ? files[0].name : '');
                                      }} />
                                    </div>
                                    {descFiles.length > 0 && (
                                      <div className="upload-list">
                                        {descFiles.map((f, idx) => (
                                          <span key={idx} className="upload-chip">{f.name}</span>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </Modal>
                            <input type="file" onChange={(e) => handleMediaFileChange('company_logo', e)} accept=".png,.jpg,.gif" required disabled={uploading} />
                            {mediaFiles.company_logo && (
                              <div className="mt-2 small text-success">
                                ✓ Uploaded: {mediaFiles.company_logo.split('/').pop()}
                              </div>
                            )}
                          </label>
                          <div className="file-types">PNG, JPG, GIF</div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <div className="file-upload-component">
                          <div className="file-title">Profile Banner</div>
                          <label className="file-box">
                            <div className="file-content">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="upload-icon">
                                <path d="M12 3v12"></path>
                                <path d="m17 8-5-5-5 5"></path>
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                              </svg>
                              <span className="choose-text">Choose file</span>
                            </div>
                            <input type="file" onChange={(e) => handleMediaFileChange('profile_banner', e)} accept=".png,.jpg" disabled={uploading} />
                            {mediaFiles.profile_banner && (
                              <div className="mt-2 small text-success">
                                ✓ Uploaded: {mediaFiles.profile_banner.split('/').pop()}
                              </div>
                            )}
                          </label>
                          <div className="file-types">PNG, JPG</div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <div className="file-upload-component">
                          <div className="file-title">Brochure</div>
                          <label className="file-box">
                            <div className="file-content">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="upload-icon">
                                <path d="M12 3v12"></path>
                                <path d="m17 8-5-5-5 5"></path>
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                              </svg>
                              <span className="choose-text">Choose file</span>
                            </div>
                            <input type="file" onChange={(e) => handleMediaFileChange('brochure', e)} accept=".pdf,.doc,.docx" disabled={uploading} />
                            {mediaFiles.brochure && (
                              <div className="mt-2 small text-success">
                                ✓ Uploaded: {mediaFiles.brochure.split('/').pop()}
                              </div>
                            )}
                          </label>
                          <div className="file-types">PDF, DOC, DOCX</div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <div className="file-upload-component">
                          <div className="file-title">Company Video</div>
                          <label className="file-box">
                            <div className="file-content">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="upload-icon">
                                <path d="M12 3v12"></path>
                                <path d="m17 8-5-5-5 5"></path>
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                              </svg>
                              <span className="choose-text">Choose file</span>
                            </div>
                            <input type="file" onChange={(e) => handleMediaFileChange('company_video', e)} accept=".mp4,.mov,.avi" disabled={uploading} />
                            {mediaFiles.company_video && (
                              <div className="mt-2 small text-success">
                                ✓ Uploaded: {mediaFiles.company_video.split('/').pop()}
                              </div>
                            )}
                          </label>
                          <div className="file-types">MP4, MOV, AVI</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="sp-subcard">
                    <h6 className="sp-section-title">🔧 Main Products <span className="required-asterisk">*</span></h6>
                    <div className="product-input-row">
                      <input
                        className="input-pill"
                        placeholder="eg. chilli powder"
                        value={productInput}
                        onChange={(e) => setProductInput(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            addProduct();
                          }
                        }}
                      />
                      <button type="button" className="btn-add" onClick={addProduct} disabled={!productInput.trim()}>+ Add</button>
                    </div>
                    <div className="tags">
                      {products.map(p => (
                        <span className="tag" key={p}>{p} <button type="button" className="tag-x" onClick={() => removeProduct(p)}>×</button></span>
                      ))}
                    </div>
                  </div>

                </section>

                <section className="sp-section">
                  <div className="sp-subcard">
                    <h6 className="sp-section-title">📞 Contact Details</h6>
                    <div className="row g-2">
                      <div className="col-12 col-md-6 col-lg-4">
                        <input className="input-pill" placeholder="Alternate Contact Name *" name="altContactName" value={form.altContactName} onChange={onChange} required />
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <input className="input-pill" placeholder="Alternate Email (email@example.com) *" name="altEmail" value={form.altEmail} onChange={onChange} type="email" required />
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <input className="input-pill" placeholder="Alternate Contact (+91 1234567890) *" name="altContact" value={form.altContact} onChange={onChange} required />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sp-section">
                  <div className="sp-subcard">
                    <h6 className="sp-section-title">📍 Address</h6>
                    <div className="row g-2">
                      <div className="col-12 col-md-6 col-lg-6">
                        <input
                          className="input-pill"
                          placeholder="Address *"
                          name="address"
                          value={form.address}
                          onChange={onChange}
                          required
                        />
                      </div>

                      <div className="col-12 col-md-6 col-lg-6">
                        <input
                          className="input-pill"
                          placeholder="Landmark (Near...) *"
                          name="landmark"
                          value={form.landmark}
                          onChange={onChange}
                          required
                        />
                      </div>

                      <div className="col-12 col-md-6 col-lg-3">
                        <Select
                          className="input-pill p-0"
                          name="country"
                          placeholder="Select country"
                          options={countries}
                          onChange={(opt) => handleLocationChange("country", opt)}
                          value={findOption(countries, form.country)}
                          isClearable
                        />
                      </div>

                      <div className="col-12 col-md-6 col-lg-3">
                        <Select
                          className="input-pill p-0"
                          name="state"
                          placeholder="Select state"
                          options={states}
                          onChange={(opt) => handleLocationChange("state", opt)}
                          value={findOption(states, form.state)}
                          isDisabled={!form.country}
                          isClearable
                        />
                      </div>

                      <div className="col-12 col-md-6 col-lg-3">
                        <Select
                          className="input-pill p-0"
                          name="city"
                          placeholder="Select city"
                          options={cities}
                          onChange={(opt) => {
                            const value = opt ? opt.value : "";
                            onChange({ target: { name: "city", value } });
                          }}
                          value={findOption(cities, form.city)}
                          isDisabled={!form.state}
                          isClearable
                        />
                      </div>

                      <div className="col-12 col-md-6 col-lg-3">
                        <input
                          className="input-pill"
                          placeholder="Pincode (000000) *"
                          name="pincode"
                          value={form.pincode}
                          onChange={onChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sp-section">
                  <div className="sp-subcard">
                    <h6 className="sp-section-title">🏦 Bank Details</h6>
                    <div className="row g-2">
                      <div className="col-12 col-md-6 col-lg-4">
                        <input className="input-pill" placeholder="Name of the Account Holder" name="accountHolder" value={form.accountHolder} onChange={onChange} />
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <input type="number" className="input-pill" placeholder="Account Number" name="accountNumber" value={form.accountNumber} onChange={onChange} min="0" />
                      </div>
                      <div className="col-12 col-md-6 col-lg-4">
                        <input className="input-pill" placeholder="Bank Name" name="bankName" value={form.bankName} onChange={onChange} />
                      </div>

                      <div className="col-12 col-md-6 col-lg-3">
                        <input className="input-pill" placeholder="Branch Name" name="branchName" value={form.branchName} onChange={onChange} />
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <input className="input-pill" placeholder="IFSC Code" name="ifsc" value={form.ifsc} onChange={onChange} />
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <input className="input-pill" placeholder="Swift Code" name="swift" value={form.swift} onChange={onChange} />
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <Select
                          className="input-pill p-0"
                          name="currency"
                          placeholder="Choice of Currency for Trade"
                          options={currencyOptions}
                          onChange={(opt) => setForm(prev => ({ ...prev, currency: opt?.value || "" }))}
                          value={findOption(currencyOptions, form.currency)}
                          isClearable
                        />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sp-section">
                  <div className="sp-subcard">
                    <h6 className="sp-section-title">📊 Trading Information</h6>
                    <div className="form-grid">
                      <input className="input-pill" placeholder="Total Revenue (Annual)" name="totalRevenue" value={form.totalRevenue} onChange={onChange} />
                      <input className="input-pill" placeholder="Export Percentage (%)" name="exportPercentage" value={form.exportPercentage} onChange={onChange} />
                      <input className="input-pill" placeholder="Company Overseas Address" name="overseasAddress" value={form.overseasAddress} onChange={onChange} />
                      <input className="input-pill" placeholder="IEC Number" name="iecNumber" value={form.iecNumber} onChange={onChange} />
                    </div>
                  </div>
                </section>


                <section className="sp-section">
                  <div className="sp-subcard">
                    <h6 className="sp-section-title">🕐 Timezone</h6>
                    <div className="form-grid">
                      <Select 
                        className="input-pill p-0"
                        placeholder="Select Timezone" 
                        options={timezoneOptions} 
                        onChange={(opt) => setForm(prev => ({ ...prev, timezone: opt?.value || "" }))}
                        value={findOption(timezoneOptions, form.timezone)}
                        isClearable
                      />


                      {/* <select className="input-pill" name="timezone" value={form.timezone} onChange={onChange}>
                        <option>Select Timezone</option>
                        {timezoneList.map(tz => (
                          <option key={tz.value} value={tz.value}>
                            {tz.label}
                          </option>
                        ))}
                      </select> */}
                    </div>
                  </div>
                </section>


                <div className="sp-actions-row mb-2">
                  <div className="sp-left-actions">
                  </div>
                  <div className="sp-right-actions">
                    <button type="button" className="btn btn-primary" onClick={saveCompanyProfiles}>Save</button>
                    {isCompanyProfileSaved && (
                      <button type="button" className="btn btn-outline-primary ms-2" onClick={handleNext}>Next</button>
                    )}
                  </div>
                </div>
              </div>
            </TabPane>

            {/* Other tabs can duplicate structure or be left as placeholders */}
            <TabPane tab={<span><span className="tab-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 16h.01"></path><path d="M16 16h.01"></path><path d="M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z"></path><path d="M8 16h.01"></path></svg></span> Factory Details</span>} key="2">
              <div className="container-fluid">
                <section className="sp-section">
                  <div className="sp-subcard">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="sp-section-title">🏭 Factory Details</h6>
                      <button type="button" className="btn-add" onClick={addFactoryDetails}>+ Add More</button>
                    </div>
                    {factoryDetailsList.map((factory, index) => (
                      <div key={index} className="mb-4">
                        {factoryDetailsList.length > 1 && (
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="sp-section-subtitle">Factory {index + 1}</h6>
                            <button type="button" className="btn-icon-remove" onClick={() => removeFactoryDetails(index)} title="Remove Factory">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="3 6 5 6 21 6"></polyline>
                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                <line x1="10" y1="11" x2="10" y2="17"></line>
                                <line x1="14" y1="11" x2="14" y2="17"></line>
                              </svg>
                            </button>
                          </div>
                        )}
                        <div className="row g-2">
                          <div className="col-12 col-md-6 col-lg-3">
                            <input className="input-pill" placeholder="Factory Name" name="factoryName" value={factory.factoryName || ''} onChange={(e) => updateFactoryDetails(index, 'factoryName', e.target.value)} />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <input type="number" className="input-pill" placeholder="Factory Size" name="factorySize" value={factory.factorySize || ''} onChange={(e) => updateFactoryDetails(index, 'factorySize', e.target.value)} min="0" />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <Select
                              className="input-pill p-0"
                              name="factoryUnit"
                              placeholder="Select Unit"
                              options={factorySizeUnitsOptions}
                              onChange={(opt) => updateFactoryDetails(index, 'factoryUnit', opt ? opt.value : "")}
                              value={findOption(factorySizeUnitsOptions, factory.factoryUnit)}
                              isClearable
                            />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <input type="number" className="input-pill" placeholder="No of Employees / Staff" name="noOfEmployees" value={factory.noOfEmployees || ''} onChange={(e) => updateFactoryDetails(index, 'noOfEmployees', e.target.value)} min="0" />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <input type="number" className="input-pill" placeholder="No of Quality Staff" name="noOfQualityStaff" value={factory.noOfQualityStaff || ''} onChange={(e) => updateFactoryDetails(index, 'noOfQualityStaff', e.target.value)} min="0" />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <input type="number" className="input-pill" placeholder="No of Research & Development Staff" name="noOfRDStaff" value={factory.noOfRDStaff || ''} onChange={(e) => updateFactoryDetails(index, 'noOfRDStaff', e.target.value)} min="0" />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <input type="number" className="input-pill" placeholder="Total Number of Production Lines" name="totalProductionLines" value={factory.totalProductionLines || ''} onChange={(e) => updateFactoryDetails(index, 'totalProductionLines', e.target.value)} min="0" />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <input type="number" className="input-pill" placeholder="Annual Output" name="annualOutput" value={factory.annualOutput || ''} onChange={(e) => updateFactoryDetails(index, 'annualOutput', e.target.value)} min="0" />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <input type="number" className="input-pill" placeholder="Average Lead Time For Production" name="averageLeadTime" value={factory.averageLeadTime || ''} onChange={(e) => updateFactoryDetails(index, 'averageLeadTime', e.target.value)} min="0" />
                          </div>
                          <div className="col-12 col-md-6 col-lg-9">
                            <input className="input-pill" placeholder="Address" name="factoryAddress" value={factory.factoryAddress || ''} onChange={(e) => updateFactoryDetails(index, 'factoryAddress', e.target.value)} />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <Select
                              className="input-pill p-0"
                              name="factoryCountry"
                              placeholder="Country/Region"
                              options={countries}
                              onChange={(opt) => handleFactoryLocationChangeArray(index, "factoryCountry", opt)}
                              value={findOption(countries, factory.factoryCountry, 'label')}
                              isClearable
                            />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <Select
                              className="input-pill p-0"
                              name="factoryState"
                              placeholder="State"
                              options={factory.factoryStates || []}
                              onChange={(opt) => handleFactoryLocationChangeArray(index, "factoryState", opt)}
                              value={findOption(factory.factoryStates || [], factory.factoryState, 'label')}
                              isDisabled={!factory.factoryCountry}
                              isLoading={loadingFactoryStates}
                              isClearable
                            />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <Select
                              className="input-pill p-0"
                              name="factoryCity"
                              placeholder={loadingFactoryCities ? "Loading cities..." : factory.factoryState ? "Select City" : "Select State first"}
                              options={factory.factoryCities || []}
                              onChange={(opt) => handleFactoryLocationChangeArray(index, "factoryCity", opt)}
                              value={findOption(factory.factoryCities || [], factory.factoryCity, 'label')}
                              isDisabled={!factory.factoryState || loadingFactoryCities}
                              isLoading={loadingFactoryCities}
                              isClearable
                              noOptionsMessage={({ inputValue }) => {
                                if (!factory.factoryState) {
                                  return "Please select a state first";
                                }
                                if (loadingFactoryCities) {
                                  return "Loading cities...";
                                }
                                return inputValue ? `No cities found for "${inputValue}"` : "No cities available";
                              }}
                            />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <input className="input-pill" placeholder="Pincode (000000)" name="factoryPincode" value={factory.factoryPincode || ''} onChange={(e) => updateFactoryDetails(index, 'factoryPincode', e.target.value)} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </section>

                <section className="sp-section">
                  <div className="sp-subcard">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="sp-section-title">📦 Warehouse Location</h6>
                      <button type="button" className="btn-add" onClick={addWarehouseLocation}>+ Add More</button>
                    </div>
                    {warehouseLocationsList.map((warehouse, index) => (
                      <div key={index} className="mb-4">
                        {warehouseLocationsList.length > 1 && (
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="sp-section-subtitle">Warehouse {index + 1}</h6>
                            <button type="button" className="btn-icon-remove" onClick={() => removeWarehouseLocation(index)} title="Remove Warehouse">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="3 6 5 6 21 6"></polyline>
                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                <line x1="10" y1="11" x2="10" y2="17"></line>
                                <line x1="14" y1="11" x2="14" y2="17"></line>
                              </svg>
                            </button>
                          </div>
                        )}
                        <div className="row g-2">
                          <div className="col-12 col-md-3">
                            <input className="input-pill" placeholder="Warehouse Name" name="warehouseName" value={warehouse.warehouseName || ''} onChange={(e) => updateWarehouseLocation(index, 'warehouseName', e.target.value)} />
                          </div>
                          <div className="col-12 col-md-3">
                            <input type="number" className="input-pill" placeholder="Stock Quantity" name="stockQuantity" value={warehouse.stockQuantity || ''} onChange={(e) => updateWarehouseLocation(index, 'stockQuantity', e.target.value)} min="0" />
                          </div>
                          <div className="col-12 col-md-6">
                            <input className="input-pill" placeholder="Address" name="warehouseAddress" value={warehouse.warehouseAddress || ''} onChange={(e) => updateWarehouseLocation(index, 'warehouseAddress', e.target.value)} />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <Select
                              className="input-pill p-0"
                              name="warehouseCountry"
                              placeholder="Country/Region"
                              options={countries}
                              onChange={(opt) => handleWarehouseLocationChangeArray(index, "warehouseCountry", opt)}
                              value={findOption(countries, warehouse.warehouseCountry, 'label')}
                              isClearable
                            />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <Select
                              className="input-pill p-0"
                              name="warehouseState"
                              placeholder="State"
                              options={warehouse.warehouseStates || []}
                              onChange={(opt) => handleWarehouseLocationChangeArray(index, "warehouseState", opt)}
                              value={findOption(warehouse.warehouseStates || [], warehouse.warehouseState, 'label')}
                              isDisabled={!warehouse.warehouseCountry}
                              isLoading={loadingFactoryStates}
                              isClearable
                            />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <Select
                              className="input-pill p-0"
                              name="warehouseCity"
                              placeholder={loadingFactoryCities ? "Loading cities..." : warehouse.warehouseState ? "Select City" : "Select State first"}
                              options={warehouse.warehouseCities || []}
                              onChange={(opt) => handleWarehouseLocationChangeArray(index, "warehouseCity", opt)}
                              value={findOption(warehouse.warehouseCities || [], warehouse.warehouseCity, 'label')}
                              isDisabled={!warehouse.warehouseState || loadingFactoryCities}
                              isLoading={loadingFactoryCities}
                              isClearable
                              noOptionsMessage={({ inputValue }) => {
                                if (!warehouse.warehouseState) {
                                  return "Please select a state first";
                                }
                                if (loadingFactoryCities) {
                                  return "Loading cities...";
                                }
                                return inputValue ? `No cities found for "${inputValue}"` : "No cities available";
                              }}
                            />
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <input className="input-pill" placeholder="Pincode (000000)" name="warehousePincode" value={warehouse.warehousePincode || ''} onChange={(e) => updateWarehouseLocation(index, 'warehousePincode', e.target.value)} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </section>

                <section className="sp-section">
                  <div className="sp-subcard">
                    <h6 className="sp-section-title">🚚 Supply Chain Logistics</h6>
                    <div className="row g-2">
                      {/* First Row */}
                      <div className="col-12 col-md-6 col-lg-3">
                        <input className="input-pill" placeholder="Enter port name" name="nearestPort" value={form.nearestPort || ''} onChange={onChange} />
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <div className="input-group-prefix-suffix input-group-row">
                          <input className="input-middle input-middle-with-border" placeholder="Enter Distance to the Factory" name="factoryToPortDistance" value={form.factoryToPortDistance || ''} onChange={onChange} />
                          <div className="input-prefix input-prefix-no-borders">
                            <select name="factoryToPortDistanceUnit" value={form.factoryToPortDistanceUnit || 'km'} onChange={onChange}>
                              {factoryDistanceUnitsOptions.map((d) => (
                                <option key={d.value} value={d.value}>{d.label}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <input className="input-pill" placeholder="Enter airport name" name="nearestAirport" value={form.nearestAirport || ''} onChange={onChange} />
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <div className="input-group-prefix-suffix input-group-row">
                          <input className="input-middle input-middle-with-border" placeholder="Enter Distance to Port/Airport" name="factoryToAirportDistance" value={form.factoryToAirportDistance || ''} onChange={onChange} />
                          <div className="input-prefix input-prefix-no-borders">
                            <select name="factoryToAirportDistanceUnit" value={form.factoryToAirportDistanceUnit || 'km'} onChange={onChange}>
                              {factoryDistanceUnitsOptions.map((d) => (
                                <option key={d.value} value={d.value}>{d.label}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      {/* Second Row */}
                      <div className="col-12 col-md-6 col-lg-3">
                        <input className="input-pill" placeholder="Enter highway name" name="nearestHighway" value={form.nearestHighway || ''} onChange={onChange} />
                      </div>
                      <div className="col-12 col-md-6 col-lg-3">
                        <div className="input-group-prefix-suffix input-group-row">
                          <input className="input-middle input-middle-with-border" placeholder="Enter Distance to the Factory" name="factoryToHighwayDistance" value={form.factoryToHighwayDistance || ''} onChange={onChange} />
                          <div className="input-prefix input-prefix-no-borders">
                            <select name="factoryToHighwayDistanceUnit" value={form.factoryToHighwayDistanceUnit || 'km'} onChange={onChange}>
                              {factoryDistanceUnitsOptions.map((d) => (
                                <option key={d.value} value={d.value}>{d.label}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sp-section">
                  <div className="sp-subcard">
                    <h6 className="sp-section-title">🚢 Shipping Information</h6>
                    <div className="row g-2">
                      <div className="col-12 col-md-4">
                        <Select
                          className="input-pill p-0"
                          name="shippingTerms"
                          placeholder="Shipping Terms"
                          options={shippingTermsOptions}
                          onChange={(opt) => setForm(prev => ({ ...prev, shippingTerms: opt?.value || "" }))}
                          value={findOption(shippingTermsOptions, form.shippingTerms)}
                          isClearable
                        />
                      </div>
                      <div className="col-12 col-md-4">
                        <Select
                          className="input-pill p-0"
                          name="modeOfTransport"
                          placeholder="Mode of Transport"
                          options={modeOfTransportOptions}
                          onChange={(opt) => setForm(prev => ({ ...prev, modeOfTransport: opt?.value || "" }))}
                          value={findOption(modeOfTransportOptions, form.modeOfTransport)}
                          isClearable
                        />
                      </div>
                      <div className="col-12 col-md-4">
                        <Select
                          className="input-pill p-0"
                          name="dispatchLocation"
                          placeholder="Dispatch Location"
                          options={countries}
                          onChange={(opt) => setForm(prev => ({ ...prev, dispatchLocation: opt?.value || "" }))}
                          value={findOption(countries, form.dispatchLocation)}
                          isClearable
                        />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sp-section">
                  <div className="sp-subcard">
                    <h6 className="sp-section-title">💳 Accepted Payment Methods</h6>
                    <div className="row g-2">
                      <div className="col-12 col-md-3">
                        <Select
                          className="input-pill p-0"
                          name="paymentMethod"
                          placeholder="Payment Method"
                          options={paymentMethodOptions}
                          onChange={(opt) => {
                            const value = opt?.value || "";
                            setForm(prev => ({ 
                              ...prev, 
                              paymentMethod: value,
                              // Also update paymentMethods array for payload building
                              paymentMethods: value ? [String(value)] : []
                            }));
                          }}
                          value={findOption(paymentMethodOptions, form.paymentMethod)}
                          isClearable
                        />
                      </div>
                      <div className="col-12 col-md-3">
                        <Select
                          className="input-pill p-0"
                          name="paymentSchedule"
                          placeholder="Payment Schedule"
                          options={paymentScheduleOptions}
                          onChange={(opt) => setForm(prev => ({ ...prev, paymentSchedule: opt?.value || "" }))}
                          value={findOption(paymentScheduleOptions, form.paymentSchedule)}
                          isClearable
                        />
                      </div>
                      <div className="col-12 col-md-3">
                        <Select
                          className="input-pill p-0"
                          name="latePaymentPolicy"
                          placeholder="Late Payment Policy"
                          options={latePaymentPolicyOptions}
                          onChange={(opt) => setForm(prev => ({ ...prev, latePaymentPolicy: opt?.value || "" }))}
                          value={findOption(latePaymentPolicyOptions, form.latePaymentPolicy)}
                          isClearable
                        />
                      </div>
                      <div className="col-12 col-md-3">
                        <Select
                          className="input-pill p-0"
                          name="paymentCurrency"
                          placeholder="Currency"
                          options={currencyOptions}
                          onChange={(opt) => setForm(prev => ({ ...prev, paymentCurrency: opt?.value || "" }))}
                          value={findOption(currencyOptions, form.paymentCurrency)}
                          isClearable
                        />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sp-section">
                  <div className="sp-subcard">
                    <h6 className="sp-section-title">🔄 Refund Policy</h6>
                    <div className="row g-2">
                      <div className="col-12">
                        <textarea className="input-area" placeholder="Refund Policy Description" name="refundPolicyDescription" value={form.refundPolicyDescription || ''} onChange={onChange} rows="2"></textarea>
                      </div>
                    </div>
                  </div>
                </section>

                <div className="sp-actions-row mb-2">
                  <div className="sp-left-actions">
                    <button type="button" className="btn btn-outline-primary sp-back" onClick={handleBack}>Back</button>
                  </div>
                  <div className="sp-right-actions">
                    <button type="button" className="btn btn-primary" onClick={saveFactoryDetails}>Save</button>
                    {isFactoryDetailsSaved && (
                      <button type="button" className="btn btn-outline-primary ms-2" onClick={handleNext}>Next</button>
                    )}
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane tab={<span><span className="tab-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg></span> Quality Control</span>} key="3">
              <div className="container-fluid">
                <section className="sp-section">
                  <div className="sp-subcard quality-control-card">
                    <h6 className="sp-section-title">✅ Quality Control <span className="required-asterisk">*</span></h6>
                    <div className="row g-2">
                      <div className="col-12">
                        <textarea className="input-area" placeholder="Please describe your organization's quality control process. *" name="qualityControlProcess" value={form.qualityControlProcess || ''} onChange={onChange} rows="2" required></textarea>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sp-section">
                  <div className="sp-subcard certificates-card">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="sp-section-title">📜 Certificates</h6>
                      <button type="button" className="btn-add" onClick={addCertificate}>+ Add More</button>
                    </div>
                    {certificatesList.map((certificate, index) => (
                      <section key={index} className="sp-section">
                        <div className="sp-subcard">
                          {certificatesList.length > 1 && (
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <h6 className="sp-section-subtitle">Certificate {index + 1}</h6>
                              <button type="button" className="btn-icon-remove" onClick={() => removeCertificate(index)} title="Remove Certificate">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                  <polyline points="3 6 5 6 21 6" />
                                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                  <line x1="10" y1="11" x2="10" y2="17" />
                                  <line x1="14" y1="11" x2="14" y2="17" />
                                </svg>
                              </button>
                            </div>
                          )}
                          <div className="certificate-entry">
                            <div className="row g-2">
                              <div className="col-12 col-md-6 col-lg-3">
                                <input className="input-pill" placeholder="Title" name="certificateTitle" value={certificate.certificateTitle || ''} onChange={(e) => updateCertificate(index, 'certificateTitle', e.target.value)} />
                              </div>
                              <div className="col-12 col-md-6 col-lg-3">
                                <input className="input-pill" placeholder="Certification Company" name="certificationCompany" value={certificate.certificationCompany || ''} onChange={(e) => updateCertificate(index, 'certificationCompany', e.target.value)} />
                              </div>
                              <div className="col-12 col-md-6 col-lg-3">
                                <label className="form-label form-label-small">Date Issued</label>
                                <input className="input-pill" name="certificateStartDate" value={certificate.certificateStartDate || ''} onChange={(e) => updateCertificate(index, 'certificateStartDate', e.target.value)} type="date" />
                              </div>
                              <div className="col-12 col-md-6 col-lg-3">
                                <label className="form-label form-label-small">Expiry Date</label>
                                <input className="input-pill" name="certificateEndDate" value={certificate.certificateEndDate || ''} onChange={(e) => updateCertificate(index, 'certificateEndDate', e.target.value)} type="date" />
                              </div>
                            </div>
                            <div className="col-12">
                              <textarea className="input-area" placeholder="Enter Details about Certificate" name="certificateDetails" value={certificate.certificateDetails || ''} onChange={(e) => updateCertificate(index, 'certificateDetails', e.target.value)} rows="2"></textarea>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                              <div className="file-upload-component">
                                <div className="file-title">Attachment (jpg, jpeg and png formats are supported)</div>
                                <label className="file-box">
                                  <div className="file-content">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="upload-icon">
                                      <path d="M12 3v12"></path>
                                      <path d="m17 8-5-5-5 5"></path>
                                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                    </svg>
                                    <span className="choose-text">Choose file</span>
                                  </div>
                                  <input type="file" className="d-none" accept=".jpg,.jpeg,.png" onChange={(e) => handleCertificateFileChange(index, e)} disabled={uploading} />
                                  {certificate.certificateAttachmentUrl && (
                                    <div className="mt-2 small text-success">
                                      ✓ Uploaded: {certificate.certificateAttachmentUrl.split('/').pop()}
                                    </div>
                                  )}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    ))}
                  </div>
                </section>


                <div className="sp-actions-row mb-2">
                  <div className="sp-left-actions">
                    <button type="button" className="btn btn-outline-primary sp-back" onClick={handleBack}>Back</button>
                  </div>
                  <div className="sp-right-actions">
                    <button type="button" className="btn btn-primary" onClick={saveQualityDetails}>Save</button>
                    {isQualityDetailsSaved && (
                      <button type="button" className="btn btn-outline-primary ms-2" onClick={handleNext}>Next</button>
                    )}
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane tab={<span><span className="tab-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"></path><path d="M12 22V12"></path><polyline points="3.29 7 12 12 20.71 7"></polyline><path d="m7.5 4.27 9 5.15"></path></svg></span> Product Catalogue</span>} key="4">
              <div className="container-fluid">
                {/* Add Product Button */}
                <div className="d-flex justify-content-end mb-2 mt-2">
                  <button
                    type="button"
                    className="btn-add"
                    onClick={handleAddProduct}
                    disabled={!productCatalogueCollapsed}
                  >
                    + Add Product
                  </button>
                </div>

                {/* Collapsible Product Details Form */}
                {!productCatalogueCollapsed && (
                  <>
                    {/* Product Details */}
                    <section className="sp-section">
                      <div className="sp-subcard">
                        <h6 className="sp-section-title">📦 Product Details</h6>
                        <div className="row g-2">
                          <div className="col-12 col-md-6 col-lg-5-custom"><input className="input-pill" placeholder="Product Name *" name="pd_name" value={form.pd_name || ''} onChange={onChange} required /></div>
                          <div className="col-12 col-md-6 col-lg-5-custom"><input className="input-pill" placeholder="Brand *" name="pd_brand" value={form.pd_brand || ''} onChange={onChange} required /></div>
                          <div className="col-12 col-md-6 col-lg-5-custom">
                            <select 
                              className="input-pill" 
                              name="pd_cat" 
                              value={form.pd_cat || ''} 
                              onChange={handleCategoryChange} 
                              required
                              disabled={loadingCategories}
                            >
                              <option value="">{loadingCategories ? 'Loading categories...' : 'Product Category *'}</option>
                              {categoryData && categoryData.length > 0 ? (
                                categoryData.map((cat) => (
                                  <option key={cat.id} value={String(cat.id)}>{cat.name}</option>
                                ))
                              ) : (
                                !loadingCategories && <option value="" disabled>No categories available</option>
                              )}
                            </select>
                          </div>
                          <div className="col-12 col-md-6 col-lg-5-custom">
                            <select 
                              className="input-pill" 
                              name="pd_subcat" 
                              value={form.pd_subcat || ''} 
                              onChange={handleSubcategoryChange} 
                              disabled={!form.pd_cat || loadingCategories || hookLoadingSubCategories} 
                              required
                            >
                              <option value="">{hookLoadingSubCategories ? 'Loading subcategories...' : 'Product Sub-category *'}</option>
                              {/* Use dynamically loaded subcategories from hook (master_sub_category table) */}
                              {hookSubCategories.map((sub) => (
                                <option key={sub.id} value={String(sub.id)}>{sub.name}</option>
                              ))}
                              {/* Fallback to categoryData if dynamic loading hasn't completed yet */}
                              {hookSubCategories.length === 0 && !hookLoadingSubCategories && (categoryData.find(c => String(c.id) === String(form.pd_cat))?.subs || []).map((sub) => (
                                <option key={sub.id} value={String(sub.id)}>{sub.name}</option>
                              ))}
                            </select>
                          </div>
                          <div className="col-12 col-md-6 col-lg-5-custom">
                            <select 
                              className="input-pill" 
                              name="pd_subsubcat" 
                              value={form.pd_subsubcat || ''} 
                              onChange={handleSubSubcategoryChange} 
                              disabled={!form.pd_subcat || loadingCategories || hookLoadingSubSubCategories} 
                              required
                            >
                              <option value="">{hookLoadingSubSubCategories ? 'Loading sub-subcategories...' : 'Product Sub-Sub Category *'}</option>
                              {/* Use dynamically loaded sub-subcategories from hook (master_sub_sub_category table) */}
                              {hookSubSubCategories.map((ss) => (
                                <option key={ss.id} value={String(ss.id)}>{ss.name}</option>
                              ))}
                              {/* Fallback to categoryData if dynamic loading hasn't completed yet */}
                              {hookSubSubCategories.length === 0 && !hookLoadingSubSubCategories && (categoryData.find(c => String(c.id) === String(form.pd_cat))?.subs?.find(s => String(s.id) === String(form.pd_subcat))?.subs || []).map((ss) => (
                                <option key={ss.id} value={String(ss.id)}>{ss.name}</option>
                              ))}
                            </select>
                          </div>
                          <div className="col-12 col-md-6 col-lg-3">
                            <div className="input-pill input-pill-toggle input-pill-main-products">
                              <span>main products</span>
                              <div
                                className={`sp-switch ${form.pd_main_product ? 'on' : 'off'}`}
                                role="switch"
                                aria-checked={!!form.pd_main_product}
                                onClick={() => setForm(prev => ({ ...prev, pd_main_product: !prev.pd_main_product }))}
                              >
                                <span className="sp-switch-label">{form.pd_main_product ? 'Yes' : 'No'}</span>
                                <span className="sp-switch-thumb"></span>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6 col-lg-3"><input className="input-pill" placeholder="HSN Code" name="pd_hsn" value={form.pd_hsn || ''} onChange={onChange} /></div>
                          <div className="col-12 col-md-6 col-lg-3"><input className="input-pill" placeholder="Tax Code" name="pd_taxcode" value={form.pd_taxcode || ''} onChange={onChange} /></div>
                          <div className="col-12 col-md-6 col-lg-3"><input className="input-pill" placeholder="Model Number" name="pd_model" value={form.pd_model || ''} onChange={onChange} /></div>
                          {/* <div className="col-12 col-md-6 col-lg-9">
                        <div className="product-input-row">
                        <input className="input-pill" placeholder="Enter Keywords here eg. chilli powder" value={keywordInput} onChange={(e) => setKeywordInput(e.target.value)} />
                        <button type="button" className="btn-add" onClick={addKeyword}>+ Add</button>
                      </div></div>
                      <div className="col-12 col-md-6 col-lg-12">
                      <div className="tags">
                        {keywords.map(k => (
                          <span className="tag" key={k}>{k} <button type="button" className="tag-x" onClick={() => removeKeyword(k)}>×</button></span>
                        ))}
                      </div>
                      </div> */}
                          <div className="col-12"><textarea className="input-area" rows="3" placeholder="Product Description *" name="pd_desc" value={form.pd_desc || ''} onChange={onChange} required></textarea></div>
                        </div>

                        {/* Keywords */}
                        <div className="keywords-section">
                          <h6 className="sp-section-title">🔑 Keywords <span className="required-asterisk">*</span></h6>
                          <div className="product-input-row">
                            <input className="input-pill" placeholder="eg. chilli powder" value={keywordInput} onChange={(e) => setKeywordInput(e.target.value)} />
                            <button type="button" className="btn-add" onClick={addKeyword}>+ Add</button>
                          </div>
                          <div className="tags">
                            {keywords.map(k => (
                              <span className="tag" key={k}>{k} <button type="button" className="tag-x" onClick={() => removeKeyword(k)}>×</button></span>
                            ))}
                          </div>
                        </div>

                        {/* Uploads */}
                        <div className="row g-2 uploads-section">
                          <div className="col-12 col-md-6">
                            <div className="file-upload-component">
                              <div className="file-title">Upload the Product catalogue (20*30 px)</div>
                              <label className="file-box">
                                <div className="file-content">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="upload-icon"><path d="M12 3v12"></path><path d="m17 8-5-5-5 5"></path><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path></svg>
                                  <span className="choose-text">{uploadingProductFiles ? 'Uploading...' : 'Choose file'}</span>
                                </div>
                                <input 
                                  type="file" 
                                  accept=".pdf,.doc,.docx" 
                                  onChange={handleProductCatalogueUpload}
                                  disabled={uploadingProductFiles}
                                />
                              </label>
                              {productCatalogueUrl && (
                                <div className="mt-2 small text-success">
                                  ✓ Uploaded: {productCatalogueUrl.split('/').pop()}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="file-upload-component">
                              <div className="file-title">Upload Product Video ( Max 100 MB, MP4, MOV, AVI, MKV, WEBM )</div>
                              <label className="file-box">
                                <div className="file-content">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="upload-icon"><path d="M12 3v12"></path><path d="m17 8-5-5-5 5"></path><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path></svg>
                                  <span className="choose-text">{uploadingProductFiles ? 'Uploading...' : 'Choose file'}</span>
                                </div>
                                <input 
                                  type="file" 
                                  accept=".mp4,.mov,.avi,.mkv,.webm" 
                                  onChange={handleProductVideoUpload}
                                  disabled={uploadingProductFiles}
                                />
                              </label>
                              {productVideoUrl && (
                                <div className="mt-2 small text-success">
                                  ✓ Uploaded: {productVideoUrl.split('/').pop()}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    {/* Colour Options */}
                    <section className="sp-section">
                      <div className="sp-subcard">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="sp-section-title">🎨 Colour Options</h6>
                          <button type="button" className="btn-add" onClick={addColourOption}>+ Add More</button>
                        </div>
                        {colourOptionsList.map((option, index) => (
                          <div key={option.id} className={index > 0 ? "mt-3" : ""}>
                            <div className="row g-2">
                              <div className="col-12 col-md-6 col-lg-3">
                                <input 
                                  className="input-pill" 
                                  placeholder="#ED00BE" 
                                  value={option.color || ''} 
                                  readOnly 
                                />
                              </div>
                              <div className="col-12 col-md-2 col-lg-1">
                                <div className="input-pill color-picker-pill">
                                  <input
                                    type="color"
                                    className="color-input"
                                    value={option.color || '#ED00BE'}
                                    onChange={(e) => updateColourOption(option.id, 'color', e.target.value)}
                                    aria-label="Pick colour"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-6 col-lg-7">
                                <div className="file-upload-component">
                                  <label className="file-box">
                                    <div className="file-content">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="upload-icon"><path d="M12 3v12"></path><path d="m17 8-5-5-5 5"></path><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path></svg>
                                      <span className="choose-text">Upload color image (206*206px, max 2MB)</span>
                                    </div>
                                    <input 
                                      type="file" 
                                      accept=".jpg,.jpeg,.png" 
                                      onChange={async (e) => {
                                        const file = e.target.files?.[0];
                                        if (file) {
                                          try {
                                            setUploadingProductFiles(true);
                                            const fileUrl = await uploadFile(file, 'product_image', 'product');
                                            updateColourOption(option.id, 'imageUrl', fileUrl);
                                            toast.success('Color image uploaded successfully');
                                          } catch (error) {
                                            console.error('Error uploading color image:', error);
                                          } finally {
                                            setUploadingProductFiles(false);
                                          }
                                        }
                                      }}
                                      disabled={uploadingProductFiles}
                                    />
                                  </label>
                                  {option.imageUrl && (
                                    <div className="mt-2 small text-success">
                                      ✓ Uploaded: {option.imageUrl.split('/').pop()}
                                    </div>
                                  )}
                                </div>
                              </div>
                              {colourOptionsList.length > 1 && (
                                <div className="col-12 col-md-1 col-lg-1">
                                  <button
                                    type="button"
                                    className="btn-delete"
                                    onClick={() => removeColourOption(option.id)}
                                    title="Remove"
                                  >
                                    ×
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>

                    {/* Customization */}
                    <section className="sp-section">
                      <div className="sp-subcard">
                        <div className="d-flex align-items-center mb-3 sp-section-header">
                          <h6 className="sp-section-title">🛠️ Customization Available</h6>
                          <div
                            className={`sp-switch ${form.pd_custom_available ? 'on' : 'off'}`}
                            role="switch"
                            aria-checked={!!form.pd_custom_available}
                            onClick={() => setForm(prev => ({ ...prev, pd_custom_available: !prev.pd_custom_available }))}
                          >
                            <span className="sp-switch-label">{form.pd_custom_available ? 'Yes' : 'No'}</span>
                            <span className="sp-switch-thumb"></span>
                          </div>
                        </div>
                        {form.pd_custom_available && (
                          <>
                            <div className="row g-2">
                              <div className="col-12">
                                <Select
                                  className="input-pill p-0"
                                  name="pd_custom_type"
                                  placeholder="Select Type of Customization"
                                  options={customizationTypesOptions}
                                  onChange={(opt) => setForm(prev => ({ ...prev, pd_custom_type: opt?.value || "" }))}
                                  value={findOption(customizationTypesOptions, form.pd_custom_type)}
                                  isClearable
                                />
                              </div>
                            </div>

                            {form.pd_custom_type && (
                              <div className="customization-grid mt-4">
                                <div className="cg-header">Specification of Customization</div>
                                <div className="cg-header text-center">YES / NO</div>
                                <div className="cg-header text-center">MOQ</div>
                                <div className="cg-header text-center">Price (Without Tax)</div>
                                <div className="cg-header text-center">Tax %</div>
                                <div className="cg-header text-center">Price (With Tax)</div>
                                <div className="cg-header text-center">Description/image</div>

                                {customizationRows
                                  .filter(row => getCustomizationVisibleRows(form.pd_custom_type).includes(row.id))
                                  .map((row) => (
                                    <React.Fragment key={row.id}>
                                      <div className="cg-cell"><input className="input-pill" value={row.name} readOnly /></div>
                                      <div className="cg-cell text-center">
                                        <div
                                          className={`sp-switch ${row.enabled ? 'on' : 'off'}`}
                                          role="switch"
                                          aria-checked={!!row.enabled}
                                          onClick={() => toggleCustomizationRow(row.id)}
                                        >
                                          <span className="sp-switch-label">{row.enabled ? 'Yes' : 'No'}</span>
                                          <span className="sp-switch-thumb"></span>
                                        </div>
                                      </div>
                                      <div className="cg-cell">{renderCustomizationInput(row, 'moq')}</div>
                                      <div className="cg-cell">{renderCustomizationInput(row, 'priceNoTax')}</div>
                                      <div className="cg-cell">{renderCustomizationInput(row, 'tax')}</div>
                                      <div className="cg-cell">{renderCustomizationInput(row, 'priceWithTax')}</div>
                                      <div className="cg-cell">{renderDescCell(row)}</div>
                                    </React.Fragment>
                                  ))}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </section>

                    {/* Dimensions */}
                    <section className="sp-section">
                      <div className="sp-subcard">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="sp-section-title">📐 Dimensions</h6>
                          <button type="button" className="btn-add" onClick={addDimension}>+ Add More</button>
                        </div>
                        {dimensionsList.map((dim, index) => (
                          <div key={dim.id} className={index > 0 ? "mt-3" : ""}>
                            <div className="row g-2">
                              <div className="col-6 col-md-4 col-lg-3">
                                <input 
                                  className="input-pill" 
                                  placeholder="Height" 
                                  value={dim.height || ''} 
                                  onChange={(e) => updateDimension(dim.id, 'height', e.target.value)} 
                                />
                              </div>
                              <div className="col-6 col-md-4 col-lg-3">
                                <input 
                                  className="input-pill" 
                                  placeholder="Length" 
                                  value={dim.length || ''} 
                                  onChange={(e) => updateDimension(dim.id, 'length', e.target.value)} 
                                />
                              </div>
                              <div className="col-6 col-md-4 col-lg-3">
                                <input 
                                  className="input-pill" 
                                  placeholder="Width" 
                                  value={dim.width || ''} 
                                  onChange={(e) => updateDimension(dim.id, 'width', e.target.value)} 
                                />
                              </div>
                              <div className="col-6 col-md-4 col-lg-3">
                                <div className="d-flex align-items-center gap-2">
                                  <Select
                                    className="input-pill p-0 flex-grow-1"
                                    placeholder="Unit of Measurements"
                                    options={dimensionUnitOptions}
                                    onChange={(opt) => updateDimension(dim.id, 'uom', opt?.value || "")}
                                    value={(() => {
                                      const found = findOption(dimensionUnitOptions, dim.uom);
                                      if (dim.uom && !found) {
                                        console.log('Unit not found in options:', {
                                          dim_uom: dim.uom,
                                          dim_uom_type: typeof dim.uom,
                                          available_options: dimensionUnitOptions?.map(opt => ({ value: opt.value, label: opt.label })),
                                          trying_to_match: String(dim.uom).trim()
                                        });
                                      }
                                      return found;
                                    })()}
                                    isClearable
                                  />
                                  {dimensionsList.length > 1 && (
                                    <button
                                      type="button"
                                      className="btn-delete"
                                      onClick={() => removeDimension(dim.id)}
                                      title="Remove"
                                    >
                                      ×
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>

                    {/* Dynamic Attributes Section - Loaded from master_category_attributes table */}
                    {form?.pd_cat && (
                      <section className="sp-section">
                        <div className="sp-subcard">
                          <h6 className="sp-section-title">⚡ Dynamic Attributes</h6>
                          {categoryAttributesLoading ? (
                            <div className="text-center py-3">
                              <span className="text-muted">Loading attributes...</span>
                            </div>
                          ) : categoryAttributesError ? (
                            <div className="text-center py-3">
                              <span className="text-danger">Error loading attributes: {categoryAttributesError?.message || 'Unknown error'}</span>
                            </div>
                          ) : categoryAttributes && categoryAttributes.length > 0 ? (
                            <div className="row g-2">
                              {categoryAttributes
                              .filter(attr => attr.is_active)
                              .sort((a, b) => (a.display_order || 0) - (b.display_order || 0))
                              .map((attr) => (
                                <React.Fragment key={attr.attribute_id}>
                                  {/* Main Attribute Field */}
                                  <div className="col-12 col-md-6 col-lg-3">
                                    {attr.attribute_type === 'select' || attr.attribute_type === 'multiselect' ? (
                                      <Select
                                        className="input-pill p-0"
                                        name={attr.attribute_key}
                                        placeholder={attr.attribute_name || `Select ${attr.attribute_key}`}
                                        options={attr.options || []}
                                        onChange={(opt) => {
                                          const value = attr.attribute_type === 'multiselect' 
                                            ? (opt || []).map(o => o.value)
                                            : opt?.value || "";
                                          setForm(prev => ({ ...prev, [attr.attribute_key]: value }));
                                        }}
                                        value={(() => {
                                          const formValue = form[attr.attribute_key];
                                          if (attr.attribute_type === 'multiselect') {
                                            if (Array.isArray(formValue)) {
                                              return formValue.map(v => attr.options?.find(opt => opt.value === v)).filter(Boolean);
                                            }
                                            return [];
                                          }
                                          return findOption(attr.options || [], formValue);
                                        })()}
                                        isMulti={attr.attribute_type === 'multiselect'}
                                        isClearable
                                        required={attr.is_required}
                                      />
                                    ) : attr.attribute_type === 'boolean' ? (
                                      <div className="input-pill input-pill-toggle">
                                        <span>{attr.attribute_name || attr.attribute_key}</span>
                                        <div
                                          className={`sp-switch ${form[attr.attribute_key] ? 'on' : 'off'}`}
                                          role="switch"
                                          aria-checked={!!form[attr.attribute_key]}
                                          onClick={() => setForm(prev => ({ ...prev, [attr.attribute_key]: !prev[attr.attribute_key] }))}
                                        >
                                          <span className="sp-switch-label">{form[attr.attribute_key] ? 'Yes' : 'No'}</span>
                                          <span className="sp-switch-thumb"></span>
                                        </div>
                                      </div>
                                    ) : attr.attribute_type === 'number' ? (
                                      <input
                                        className="input-pill"
                                        type="number"
                                        placeholder={attr.attribute_name || `Enter ${attr.attribute_key}`}
                                        name={attr.attribute_key}
                                        value={form[attr.attribute_key] || ''}
                                        onChange={onChange}
                                        required={attr.is_required}
                                      />
                                    ) : (
                                      <input
                                        className="input-pill"
                                        type="text"
                                        placeholder={attr.attribute_name || `Enter ${attr.attribute_key}`}
                                        name={attr.attribute_key}
                                        value={form[attr.attribute_key] || ''}
                                        onChange={onChange}
                                        required={attr.is_required}
                                      />
                                    )}
                                  </div>

                                  {/* Sub-Attributes */}
                                  {attr.sub_attributes && attr.sub_attributes.length > 0 && (
                                    <>
                                      {attr.sub_attributes
                                        .filter(subAttr => subAttr.is_active)
                                        .sort((a, b) => (a.display_order || 0) - (b.display_order || 0))
                                        .map((subAttr) => (
                                          <div key={subAttr.sub_attribute_id} className="col-12 col-md-6 col-lg-3">
                                            {subAttr.attribute_type === 'select' || subAttr.attribute_type === 'multiselect' ? (
                                              <Select
                                                className="input-pill p-0"
                                                name={subAttr.sub_attribute_key}
                                                placeholder={subAttr.sub_attribute_name || `Select ${subAttr.sub_attribute_key}`}
                                                options={subAttr.options || []}
                                                onChange={(opt) => {
                                                  const value = subAttr.attribute_type === 'multiselect' 
                                                    ? (opt || []).map(o => o.value)
                                                    : opt?.value || "";
                                                  setForm(prev => ({ ...prev, [subAttr.sub_attribute_key]: value }));
                                                }}
                                                value={(() => {
                                                  const formValue = form[subAttr.sub_attribute_key];
                                                  if (subAttr.attribute_type === 'multiselect') {
                                                    if (Array.isArray(formValue)) {
                                                      return formValue.map(v => subAttr.options?.find(opt => opt.value === v)).filter(Boolean);
                                                    }
                                                    return [];
                                                  }
                                                  return findOption(subAttr.options || [], formValue);
                                                })()}
                                                isMulti={subAttr.attribute_type === 'multiselect'}
                                                isClearable
                                                required={subAttr.is_required}
                                              />
                                            ) : subAttr.attribute_type === 'boolean' ? (
                                              <div className="input-pill input-pill-toggle">
                                                <span>{subAttr.sub_attribute_name || subAttr.sub_attribute_key}</span>
                                                <div
                                                  className={`sp-switch ${form[subAttr.sub_attribute_key] ? 'on' : 'off'}`}
                                                  role="switch"
                                                  aria-checked={!!form[subAttr.sub_attribute_key]}
                                                  onClick={() => setForm(prev => ({ ...prev, [subAttr.sub_attribute_key]: !prev[subAttr.sub_attribute_key] }))}
                                                >
                                                  <span className="sp-switch-label">{form[subAttr.sub_attribute_key] ? 'Yes' : 'No'}</span>
                                                  <span className="sp-switch-thumb"></span>
                                                </div>
                                              </div>
                                            ) : subAttr.attribute_type === 'number' ? (
                                              <input
                                                className="input-pill"
                                                type="number"
                                                placeholder={subAttr.sub_attribute_name || `Enter ${subAttr.sub_attribute_key}`}
                                                name={subAttr.sub_attribute_key}
                                                value={form[subAttr.sub_attribute_key] || ''}
                                                onChange={onChange}
                                                required={subAttr.is_required}
                                              />
                                            ) : (
                                              <input
                                                className="input-pill"
                                                type="text"
                                                placeholder={subAttr.sub_attribute_name || `Enter ${subAttr.sub_attribute_key}`}
                                                name={subAttr.sub_attribute_key}
                                                value={form[subAttr.sub_attribute_key] || ''}
                                                onChange={onChange}
                                                required={subAttr.is_required}
                                              />
                                            )}
                                          </div>
                                        ))}
                                    </>
                                  )}
                                </React.Fragment>
                              ))}
                            </div>
                          ) : (
                            <div className="text-center py-3">
                              <span className="text-muted">No attributes configured for this category.</span>
                            </div>
                          )}
                        </div>
                      </section>
                    )}

                    {/* Attributes - only show when Health & Medical category selected */}
                    {isHealthMedicalCategory(form.pd_cat) && (
                      <section className="sp-section">
                        <div className="sp-subcard">
                          <h6 className="sp-section-title">⚡ Attributes</h6>

                          {/* Wheelchair / Walker Section */}
                          <div className="row g-2 mt-3">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Wheelchair / Walker</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleHealthMedicalSection('wheelchair')}>
                                {healthMedicalSections.wheelchair ? '−' : '+'}
                              </button>
                            </div>
                            {healthMedicalSections.wheelchair && (
                              <>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Product Type" name="hm_product_type" value={form.hm_product_type || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_brake_type" value={form.hm_brake_type || ''} onChange={onChange}>
                                    <option value="">Select Brake Type</option>
                                    {brakeTypeOptions.map((b) => (
                                      <option key={b.id} value={b.id}>{b.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_frame_material" value={form.hm_frame_material || ''} onChange={onChange}>
                                    <option value="">Select Frame Material</option>
                                    {frameMaterialOptions.map((f) => (
                                      <option key={f.id} value={f.id}>{f.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Seat Width" name="hm_seat_width" value={form.hm_seat_width || ''} onChange={onChange} />
                                    <span className="input-suffix">Cm</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_foldable" value={form.hm_foldable || ''} onChange={onChange}>
                                    <option value="">Select Foldable</option>
                                    {foldableOptions.map((f) => (
                                      <option key={f.id} value={f.id}>{f.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Load Capacity" name="hm_load_capacity" value={form.hm_load_capacity || ''} onChange={onChange} />
                                    <span className="input-suffix">kg</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Wheel Size" name="hm_wheel_size" value={form.hm_wheel_size || ''} onChange={onChange} />
                                    <span className="input-suffix">Inches</span>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>

                          {/* Device / Equipment Section */}
                          <div className="row g-2 mt-4">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Device / Equipment</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleHealthMedicalSection('device')}>
                                {healthMedicalSections.device ? '−' : '+'}
                              </button>
                            </div>
                            {healthMedicalSections.device && (
                              <>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Product Name" name="hm_device_product_name" value={form.hm_device_product_name || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-prefix-suffix input-group-row">
                                    <input className="input-middle input-middle-with-border" placeholder="Enter Power Requirements" name="hm_power_requirements" value={form.hm_power_requirements || ''} onChange={onChange} />
                                    <div className="input-prefix input-prefix-no-borders">
                                      <select name="hm_power_unit" value={form.hm_power_unit || ''} onChange={onChange}>
                                        <option value="">Select</option>
                                        {hmPowerUnitOptions.map((u) => (
                                          <option key={u.id} value={u.id}>{u.label}</option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_regulatory_approvals" value={form.hm_regulatory_approvals || ''} onChange={onChange}>
                                    <option value="">Select Regulatory Approvals</option>
                                    {regulatoryApprovalsOptions.map((r) => (
                                      <option key={r.id} value={r.id}>{r.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_sterility_status" value={form.hm_sterility_status || ''} onChange={onChange}>
                                    <option value="">Select Sterility Status</option>
                                    {sterilityStatusOptions.map((s) => (
                                      <option key={s.id} value={s.id}>{s.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_accessories_included" value={form.hm_accessories_included || ''} onChange={onChange}>
                                    <option value="">Select Accessories Included</option>
                                    {accessoriesIncludedOptions.map((a) => (
                                      <option key={a.id} value={a.id}>{a.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Brand" name="hm_brand" value={form.hm_brand || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Battery Type & Capacity" name="hm_battery_type" value={form.hm_battery_type || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Sterilization Method" name="hm_sterilization_method" value={form.hm_sterilization_method || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Ingress Protection" name="hm_ingress_protection" value={form.hm_ingress_protection || ''} onChange={onChange} />
                                    <span className="input-suffix">IP</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_spares_availability" value={form.hm_spares_availability || ''} onChange={onChange}>
                                    <option value="">Select Spares Availability</option>
                                    {sparesAvailabilityOptions.map((s) => (
                                      <option key={s.id} value={s.id}>{s.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Model" name="hm_model" value={form.hm_model || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_safety_standards" value={form.hm_safety_standards || ''} onChange={onChange}>
                                    <option value="">Select Safety Standards</option>
                                    {safetyStandardsOptions.map((s) => (
                                      <option key={s.id} value={s.id}>{s.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_standards_compliance" value={form.hm_standards_compliance || ''} onChange={onChange}>
                                    <option value="">Select Standards Compliance</option>
                                    {standardsComplianceOptions.map((s) => (
                                      <option key={s.id} value={s.id}>{s.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Accuracy" name="hm_accuracy" value={form.hm_accuracy || ''} onChange={onChange} />
                                    <span className="input-suffix">± mmHg</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_device_class" value={form.hm_device_class || ''} onChange={onChange}>
                                    <option value="">Select Device Class</option>
                                    {deviceClassOptions.map((d) => (
                                      <option key={d.id} value={d.id}>{d.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_warranty" value={form.hm_warranty || ''} onChange={onChange}>
                                    <option value="">Select Warranty</option>
                                    {warrantyOptions.map((w) => (
                                      <option key={w.id} value={w.id}>{w.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Measurement Range" name="hm_measurement_range" value={form.hm_measurement_range || ''} onChange={onChange} />
                                    <span className="input-suffix">mmHg</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Materials in Patient Contact" name="hm_materials_patient_contact" value={form.hm_materials_patient_contact || ''} onChange={onChange} />
                                </div>
                              </>
                            )}
                          </div>

                          {/* PPE Section */}
                          <div className="row g-2 mt-4">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">PPE (Personal Protective Equipment)</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleHealthMedicalSection('ppe')}>
                                {healthMedicalSections.ppe ? '−' : '+'}
                              </button>
                            </div>
                            {healthMedicalSections.ppe && (
                              <>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_mask_type" value={form.hm_mask_type || ''} onChange={onChange}>
                                    <option value="">Select Mask Type</option>
                                    {maskTypeOptions.map((m) => (
                                      <option key={m.id} value={m.id}>{m.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_valve" value={form.hm_valve || ''} onChange={onChange}>
                                    <option value="">Select Valve</option>
                                    {valveOptions.map((v) => (
                                      <option key={v.id} value={v.id}>{v.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_glove_material" value={form.hm_glove_material || ''} onChange={onChange}>
                                    <option value="">Select Glove Material</option>
                                    {gloveMaterialOptions.map((g) => (
                                      <option key={g.id} value={g.id}>{g.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_fit_type" value={form.hm_fit_type || ''} onChange={onChange}>
                                    <option value="">Select Fit Type</option>
                                    {hmFitTypeOptions.map((f) => (
                                      <option key={f.id} value={f.id}>{f.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Filtration Efficiency" name="hm_filtration_efficiency" value={form.hm_filtration_efficiency || ''} onChange={onChange} />
                                    <span className="input-suffix">(BFE% / PFE%)</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Glove Thickness" name="hm_glove_thickness" value={form.hm_glove_thickness || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_compliance_standard" value={form.hm_compliance_standard || ''} onChange={onChange}>
                                    <option value="">Select Compliance Standard</option>
                                    {complianceStandardOptions.map((c) => (
                                      <option key={c.id} value={c.id}>{c.label}</option>
                                    ))}
                                  </select>
                                </div>
                              </>
                            )}
                          </div>

                          {/* Diagnostics / Reagents Section */}
                          <div className="row g-2 mt-4">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Diagnostics / Reagents</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleHealthMedicalSection('diagnostics')}>
                                {healthMedicalSections.diagnostics ? '−' : '+'}
                              </button>
                            </div>
                            {healthMedicalSections.diagnostics && (
                              <>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_test_method" value={form.hm_test_method || ''} onChange={onChange}>
                                    <option value="">Select Test Method</option>
                                    {testMethodOptions.map((t) => (
                                      <option key={t.id} value={t.id}>{t.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-prefix-suffix input-group-row">
                                    <input className="input-middle input-middle-with-border" placeholder="Enter Shelf Life (From MFG)" name="hm_diagnostics_shelf_life" value={form.hm_diagnostics_shelf_life || ''} onChange={onChange} />
                                    <div className="input-prefix input-prefix-no-borders">
                                      <select name="hm_diagnostics_shelf_life_unit" value={form.hm_diagnostics_shelf_life_unit || ''} onChange={onChange}>
                                        <option value="">Select</option>
                                        {agriShelfLifeUnitOptions.map((u) => (
                                          <option key={u.id} value={u.id}>{u.label}</option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_controls_included" value={form.hm_controls_included || ''} onChange={onChange}>
                                    <option value="">Select Controls Included</option>
                                    {controlsIncludedOptions.map((c) => (
                                      <option key={c.id} value={c.id}>{c.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Target Analyte" name="hm_target_analyte" value={form.hm_target_analyte || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_diagnostics_regulatory_approvals" value={form.hm_diagnostics_regulatory_approvals || ''} onChange={onChange}>
                                    <option value="">Select Regulatory Approvals</option>
                                    {regulatoryApprovalsOptions.map((r) => (
                                      <option key={r.id} value={r.id}>{r.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_waste_disposal_class" value={form.hm_waste_disposal_class || ''} onChange={onChange}>
                                    <option value="">Select Waste Disposal Class</option>
                                    {wasteDisposalClassOptions.map((w) => (
                                      <option key={w.id} value={w.id}>{w.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_sample_type" value={form.hm_sample_type || ''} onChange={onChange}>
                                    <option value="">Select Sample Type</option>
                                    {sampleTypeOptions.map((s) => (
                                      <option key={s.id} value={s.id}>{s.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Storage Temperature" name="hm_storage_temperature" value={form.hm_storage_temperature || ''} onChange={onChange} />
                                    <span className="input-suffix">°C</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Sensitivity" name="hm_sensitivity" value={form.hm_sensitivity || ''} onChange={onChange} />
                                    <span className="input-suffix">%</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Tests Per Kit" name="hm_tests_per_kit" value={form.hm_tests_per_kit || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Open Kit Stability" name="hm_open_kit_stability" value={form.hm_open_kit_stability || ''} onChange={onChange} />
                                    <span className="input-suffix">Days</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Specificity" name="hm_specificity" value={form.hm_specificity || ''} onChange={onChange} />
                                    <span className="input-suffix">%</span>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>

                          {/* Tablets / Capsules Section */}
                          <div className="row g-2 mt-4">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Tablets / Capsules</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleHealthMedicalSection('tablets')}>
                                {healthMedicalSections.tablets ? '−' : '+'}
                              </button>
                            </div>
                            {healthMedicalSections.tablets && (
                              <>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Generic Name" name="hm_tablets_generic_name" value={form.hm_tablets_generic_name || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-prefix-suffix input-group-row">
                                    <input className="input-middle input-middle-with-border" placeholder="Enter Shelf Life (From MFG)" name="hm_tablets_shelf_life" value={form.hm_tablets_shelf_life || ''} onChange={onChange} />
                                    <div className="input-prefix input-prefix-no-borders">
                                      <select name="hm_tablets_shelf_life_unit" value={form.hm_tablets_shelf_life_unit || ''} onChange={onChange}>
                                        <option value="">Select</option>
                                        {agriShelfLifeUnitOptions.map((u) => (
                                          <option key={u.id} value={u.id}>{u.label}</option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Manufacturer" name="hm_manufacturer" value={form.hm_manufacturer || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Units Per Strip/Blister" name="hm_units_per_strip" value={form.hm_units_per_strip || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Product Name" name="hm_tablets_product_name" value={form.hm_tablets_product_name || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Indication / Use" name="hm_indication_use" value={form.hm_indication_use || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Batch/Lot No" name="hm_batch_lot_no" value={form.hm_batch_lot_no || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_tablets_regulatory_approvals" value={form.hm_tablets_regulatory_approvals || ''} onChange={onChange}>
                                    <option value="">Select Regulatory Approvals</option>
                                    {regulatoryApprovalsOptions.map((r) => (
                                      <option key={r.id} value={r.id}>{r.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_tablets_dosage_form" value={form.hm_tablets_dosage_form || ''} onChange={onChange}>
                                    <option value="">Select Dosage Form</option>
                                    {dosageFormOptions.map((d) => (
                                      <option key={d.id} value={d.id}>{d.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Storage Temperature" name="hm_tablets_storage_temp" value={form.hm_tablets_storage_temp || ''} onChange={onChange} />
                                    <span className="input-suffix">°C</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_tablets_packaging" value={form.hm_tablets_packaging || ''} onChange={onChange}>
                                    <option value="">Select Packaging</option>
                                    {agriPackagingOptions.map((p) => (
                                      <option key={p.id} value={p.id}>{p.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_prescription_type" value={form.hm_prescription_type || ''} onChange={onChange}>
                                    <option value="">Select Prescription Type</option>
                                    {prescriptionTypeOptions.map((p) => (
                                      <option key={p.id} value={p.id}>{p.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Brand Name" name="hm_tablets_brand_name" value={form.hm_tablets_brand_name || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input type="date" className="input-pill" placeholder="dd-mm-yyyy" name="hm_tablets_expiry_date" value={form.hm_tablets_expiry_date || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Active Ingredient" name="hm_tablets_active_ingredient" value={form.hm_tablets_active_ingredient || ''} onChange={onChange} />
                                    <span className="input-suffix">mg</span>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>

                          {/* Injectables Section */}
                          <div className="row g-2 mt-4">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Injectables</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleHealthMedicalSection('injectables')}>
                                {healthMedicalSections.injectables ? '−' : '+'}
                              </button>
                            </div>
                            {healthMedicalSections.injectables && (
                              <>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Generic Name" name="hm_injectables_generic_name" value={form.hm_injectables_generic_name || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_route_administration" value={form.hm_route_administration || ''} onChange={onChange}>
                                    <option value="">Select Route of Administration</option>
                                    {routeOfAdministrationOptions.map((r) => (
                                      <option key={r.id} value={r.id}>{r.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_diluent_required" value={form.hm_diluent_required || ''} onChange={onChange}>
                                    <option value="">Select Diluent Required</option>
                                    {diluentRequiredOptions.map((d) => (
                                      <option key={d.id} value={d.id}>{d.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Concentration" name="hm_concentration" value={form.hm_concentration || ''} onChange={onChange} />
                                    <span className="input-suffix">mg/ml</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input type="date" className="input-pill" placeholder="dd-mm-yyyy" name="hm_injectables_expiry_date" value={form.hm_injectables_expiry_date || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Diluent Type & Volume" name="hm_diluent_type_volume" value={form.hm_diluent_type_volume || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Vial/Ampoule Volume" name="hm_vial_ampoule_volume" value={form.hm_vial_ampoule_volume || ''} onChange={onChange} />
                                    <span className="input-suffix">ml</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Storage Temperature" name="hm_injectables_storage_temp" value={form.hm_injectables_storage_temp || ''} onChange={onChange} />
                                    <span className="input-suffix">°C</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Cold Chain Required" name="hm_cold_chain_required" value={form.hm_cold_chain_required || ''} onChange={onChange} />
                                    <span className="input-suffix">°C</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Batch/Lot No" name="hm_injectables_batch_lot_no" value={form.hm_injectables_batch_lot_no || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Sterility and Preservative" name="hm_sterility_preservative" value={form.hm_sterility_preservative || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Reconstitution Instructions" name="hm_reconstitution_instructions" value={form.hm_reconstitution_instructions || ''} onChange={onChange} />
                                </div>
                              </>
                            )}
                          </div>

                          {/* Syrup / Tonic Section */}
                          <div className="row g-2 mt-4">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Syrup / Tonic</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleHealthMedicalSection('syrup')}>
                                {healthMedicalSections.syrup ? '−' : '+'}
                              </button>
                            </div>
                            {healthMedicalSections.syrup && (
                              <>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Generic Name" name="hm_syrup_generic_name" value={form.hm_syrup_generic_name || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-prefix-suffix input-group-row">
                                    <input className="input-middle input-middle-with-border" placeholder="Enter Shelf Life (From MFG)" name="hm_syrup_shelf_life" value={form.hm_syrup_shelf_life || ''} onChange={onChange} />
                                    <div className="input-prefix input-prefix-no-borders">
                                      <select name="hm_syrup_shelf_life_unit" value={form.hm_syrup_shelf_life_unit || ''} onChange={onChange}>
                                        <option value="">Select</option>
                                        {agriShelfLifeUnitOptions.map((u) => (
                                          <option key={u.id} value={u.id}>{u.label}</option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Flavour" name="hm_flavour" value={form.hm_flavour || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Volume" name="hm_volume" value={form.hm_volume || ''} onChange={onChange} />
                                    <span className="input-suffix">ml</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Product Name" name="hm_syrup_product_name" value={form.hm_syrup_product_name || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Sugar Free" name="hm_sugar_free" value={form.hm_sugar_free || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Indication / Use" name="hm_syrup_indication_use" value={form.hm_syrup_indication_use || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_syrup_regulatory_approvals" value={form.hm_syrup_regulatory_approvals || ''} onChange={onChange}>
                                    <option value="">Select Regulatory Approvals</option>
                                    {regulatoryApprovalsOptions.map((r) => (
                                      <option key={r.id} value={r.id}>{r.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="hm_syrup_dosage_form" value={form.hm_syrup_dosage_form || ''} onChange={onChange}>
                                    <option value="">Select Dosage Form</option>
                                    {dosageFormOptions.map((d) => (
                                      <option key={d.id} value={d.id}>{d.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Storage Temperature" name="hm_syrup_storage_temp" value={form.hm_syrup_storage_temp || ''} onChange={onChange} />
                                    <span className="input-suffix">°C</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Alcohol Content" name="hm_alcohol_content" value={form.hm_alcohol_content || ''} onChange={onChange} />
                                    <span className="input-suffix">%</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter After-Opening Shelf Life" name="hm_after_opening_shelf_life" value={form.hm_after_opening_shelf_life || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Brand Name" name="hm_syrup_brand_name" value={form.hm_syrup_brand_name || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input type="date" className="input-pill" placeholder="dd-mm-yyyy" name="hm_syrup_expiry_date" value={form.hm_syrup_expiry_date || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Active Ingredient" name="hm_syrup_active_ingredient" value={form.hm_syrup_active_ingredient || ''} onChange={onChange} />
                                    <span className="input-suffix">mg/ml</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Bottle Type / Closure" name="hm_bottle_type_closure" value={form.hm_bottle_type_closure || ''} onChange={onChange} />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </section>
                    )}

                    {/* Attributes - only show when Construction & Real Estate category selected */}
                    {(isConstructionCategory(form.pd_cat) || isCategoryByName(form.pd_cat, ['real estate', 'realestate', 'estate'])) && (
                      <section className="sp-section">
                        <div className="sp-subcard">
                          <h6 className="sp-section-title">⚡ Attributes</h6>

                          {/* Safety & Compliance */}
                          <div className="row g-2 mt-3">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Safety & Compliance</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleCreSection('safety')}>
                                {creSections.safety ? '−' : '+'}
                              </button>
                            </div>
                            {creSections.safety && (
                              <>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Fire Rating" name="cre_fire_rating" value={form.cre_fire_rating || ''} onChange={onChange} />
                                    <span className="input-suffix">min</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="cre_seismic_compliance" value={form.cre_seismic_compliance || ''} onChange={onChange}>
                                    <option value="">Select Seismic Compliance</option>
                                    {seismicComplianceOptions.map((s) => (
                                      <option key={s.id} value={s.id}>{s.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="cre_standards" value={form.cre_standards || ''} onChange={onChange}>
                                    <option value="">Select Standards</option>
                                    {standardsOptions.map((st) => (
                                      <option key={st.id} value={st.id}>{st.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="cre_green_rating" value={form.cre_green_rating || ''} onChange={onChange}>
                                    <option value="">Select Green Rating</option>
                                    {greenRatingOptions.filter(g => g.id !== 'none').map((g) => (
                                      <option key={g.id} value={g.id}>{g.label}</option>
                                    ))}
                                  </select>
                                </div>
                              </>
                            )}
                          </div>

                          {/* Thermal & Acoustic Performance */}
                          <div className="row g-2 mt-4">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Thermal & Acoustic Performance</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleCreSection('thermal')}>
                                {creSections.thermal ? '−' : '+'}
                              </button>
                            </div>
                            {creSections.thermal && (
                              <>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter U-Value" name="cre_u_value" value={form.cre_u_value || ''} onChange={onChange} />
                                    <span className="input-suffix">W/m²K</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter R-Value" name="cre_r_value" value={form.cre_r_value || ''} onChange={onChange} />
                                    <span className="input-suffix">m²K/W</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Thermal Conductivity" name="cre_thermal_conductivity" value={form.cre_thermal_conductivity || ''} onChange={onChange} />
                                    <span className="input-suffix">W/mK</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Sound Insulation" name="cre_sound_insulation" value={form.cre_sound_insulation || ''} onChange={onChange} />
                                    <span className="input-suffix">dB</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-prefix-suffix">
                                    <div className="input-prefix">
                                      <select name="cre_acoustic_rating" value={form.cre_acoustic_rating || ''} onChange={onChange}>
                                        <option value="">Select Acoustic Rating</option>
                                        {acousticRatingOptions.map((a) => (
                                          <option key={a.id} value={a.id}>{a.label}</option>
                                        ))}
                                      </select>
                                    </div>
                                    <input className="input-middle" placeholder="Enter Acoust" name="cre_acoustic_value" value={form.cre_acoustic_value || ''} onChange={onChange} />
                                    <span className="input-suffix-inline">{form.cre_acoustic_value ? `${form.cre_acoustic_value} dB` : '12dB'}</span>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>

                          {/* Structural & Load Parameters */}
                          <div className="row g-2 mt-4">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Structural & Load Parameters</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleCreSection('structural')}>
                                {creSections.structural ? '−' : '+'}
                              </button>
                            </div>
                            {creSections.structural && (
                              <>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter Wind/structural load rating" name="cre_wind_earthquake_load" value={form.cre_wind_earthquake_load || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="cre_water_permeability" value={form.cre_water_permeability || ''} onChange={onChange}>
                                    <option value="">Select Water Permeability Class</option>
                                    {waterPermeabilityClassOptions.map((w) => (
                                      <option key={w.id} value={w.id}>{w.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Density" name="cre_density" value={form.cre_density || ''} onChange={onChange} />
                                    <span className="input-suffix">kg/m³</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Compressive Strength" name="cre_compressive_strength" value={form.cre_compressive_strength || ''} onChange={onChange} />
                                    <span className="input-suffix">MPa</span>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>

                          {/* Glass & Facade Elements */}
                          <div className="row g-2 mt-4">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Glass & Facade Elements</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleCreSection('glass')}>
                                {creSections.glass ? '−' : '+'}
                              </button>
                            </div>
                            {creSections.glass && (
                              <>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Glass Thickness" name="cre_glass_thickness" value={form.cre_glass_thickness || ''} onChange={onChange} />
                                    <span className="input-suffix">mm</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="cre_air_tightness" value={form.cre_air_tightness || ''} onChange={onChange}>
                                    <option value="">Select Air Tightness</option>
                                    {airTightnessOptions.map((a) => (
                                      <option key={a.id} value={a.id}>{a.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="cre_glass_type" value={form.cre_glass_type || ''} onChange={onChange}>
                                    <option value="">Select Glass Type</option>
                                    {glassTypeOptions.map((g) => (
                                      <option key={g.id} value={g.id}>{g.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="cre_water_tightness" value={form.cre_water_tightness || ''} onChange={onChange}>
                                    <option value="">Select Water Tightness</option>
                                    {waterTightnessOptions.map((wt) => (
                                      <option key={wt.id} value={wt.id}>{wt.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter SHGC" name="cre_shgc" value={form.cre_shgc || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="cre_hardware_grade" value={form.cre_hardware_grade || ''} onChange={onChange}>
                                    <option value="">Select Hardware Grade</option>
                                    {hardwareGradeOptions.map((h) => (
                                      <option key={h.id} value={h.id}>{h.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter VLT" name="cre_vlt" value={form.cre_vlt || ''} onChange={onChange} />
                                    <span className="input-suffix">%</span>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>

                          {/* HVAC & Building Systems */}
                          <div className="row g-2 mt-4">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">HVAC & Building Systems</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleCreSection('hvac')}>
                                {creSections.hvac ? '−' : '+'}
                              </button>
                            </div>
                            {creSections.hvac && (
                              <>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="d-flex gap-2">
                                    <input className="input-pill flex-grow-1" placeholder="Enter HVAC Capacity" name="cre_hvac_capacity" value={form.cre_hvac_capacity || ''} onChange={onChange} />
                                    <select className="input-pill input-pill-select-small" name="cre_hvac_capacity_unit" value={form.cre_hvac_capacity_unit || ''} onChange={onChange}>
                                      <option value="">Select Unit</option>
                                      {hvacCapacityUnitOptions.map((u) => (
                                        <option key={u.id} value={u.id}>{u.label}</option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter COP" name="cre_cop" value={form.cre_cop || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Airflow" name="cre_airflow" value={form.cre_airflow || ''} onChange={onChange} />
                                    <span className="input-suffix">CFM</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter EER" name="cre_eer" value={form.cre_eer || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="cre_refrigerant_type" value={form.cre_refrigerant_type || ''} onChange={onChange}>
                                    <option value="">Select Refrigerant Type</option>
                                    {refrigerantTypeOptions.map((r) => (
                                      <option key={r.id} value={r.id}>{r.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <input className="input-pill" placeholder="Enter SEER" name="cre_kw_h" value={form.cre_kw_h || ''} onChange={onChange} />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Noise Level" name="cre_noise_level" value={form.cre_noise_level || ''} onChange={onChange} />
                                    <span className="input-suffix">dBA</span>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>

                          {/* Elevations & Vertical Transport */}
                          <div className="row g-2 mt-4">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Elevations & Vertical Transport</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleCreSection('elevations')}>
                                {creSections.elevations ? '−' : '+'}
                              </button>
                            </div>
                            {creSections.elevations && (
                              <>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Elevator Load" name="cre_elevator_load" value={form.cre_elevator_load || ''} onChange={onChange} />
                                    <span className="input-suffix">kg</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Car Size" name="cre_car_size" value={form.cre_car_size || ''} onChange={onChange} />
                                    <span className="input-suffix">mm</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Speed" name="cre_speed" value={form.cre_speed || ''} onChange={onChange} />
                                    <span className="input-suffix">m/s</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="cre_door_type" value={form.cre_door_type || ''} onChange={onChange}>
                                    <option value="">Select Door Type</option>
                                    {doorTypeOptions.map((d) => (
                                      <option key={d.id} value={d.id}>{d.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Stops" name="cre_stops" value={form.cre_stops || ''} onChange={onChange} />
                                    <span className="input-suffix">count</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="cre_drive_type" value={form.cre_drive_type || ''} onChange={onChange}>
                                    <option value="">Select Drive Type</option>
                                    {driveTypeOptions.map((d) => (
                                      <option key={d.id} value={d.id}>{d.label}</option>
                                    ))}
                                  </select>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </section>
                    )}

                    {/* Attributes - only show when Tools category selected */}
                    {isToolsCategory(form.pd_cat) && (
                      <section className="sp-section">
                        <div className="sp-subcard">
                          <h6 className="sp-section-title">⚡ Attributes</h6>

                          {/* General Attributes */}
                          <div className="row g-2 mt-3">
                            <div className="col-12 col-md-6 col-lg-3">
                              <select className="input-pill" name="tool_type" value={form.tool_type || ''} onChange={onChange}>
                                <option value="">Select Tool Type</option>
                                {toolTypeOptions.map((t) => (
                                  <option key={t.id} value={t.id}>{t.label}</option>
                                ))}
                              </select>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                              <select className="input-pill" name="tool_material" value={form.tool_material || ''} onChange={onChange}>
                                <option value="">Select Material</option>
                                {toolMaterialOptions.map((m) => (
                                  <option key={m.id} value={m.id}>{m.label}</option>
                                ))}
                              </select>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                              <select className="input-pill" name="tool_handle_material" value={form.tool_handle_material || ''} onChange={onChange}>
                                <option value="">Select Handle Material</option>
                                {handleMaterialOptions.map((h) => (
                                  <option key={h.id} value={h.id}>{h.label}</option>
                                ))}
                              </select>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                              <select className="input-pill" name="tool_grade" value={form.tool_grade || ''} onChange={onChange}>
                                <option value="">Select Grade</option>
                                {toolGradeOptions.map((g) => (
                                  <option key={g.id} value={g.id}>{g.label}</option>
                                ))}
                              </select>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                              <select className="input-pill" name="tool_surface_finish" value={form.tool_surface_finish || ''} onChange={onChange}>
                                <option value="">Select Surface Finish</option>
                                {surfaceFinishOptions.map((s) => (
                                  <option key={s.id} value={s.id}>{s.label}</option>
                                ))}
                              </select>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                              <select className="input-pill" name="tool_warranty" value={form.tool_warranty || ''} onChange={onChange}>
                                <option value="">Select Warranty</option>
                                {warrantyOptions.map((w) => (
                                  <option key={w.id} value={w.id}>{w.label}</option>
                                ))}
                              </select>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                              <select className="input-pill" name="tool_standards" value={form.tool_standards || ''} onChange={onChange}>
                                <option value="">Select Standards</option>
                                {toolStandardsOptions.map((s) => (
                                  <option key={s.id} value={s.id}>{s.label}</option>
                                ))}
                              </select>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                              <select className="input-pill" name="tool_safety_features" value={form.tool_safety_features || ''} onChange={onChange}>
                                <option value="">Select Safety Features</option>
                                {safetyFeaturesOptions.map((s) => (
                                  <option key={s.id} value={s.id}>{s.label}</option>
                                ))}
                              </select>
                            </div>
                          </div>

                          {/* Power & Performance */}
                          <div className="row g-2 mt-4">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Power & Performance</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleToolsSection('power')}>
                                {toolsSections.power ? '−' : '+'}
                              </button>
                            </div>
                            {toolsSections.power && (
                              <>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="tool_power_source" value={form.tool_power_source || ''} onChange={onChange}>
                                    <option value="">Select Power Source</option>
                                    {powerSourceOptions.map((p) => (
                                      <option key={p.id} value={p.id}>{p.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Voltage" name="tool_voltage" value={form.tool_voltage || ''} onChange={onChange} />
                                    <span className="input-suffix">V</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Rated Power" name="tool_rated_power" value={form.tool_rated_power || ''} onChange={onChange} />
                                    <span className="input-suffix">W</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter No Load Speed" name="tool_no_load_speed" value={form.tool_no_load_speed || ''} onChange={onChange} />
                                    <span className="input-suffix">RPM</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="tool_motor_type" value={form.tool_motor_type || ''} onChange={onChange}>
                                    <option value="">Select Motor Type</option>
                                    {toolMotorTypeOptions.map((m) => (
                                      <option key={m.id} value={m.id}>{m.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="tool_battery_type" value={form.tool_battery_type || ''} onChange={onChange}>
                                    <option value="">Select Battery Type</option>
                                    {toolBatteryTypeOptions.map((b) => (
                                      <option key={b.id} value={b.id}>{b.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Torque" name="tool_torque" value={form.tool_torque || ''} onChange={onChange} />
                                    <span className="input-suffix">Nm</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Noise Level" name="tool_noise_level" value={form.tool_noise_level || ''} onChange={onChange} />
                                    <span className="input-suffix">dB</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Frequency" name="tool_frequency" value={form.tool_frequency || ''} onChange={onChange} />
                                    <span className="input-suffix">Hz</span>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <select className="input-pill" name="tool_blade_tip_type" value={form.tool_blade_tip_type || ''} onChange={onChange}>
                                    <option value="">Select Blade/Tip Type</option>
                                    {bladeTipTypeOptions.map((b) => (
                                      <option key={b.id} value={b.id}>{b.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                  <div className="input-group-suffix">
                                    <input className="input-pill" placeholder="Enter Drilling Capacity" name="tool_drilling_capacity" value={form.tool_drilling_capacity || ''} onChange={onChange} />
                                    <span className="input-suffix">mm</span>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </section>
                    )}

                    {/* Attributes - only show when Agricultural Products category selected */}
                    {isAgriculturalCategory(form.pd_cat) && (
                      <section className="sp-section">
                        <div className="sp-subcard">
                          <h6 className="sp-section-title">⚡ Attributes</h6>

                          {/* Product Information Section */}
                          <div className="row g-2 mt-3">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Product Information</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleAgriSection('productInfo')}>
                                {agriSections.productInfo ? '−' : '+'}
                              </button>
                            </div>
                            {agriSections.productInfo && (
                              <>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <select className="input-pill" name="agri_variety" value={form.agri_variety || ''} onChange={onChange}>
                                    <option value="">Select Variety</option>
                                    {varietyOptions.map((v) => (
                                      <option key={v.id} value={v.id}>{v.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <select className="input-pill" name="agri_product_type" value={form.agri_product_type || ''} onChange={onChange}>
                                    <option value="">Select Product Type</option>
                                    {productTypeOptions.map((p) => (
                                      <option key={p.id} value={p.id}>{p.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <select className="input-pill" name="agri_type" value={form.agri_type || ''} onChange={onChange}>
                                    <option value="">Select Type</option>
                                    {agriTypeOptions.map((t) => (
                                      <option key={t.id} value={t.id}>{t.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <select className="input-pill" name="agri_grade" value={form.agri_grade || ''} onChange={onChange}>
                                    <option value="">Select Grade</option>
                                    {agriGradeOptions.map((g) => (
                                      <option key={g.id} value={g.id}>{g.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <select className="input-pill" name="agri_key_machine" value={form.agri_key_machine || ''} onChange={onChange}>
                                    <option value="">Select Key Machine</option>
                                    {keyMachineOptions.map((k) => (
                                      <option key={k.id} value={k.id}>{k.label}</option>
                                    ))}
                                  </select>
                                </div>
                              </>
                            )}
                          </div>

                          {/* Features & Attributes Section */}
                          <div className="row g-2 mt-4">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Features & Attributes</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleAgriSection('features')}>
                                {agriSections.features ? '−' : '+'}
                              </button>
                            </div>
                            {agriSections.features && (
                              <>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <select className="input-pill" name="agri_feature" value={form.agri_feature || ''} onChange={onChange}>
                                    <option value="">Select Feature</option>
                                    {featureOptions.map((f) => (
                                      <option key={f.id} value={f.id}>{f.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <select className="input-pill" name="agri_application" value={form.agri_application || ''} onChange={onChange}>
                                    <option value="">Select Application</option>
                                    {agriApplicationOptions.map((a) => (
                                      <option key={a.id} value={a.id}>{a.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <select className="input-pill" name="agri_active_ingredients" value={form.agri_active_ingredients || ''} onChange={onChange}>
                                    <option value="">Select Active Ingredients</option>
                                    {activeIngredientsOptions.map((i) => (
                                      <option key={i.id} value={i.id}>{i.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <select className="input-pill" name="agri_shape" value={form.agri_shape || ''} onChange={onChange}>
                                    <option value="">Select Shape</option>
                                    {agriShapeOptions.map((s) => (
                                      <option key={s.id} value={s.id}>{s.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <div className="input-group-prefix-suffix input-group-row">
                                    <input className="input-middle input-middle-with-border" placeholder="Enter Grain Size" name="agri_grain_size" value={form.agri_grain_size || ''} onChange={onChange} />
                                    <div className="input-prefix input-prefix-no-borders">
                                      <select name="agri_grain_size_unit" value={form.agri_grain_size_unit || ''} onChange={onChange}>
                                        <option value="">Select</option>
                                        {grainSizeUnitOptions.map((u) => (
                                          <option key={u.id} value={u.id}>{u.label}</option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>

                          {/* Cultivation & Processing Section */}
                          <div className="row g-2 mt-4">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Cultivation & Processing</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleAgriSection('cultivation')}>
                                {agriSections.cultivation ? '−' : '+'}
                              </button>
                            </div>
                            {agriSections.cultivation && (
                              <>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <select className="input-pill" name="agri_cultivation_type" value={form.agri_cultivation_type || ''} onChange={onChange}>
                                    <option value="">Select Cultivation Type</option>
                                    {cultivationTypeOptions.map((c) => (
                                      <option key={c.id} value={c.id}>{c.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <select className="input-pill" name="agri_processing_type" value={form.agri_processing_type || ''} onChange={onChange}>
                                    <option value="">Select Processing Type</option>
                                    {processingTypeOptions.map((p) => (
                                      <option key={p.id} value={p.id}>{p.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <select className="input-pill" name="agri_preservation_process" value={form.agri_preservation_process || ''} onChange={onChange}>
                                    <option value="">Select Preservation Process</option>
                                    {preservationProcessOptions.map((p) => (
                                      <option key={p.id} value={p.id}>{p.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <select className="input-pill" name="agri_extraction_type" value={form.agri_extraction_type || ''} onChange={onChange}>
                                    <option value="">Select Extraction Type</option>
                                    {extractionTypeOptions.map((e) => (
                                      <option key={e.id} value={e.id}>{e.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <select className="input-pill" name="agri_style" value={form.agri_style || ''} onChange={onChange}>
                                    <option value="">Select Style</option>
                                    {agriStyleOptions.map((s) => (
                                      <option key={s.id} value={s.id}>{s.label}</option>
                                    ))}
                                  </select>
                                </div>
                              </>
                            )}
                          </div>

                          {/* Packaging & Commercial Section */}
                          <div className="row g-2 mt-4">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Packaging & Commercial</h6>
                              <button type="button" className="btn-collapse" onClick={() => toggleAgriSection('packaging')}>
                                {agriSections.packaging ? '−' : '+'}
                              </button>
                            </div>
                            {agriSections.packaging && (
                              <>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <select className="input-pill" name="agri_packaging" value={form.agri_packaging || ''} onChange={onChange}>
                                    <option value="">Select Packaging</option>
                                    {agriPackagingOptions.map((p) => (
                                      <option key={p.id} value={p.id}>{p.label}</option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <div className="input-group-prefix-suffix input-group-row">
                                    <input className="input-middle input-middle-with-border" placeholder="Enter Value" name="agri_shelf_life" value={form.agri_shelf_life || ''} onChange={onChange} />
                                    <div className="input-prefix input-prefix-no-borders">
                                      <select name="agri_shelf_life_unit" value={form.agri_shelf_life_unit || ''} onChange={onChange}>
                                        <option value="">Select</option>
                                        {agriShelfLifeUnitOptions.map((u) => (
                                          <option key={u.id} value={u.id}>{u.label}</option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-5-custom">
                                  <div className="input-group-prefix-suffix input-group-row">
                                    <input className="input-middle input-middle-with-border" placeholder="Enter Warranty" name="agri_warranty" value={form.agri_warranty || ''} onChange={onChange} />
                                    <div className="input-prefix input-prefix-no-borders">
                                      <select name="agri_warranty_unit" value={form.agri_warranty_unit || ''} onChange={onChange}>
                                        <option value="">Select</option>
                                        {warrantyUnitOptions.map((u) => (
                                          <option key={u.id} value={u.id}>{u.label}</option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </section>
                    )}

                    {/* Add Attributes */}
                    <section className="sp-section">
                      <div className="sp-subcard">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="sp-section-title">🏷️ Add Attributes</h6>
                          <button type="button" className="btn-add" onClick={addAttribute}>+ Add More</button>
                        </div>
                        {attributesList.map((attr, index) => (
                          <div key={attr.id} className={index > 0 ? "mt-3" : ""}>
                            <div className="row g-2">
                              <div className="col-12 col-md-4">
                                <input 
                                  className="input-pill" 
                                  placeholder="Enter Attribute" 
                                  value={attr.attribute || ''} 
                                  onChange={(e) => updateAttribute(attr.id, 'attribute', e.target.value)} 
                                />
                              </div>
                              <div className="col-12 col-md-4">
                                <input 
                                  className="input-pill" 
                                  placeholder="Enter Value" 
                                  value={attr.value || ''} 
                                  onChange={(e) => updateAttribute(attr.id, 'value', e.target.value)} 
                                />
                              </div>
                              <div className="col-12 col-md-4">
                                <div className="d-flex align-items-center gap-2">
                                  <Select
                                    className="input-pill p-0 flex-grow-1"
                                    placeholder="Select Unit"
                                    options={attributeUnitOptions}
                                    onChange={(opt) => updateAttribute(attr.id, 'unit', opt?.value || "")}
                                    value={(() => {
                                      const found = findOption(attributeUnitOptions, attr.unit);
                                      if (attr.unit && !found) {
                                        console.log('Attribute unit not found in options:', {
                                          attr_unit: attr.unit,
                                          attr_unit_type: typeof attr.unit,
                                          available_options: attributeUnitOptions?.map(opt => ({ value: opt.value, label: opt.label })),
                                          trying_to_match: String(attr.unit).trim()
                                        });
                                      }
                                      return found;
                                    })()}
                                    isClearable
                                  />
                                  {attributesList.length > 1 && (
                                    <button
                                      type="button"
                                      className="btn-delete"
                                      onClick={() => removeAttribute(attr.id)}
                                      title="Remove"
                                    >
                                      ×
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>

                    {/* MOQ */}
                    <section className="sp-section">
                      <div className="sp-subcard">
                        <h6 className="sp-section-title">📦 MOQ <span className="required-asterisk">*</span></h6>
                        <div className="row g-2">
                          <div className="col-12 col-md-2"><input className="input-pill" placeholder="Minimum Order Quantity *" name="moq_min" value={form.moq_min || ''} onChange={onChange} required /></div>
                          <div className="col-12 col-md-2">
                            <Select
                              className="input-pill p-0"
                              name="moq_uom"
                              placeholder="Unit of Measurements *"
                              options={dimensionUnitOptions}
                              onChange={(opt) => setForm(prev => ({ ...prev, moq_uom: opt?.value || "" }))}
                              value={findOption(dimensionUnitOptions, form.moq_uom)}
                              isClearable
                              required
                            />
                          </div>
                          <div className="col-12 col-md-2">
                            <input 
                              className="input-pill" 
                              placeholder="Price (Without Tax) *" 
                              name="moq_price_notax" 
                              type="number"
                              step="0.01"
                              value={form.moq_price_notax || ''} 
                              onChange={(e) => {
                                const priceWithoutTax = e.target.value;
                                const taxPercent = parseFloat(form.moq_tax) || 0;
                                const priceWithTax = priceWithoutTax && taxPercent ? (parseFloat(priceWithoutTax) * (1 + taxPercent / 100)).toFixed(2) : '';
                                onChange({ target: { name: 'moq_price_notax', value: priceWithoutTax } });
                                setForm(prev => ({ ...prev, moq_price_tax: priceWithTax }));
                              }} 
                              required 
                            />
                          </div>
                          <div className="col-12 col-md-2">
                            <input 
                              className="input-pill" 
                              placeholder="Tax (%) *" 
                              name="moq_tax" 
                              type="number"
                              step="0.01"
                              value={form.moq_tax || ''} 
                              onChange={(e) => {
                                const taxPercent = e.target.value;
                                const priceWithoutTax = parseFloat(form.moq_price_notax) || 0;
                                const priceWithTax = taxPercent && priceWithoutTax ? (priceWithoutTax * (1 + parseFloat(taxPercent) / 100)).toFixed(2) : '';
                                onChange({ target: { name: 'moq_tax', value: taxPercent } });
                                setForm(prev => ({ ...prev, moq_price_tax: priceWithTax }));
                              }} 
                              required 
                            />
                          </div>
                          <div className="col-12 col-md-2">
                            <input 
                              className="input-pill" 
                              placeholder="Price (With Tax) *" 
                              name="moq_price_tax" 
                              value={form.moq_price_tax || ''} 
                              readOnly
                              style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                            />
                          </div>
                          <div className="col-12 col-md-2">
                            <Select
                              className="input-pill p-0"
                              name="moq_currency"
                              placeholder="Currency *"
                              options={currencyOptions}
                              onChange={(opt) => setForm(prev => ({ ...prev, moq_currency: opt?.value || "" }))}
                              value={findOption(currencyOptions, form.moq_currency)}
                              isClearable
                            />
                          </div>
                        </div>
                      </div>
                    </section>

                    {/* Packaging Details */}
                    <section className="sp-section">
                      <div className="sp-subcard">
                        <h6 className="sp-section-title">📦 Packaging Details</h6>
                        <div className="row g-2">
                          <div className="col-12 col-md-6 col-lg-4">
                            <input className="input-pill" placeholder="Units Per Carton" name="unitsPerCarton" value={form.unitsPerCarton || ''} onChange={onChange} />
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <input className="input-pill" placeholder="Gross Weight" name="grossWeight" value={form.grossWeight || ''} onChange={onChange} />
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <input className="input-pill" placeholder="Net Weight" name="netWeight" value={form.netWeight || ''} onChange={onChange} />
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <Select
                              className="input-pill p-0"
                              name="packingMaterials"
                              placeholder="Packing Materials"
                              options={packagingMaterialsOptions}
                              onChange={(opt) => {
                                const value = opt?.value || "";
                                setForm(prev => ({ 
                                  ...prev, 
                                  packingMaterials: value,
                                  packingType: "" // Reset packing type when material changes
                                }));
                                // Fetch packing types for selected material
                                fetchPackingTypes(value);
                              }}
                              value={(() => {
                                const found = findOption(packagingMaterialsOptions, form.packingMaterials);
                                if (form.packingMaterials && !found) {
                                  console.log('Packing material not found in options:', {
                                    packingMaterials: form.packingMaterials,
                                    packingMaterials_type: typeof form.packingMaterials,
                                    available_options: packagingMaterialsOptions?.map(opt => ({ value: opt.value, label: opt.label })),
                                    trying_to_match: String(form.packingMaterials).trim()
                                  });
                                }
                                return found;
                              })()}
                              isClearable
                            />
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <Select
                              className="input-pill p-0"
                              name="packingType"
                              placeholder="Packing Type"
                              options={packingTypesOptions}
                              onChange={(opt) => setForm(prev => ({ ...prev, packingType: opt?.value || "" }))}
                              value={(() => {
                                // If packing types are still loading, return null to avoid showing "not found" error
                                if (loadingPackingTypes) {
                                  return null;
                                }
                                
                                // Try to find exact match first
                                let found = findOption(packingTypesOptions, form.packingType);
                                
                                // If not found and packing types options are empty but we have a packing material,
                                // it might be that the API call hasn't completed yet - wait a bit and retry
                                if (!found && form.packingType && (!packingTypesOptions || packingTypesOptions.length === 0) && form.packingMaterials) {
                                  console.log('Packing types not loaded yet, but we have a packing type value:', {
                                    packingType: form.packingType,
                                    packingMaterials: form.packingMaterials,
                                    packingTypesOptions_length: packingTypesOptions?.length || 0,
                                    loadingPackingTypes
                                  });
                                  // Don't show error yet - options might still be loading
                                  return null;
                                }
                                
                                // If not found, try to fix common typos
                                if (!found && form.packingType && typeof form.packingType === 'string') {
                                  const packingTypeFixed = form.packingType
                                    .replace(/flim/gi, 'film') // Fix "Flim" -> "Film"
                                    .replace(/streatch/gi, 'stretch') // Fix "Streatch" -> "Stretch"
                                    .trim();
                                  
                                  if (packingTypeFixed !== form.packingType) {
                                    found = findOption(packingTypesOptions, packingTypeFixed);
                                    if (found) {
                                      console.log('Fixed packing type typo:', {
                                        original: form.packingType,
                                        fixed: packingTypeFixed,
                                        matched_option: found
                                      });
                                      // Update form with corrected value
                                      setForm(prev => ({ ...prev, packingType: found.value }));
                                    }
                                  }
                                }
                                
                                if (form.packingType && !found && packingTypesOptions && packingTypesOptions.length > 0) {
                                  console.log('Packing type not found in options:', {
                                    packingType: form.packingType,
                                    packingType_type: typeof form.packingType,
                                    available_options: packingTypesOptions?.map(opt => ({ value: opt.value, label: opt.label })),
                                    trying_to_match: String(form.packingType).trim(),
                                    packingMaterials: form.packingMaterials
                                  });
                                }
                                return found;
                              })()}
                              isDisabled={!form.packingMaterials || loadingPackingTypes}
                              isClearable
                            />
                          </div>
                          <div className="col-12 col-md-6 col-lg-4">
                            <Select
                              className="input-pill p-0"
                              name="labelling"
                              placeholder="Labelling"
                              options={labellingOptions}
                              onChange={(opt) => setForm(prev => ({ ...prev, labelling: opt?.value || "" }))}
                              value={(() => {
                                const found = findOption(labellingOptions, form.labelling);
                                if (form.labelling !== undefined && form.labelling !== null && form.labelling !== '' && !found) {
                                  console.log('Labelling not found in options:', {
                                    labelling: form.labelling,
                                    labelling_type: typeof form.labelling,
                                    available_options: labellingOptions?.map(opt => ({ value: opt.value, label: opt.label })),
                                    trying_to_match: String(form.labelling).trim()
                                  });
                                }
                                return found;
                              })()}
                              isClearable
                            />
                          </div>
                        </div>
                      </div>
                    </section>

                    {/* Bulk Discount Slab */}
                    <section className="sp-section">
                      <div className="sp-subcard">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="sp-section-title">💰 Bulk Discount Slab</h6>
                          <button
                            type="button"
                            className="btn-add"
                            onClick={addBulkDiscountSlab}
                            disabled={bulkDiscountSlabs.length >= 3}
                            style={{ opacity: bulkDiscountSlabs.length >= 3 ? 0.5 : 1, cursor: bulkDiscountSlabs.length >= 3 ? 'not-allowed' : 'pointer' }}
                          >
                            + Add More
                          </button>
                        </div>
                        {bulkDiscountSlabs.map((slab, index) => (
                          <div key={slab.id} className="mb-3">
                            <div className="row g-2">
                              <div className="col-12 col-md-3">
                                <input
                                  type="number"
                                  className="input-pill"
                                  placeholder="Min Units"
                                  value={slab.bulk_min || ''}
                                  onChange={(e) => updateBulkDiscountSlab(slab.id, 'bulk_min', e.target.value)}
                                  min="0"
                                />
                              </div>
                              <div className="col-12 col-md-3">
                                <input
                                  type="number"
                                  className="input-pill"
                                  placeholder="Max Units"
                                  value={slab.bulk_max || ''}
                                  onChange={(e) => updateBulkDiscountSlab(slab.id, 'bulk_max', e.target.value)}
                                  min="0"
                                />
                              </div>
                              <div className="col-12 col-md-3">
                                <Select
                                  className="input-pill p-0"
                                  placeholder="Unit of Measurements"
                                  options={dimensionUnitOptions}
                                  onChange={(opt) => updateBulkDiscountSlab(slab.id, 'bulk_uom', opt?.value || "")}
                                  value={(() => {
                                    const found = findOption(dimensionUnitOptions, slab.bulk_uom);
                                    if (slab.bulk_uom && !found) {
                                      console.log('Bulk discount slab unit not found in options:', {
                                        slab_id: slab.id,
                                        bulk_uom: slab.bulk_uom,
                                        bulk_uom_type: typeof slab.bulk_uom,
                                        available_options: dimensionUnitOptions?.map(opt => ({ value: opt.value, label: opt.label })),
                                        trying_to_match: String(slab.bulk_uom).trim()
                                      });
                                    }
                                    return found;
                                  })()}
                                  isClearable
                                />
                              </div>
                              <div className="col-12 col-md-3">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="input-pill"
                                  placeholder="Price (Without Tax)"
                                  value={slab.bulk_price_no || ''}
                                  onChange={(e) => {
                                    const priceWithoutTax = e.target.value;
                                    const taxPercent = parseFloat(slab.bulk_tax) || 0;
                                    const priceWithTax = priceWithoutTax && taxPercent ? (parseFloat(priceWithoutTax) * (1 + taxPercent / 100)).toFixed(2) : '';
                                    updateBulkDiscountSlab(slab.id, 'bulk_price_no', priceWithoutTax);
                                    updateBulkDiscountSlab(slab.id, 'bulk_price_with', priceWithTax);
                                  }}
                                />
                              </div>
                              <div className="col-12 col-md-3">
                                <input
                                  type="number"
                                  step="0.01"
                                  className="input-pill"
                                  placeholder="Tax (%)"
                                  value={slab.bulk_tax || ''}
                                  onChange={(e) => {
                                    const taxPercent = e.target.value;
                                    const priceWithoutTax = parseFloat(slab.bulk_price_no) || 0;
                                    const priceWithTax = taxPercent && priceWithoutTax ? (priceWithoutTax * (1 + parseFloat(taxPercent) / 100)).toFixed(2) : '';
                                    updateBulkDiscountSlab(slab.id, 'bulk_tax', taxPercent);
                                    updateBulkDiscountSlab(slab.id, 'bulk_price_with', priceWithTax);
                                  }}
                                />
                              </div>
                              <div className="col-12 col-md-3">
                                <input
                                  className="input-pill"
                                  placeholder="Price (With Tax)"
                                  value={slab.bulk_price_with || ''}
                                  readOnly
                                  style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                                />
                              </div>
                              <div className="col-12 col-md-3">
                                <div className="d-flex align-items-center gap-2">
                                  <Select
                                    className="input-pill p-0"
                                    placeholder="Currency"
                                    options={currencyOptions}
                                    onChange={(opt) => updateBulkDiscountSlab(slab.id, 'bulk_currency', opt?.value || '')}
                                    value={findOption(currencyOptions, slab.bulk_currency)}
                                    isClearable
                                  />
                                  {bulkDiscountSlabs.length > 1 && (
                                    <button
                                      type="button"
                                      className="btn-delete"
                                      onClick={() => removeBulkDiscountSlab(slab.id)}
                                      title="Remove"
                                    >
                                      ×
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        {/* Price Negotiable Checkbox - Unique, not part of add more */}
                        <div className="mt-3 pt-3" style={{ borderTop: '1px solid #eef0f2' }}>
                          <div className="d-flex align-items-center">
                            <input
                              type="checkbox"
                              id="isPriceNegotiableAboveTier3"
                              name="isPriceNegotiableAboveTier3"
                              checked={form.isPriceNegotiableAboveTier3 || false}
                              onChange={(e) => onChange({ target: { name: 'isPriceNegotiableAboveTier3', value: e.target.checked } })}
                              style={{ marginRight: '8px', cursor: 'pointer' }}
                            />
                            <label htmlFor="isPriceNegotiableAboveTier3" style={{ margin: 0, cursor: 'pointer', fontSize: '14px', color: '#0B1320', fontWeight: 600 }}>
                              Is price negotiable if quantity ordered is above Tier 3 slab?
                            </label>
                          </div>
                        </div>
                      </div>
                    </section>

                    {/* Inventory Details */}
                    <section className="sp-section">
                      <div className="sp-subcard">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="sp-section-title">📦 Inventory Details</h6>
                          <button type="button" className="btn-add" onClick={addInventoryDetail}>+ Add More</button>
                        </div>
                        {inventoryDetailsList.map((inv, index) => (
                          <div key={inv.id} className={index > 0 ? "mt-3" : ""}>
                            <div className="row g-2">
                              <div className="col-12 col-md-3">
                                <input 
                                  className="input-pill" 
                                  placeholder="Available Quantity" 
                                  value={inv.qty || ''} 
                                  onChange={(e) => updateInventoryDetail(inv.id, 'qty', e.target.value)} 
                                />
                              </div>
                              <div className="col-12 col-md-3">
                                <Select
                                  className="input-pill p-0"
                                  placeholder="Unit of Measurements"
                                  options={dimensionUnitOptions}
                                  onChange={(opt) => updateInventoryDetail(inv.id, 'uom', opt?.value || "")}
                                  value={(() => {
                                    const found = findOption(dimensionUnitOptions, inv.uom);
                                    if (inv.uom && !found) {
                                      console.log('Inventory unit not found in options:', {
                                        inventory_id: inv.id,
                                        uom: inv.uom,
                                        uom_type: typeof inv.uom,
                                        available_options: dimensionUnitOptions?.map(opt => ({ value: opt.value, label: opt.label })),
                                        trying_to_match: String(inv.uom).trim()
                                      });
                                    }
                                    return found;
                                  })()}
                                  isClearable
                                />
                              </div>
                              <div className="col-12 col-md-3">
                                <Select
                                  className="input-pill p-0"
                                  placeholder="Status"
                                  options={(() => {
                                    // If status is a valid enum but not in options, add it as a temporary option
                                    // Note: LOW_STOCK maps to "Backorder" in the actual options
                                    const validEnums = ['IN_STOCK', 'OUT_OF_STOCK', 'LOW_STOCK', 'DISCONTINUED', 'BACKORDER'];
                                    const enumToLabelMapping = {
                                      'IN_STOCK': 'In Stock',
                                      'OUT_OF_STOCK': 'Out of Stock',
                                      'LOW_STOCK': 'Backorder', // LOW_STOCK maps to Backorder option
                                      'DISCONTINUED': 'Discontinued',
                                      'BACKORDER': 'Backorder'
                                    };
                                    
                                    if (inv.status && validEnums.includes(String(inv.status).toUpperCase().trim())) {
                                      const statusUpper = String(inv.status).toUpperCase().trim();
                                      
                                      // Check if the mapped label exists in options
                                      const mappedLabel = enumToLabelMapping[statusUpper];
                                      const statusExists = inventoryStatusOptions?.some(opt => {
                                        const optLabel = String(opt.label || '').trim();
                                        const optValue = String(opt.value || '').trim().toUpperCase();
                                        return optLabel === mappedLabel || 
                                               optLabel.toUpperCase() === statusUpper ||
                                               optValue === statusUpper;
                                      });
                                      
                                      if (!statusExists && mappedLabel) {
                                        // Try to find the option by the mapped label
                                        const foundByLabel = inventoryStatusOptions?.find(opt => 
                                          String(opt.label || '').trim() === mappedLabel
                                        );
                                        
                                        if (foundByLabel) {
                                          // The option exists, no need to add temporary one
                                          return inventoryStatusOptions;
                                        }
                                        
                                        // Add temporary option for this status
                                        const tempOption = {
                                          value: inv.status,
                                          label: mappedLabel
                                        };
                                        return [...(inventoryStatusOptions || []), tempOption];
                                      }
                                    }
                                    return inventoryStatusOptions;
                                  })()}
                                  onChange={(opt) => updateInventoryDetail(inv.id, 'status', opt?.value || "")}
                                  value={(() => {
                                    // First try to find using findOption
                                    let found = findOption(inventoryStatusOptions, inv.status);
                                    
                                    // If not found and status is an enum string, try multiple matching strategies
                                    if (!found && inv.status && typeof inv.status === 'string' && inv.status.includes('_')) {
                                      const statusUpper = inv.status.toUpperCase().trim();
                                      
                                      // Strategy 1: Try to find by converting option labels to enum format
                                      found = inventoryStatusOptions?.find(opt => {
                                        if (!opt.label) return false;
                                        const optLabel = String(opt.label).trim();
                                        // Convert label to enum format (e.g., "Low Stock" -> "LOW_STOCK")
                                        const labelAsEnum = optLabel
                                          .toUpperCase()
                                          .replace(/[^A-Z0-9\s_-]/g, '')
                                          .replace(/[\s-]+/g, '_')
                                          .replace(/_+/g, '_')
                                          .replace(/^_|_$/g, '');
                                        
                                        return labelAsEnum === statusUpper;
                                      }) || null;
                                      
                                      // Strategy 2: Try partial word matching
                                      if (!found) {
                                        const statusWords = statusUpper.split('_');
                                        found = inventoryStatusOptions?.find(opt => {
                                          if (!opt.label) return false;
                                          const optLabel = String(opt.label).trim().toUpperCase();
                                          // Check if all words from enum are present in the label
                                          return statusWords.every(word => optLabel.includes(word));
                                        }) || null;
                                      }
                                      
                                      // Strategy 3: Try matching by option value (some APIs use enum as value)
                                      if (!found) {
                                        found = inventoryStatusOptions?.find(opt => {
                                          const optValue = String(opt.value || '').trim().toUpperCase();
                                          return optValue === statusUpper;
                                        }) || null;
                                      }
                                      
                                      // Strategy 4: Map LOW_STOCK to "Backorder" option
                                      if (!found && statusUpper === 'LOW_STOCK') {
                                        found = inventoryStatusOptions?.find(opt => {
                                          const optLabel = String(opt.label || '').trim();
                                          return optLabel === 'Backorder' || optLabel.toUpperCase() === 'BACKORDER';
                                        }) || null;
                                        
                                        if (found) {
                                          console.log('LOW_STOCK mapped to Backorder option:', {
                                            inventory_id: inv.id,
                                            original_status: inv.status,
                                            mapped_option: { value: found.value, label: found.label }
                                          });
                                        }
                                      }
                                      
                                      // Strategy 5: If it's a valid enum, create a match using the status itself
                                      if (!found) {
                                        const validEnums = ['IN_STOCK', 'OUT_OF_STOCK', 'LOW_STOCK', 'DISCONTINUED', 'BACKORDER'];
                                        const enumToLabelMapping = {
                                          'IN_STOCK': 'In Stock',
                                          'OUT_OF_STOCK': 'Out of Stock',
                                          'LOW_STOCK': 'Backorder',
                                          'DISCONTINUED': 'Discontinued',
                                          'BACKORDER': 'Backorder'
                                        };
                                        
                                        if (validEnums.includes(statusUpper)) {
                                          // Try to find by mapped label first
                                          const mappedLabel = enumToLabelMapping[statusUpper];
                                          found = inventoryStatusOptions?.find(opt => 
                                            String(opt.label || '').trim() === mappedLabel
                                          ) || null;
                                          
                                          if (!found) {
                                            // Return the status as the value - Select will match it if we added it to options
                                            found = { value: inv.status, label: mappedLabel || inv.status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) };
                                          }
                                        }
                                      }
                                      
                                      if (found) {
                                        console.log('Status matched in Select component:', {
                                          inventory_id: inv.id,
                                          original_status: inv.status,
                                          matched_option: { value: found.value, label: found.label }
                                        });
                                      }
                                    }
                                    
                                    if (inv.status && !found) {
                                      // Log all available options with their enum conversions for debugging
                                      const optionsWithEnum = inventoryStatusOptions?.map(opt => {
                                        const optLabel = String(opt.label || '').trim();
                                        const optValue = String(opt.value || '').trim();
                                        const labelAsEnum = optLabel
                                          .toUpperCase()
                                          .replace(/[^A-Z0-9\s_-]/g, '')
                                          .replace(/[\s-]+/g, '_')
                                          .replace(/_+/g, '_')
                                          .replace(/^_|_$/g, '');
                                        const valueAsEnum = optValue
                                          .toUpperCase()
                                          .replace(/[^A-Z0-9\s_-]/g, '')
                                          .replace(/[\s-]+/g, '_')
                                          .replace(/_+/g, '_')
                                          .replace(/^_|_$/g, '');
                                        const targetUpper = String(inv.status).toUpperCase().trim();
                                        return {
                                          value: opt.value,
                                          value_type: typeof opt.value,
                                          value_string: optValue,
                                          label: opt.label,
                                          label_as_enum: labelAsEnum,
                                          value_as_enum: valueAsEnum,
                                          label_matches: labelAsEnum === targetUpper,
                                          value_matches: valueAsEnum === targetUpper,
                                          exact_value_match: optValue.toUpperCase() === targetUpper
                                        };
                                      }) || [];
                                      
                                      console.log('Inventory status not found in options:', {
                                        inventory_id: inv.id,
                                        status: inv.status,
                                        status_type: typeof inv.status,
                                        trying_to_match: String(inv.status).trim(),
                                        target_enum: String(inv.status).toUpperCase().trim(),
                                        available_options: optionsWithEnum,
                                        options_count: inventoryStatusOptions?.length || 0,
                                        options_summary: optionsWithEnum.map(opt => 
                                          `${opt.label} (value: ${opt.value}, value_type: ${opt.value_type}, value_string: "${opt.value_string}")`
                                        ).join(' | ')
                                      });
                                    }
                                    return found;
                                  })()}
                                  isClearable
                                />
                              </div>
                              <div className="col-12 col-md-3">
                                <div className="d-flex align-items-center gap-2">
                                  <input 
                                    className="input-pill flex-grow-1" 
                                    placeholder="Stock Location" 
                                    value={inv.location || ''} 
                                    onChange={(e) => updateInventoryDetail(inv.id, 'location', e.target.value)} 
                                  />
                                  {inventoryDetailsList.length > 1 && (
                                    <button
                                      type="button"
                                      className="btn-delete"
                                      onClick={() => removeInventoryDetail(inv.id)}
                                      title="Remove"
                                    >
                                      ×
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>

                    {/* Lead Time */}
                    <section className="sp-section">
                      <div className="sp-subcard">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="sp-section-title">⏱️ Lead Time</h6>
                          <button type="button" className="btn-add" onClick={addLeadTime}>+ Add More</button>
                        </div>
                        {leadTimeList.map((lead, index) => (
                          <div key={lead.id} className={index > 0 ? "mt-3" : ""}>
                            <div className="row g-2">
                              <div className="col-12 col-md-4">
                                <input 
                                  type="number" 
                                  className="input-pill" 
                                  placeholder="Lead Time (in Days)" 
                                  value={lead.days || ''} 
                                  onChange={(e) => updateLeadTime(lead.id, 'days', e.target.value)} 
                                  min="0" 
                                />
                              </div>
                              <div className="col-12 col-md-4">
                                <input 
                                  className="input-pill" 
                                  placeholder="Min Quantity" 
                                  value={lead.min || ''} 
                                  onChange={(e) => updateLeadTime(lead.id, 'min', e.target.value)} 
                                />
                              </div>
                              <div className="col-12 col-md-4">
                                <div className="d-flex align-items-center gap-2">
                                  <input 
                                    className="input-pill flex-grow-1" 
                                    placeholder="Max Quantity" 
                                    value={lead.max || ''} 
                                    onChange={(e) => updateLeadTime(lead.id, 'max', e.target.value)} 
                                  />
                                  {leadTimeList.length > 1 && (
                                    <button
                                      type="button"
                                      className="btn-delete"
                                      onClick={() => removeLeadTime(lead.id)}
                                      title="Remove"
                                    >
                                      ×
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>

                    {/* FAQ */}
                    <section className="sp-section">
                      <div className="sp-subcard">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="sp-section-title">❓ FAQ</h6>
                          <button type="button" className="btn-add" onClick={addFAQ}>+ Add More</button>
                        </div>
                        {faqList.map((faq, index) => (
                          <div key={faq.id} className={index > 0 ? "mt-3" : ""}>
                            <div className="row g-2">
                              <div className="col-12 col-md-6">
                                <input 
                                  className="input-pill" 
                                  placeholder="Question" 
                                  value={faq.question || ''} 
                                  onChange={(e) => updateFAQ(faq.id, 'question', e.target.value)} 
                                />
                              </div>
                              <div className="col-12 col-md-6">
                                <div className="d-flex align-items-center gap-2">
                                  <input 
                                    className="input-pill flex-grow-1" 
                                    placeholder="Answer" 
                                    value={faq.answer || ''} 
                                    onChange={(e) => updateFAQ(faq.id, 'answer', e.target.value)} 
                                  />
                                  {faqList.length > 1 && (
                                    <button
                                      type="button"
                                      className="btn-delete"
                                      onClick={() => removeFAQ(faq.id)}
                                      title="Remove"
                                    >
                                      ×
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>

                    {/* FAQ Add-on: Carousel Slider */}
                    <section className="sp-section">
                      <div className="sp-subcard">
                        <div className="row g-2 align-items-center">
                          <div className="col-12 col-md-6">
                            <div className="input-pill input-pill-toggle">
                              <span>Carousal Slider</span>
                              <div
                                className={`sp-switch ${carouselEnabled ? 'on' : 'off'}`}
                                role="switch"
                                aria-checked={!!carouselEnabled}
                                onClick={() => setCarouselEnabled(v => !v)}
                              >
                                <span className="sp-switch-label">{carouselEnabled ? 'Yes' : 'No'}</span>
                                <span className="sp-switch-thumb"></span>
                              </div>
                            </div>
                          </div>
                          {carouselEnabled && (
                            <div className="col-12 col-md-6">
                              <div className="input-pill upload-pill" onClick={(e) => { 
                                if (carouselImageUrls.length >= 5 || uploadingProductFiles) return;
                                const input = e.currentTarget.querySelector('input[type=file]'); 
                                if (input) input.click(); 
                              }}>
                                <span className="upload-icon-only" aria-hidden>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="upload-icon"><path d="M12 3v12"></path><path d="m17 8-5-5-5 5"></path><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path></svg>
                                </span>
                                <span className="choose-text ms-2">
                                  {uploadingProductFiles ? 'Uploading...' : carouselImageUrls.length >= 5 ? 'Maximum 5 images reached' : `Upload product images (1420w * 555h - max 1MB) (${carouselImageUrls.length}/5)`}
                                </span>
                                <input 
                                  type="file" 
                                  className="d-none" 
                                  accept=".jpg,.jpeg,.png" 
                                  multiple 
                                  onChange={handleCarouselImagesUpload}
                                  disabled={uploadingProductFiles || carouselImageUrls.length >= 5}
                                />
                              </div>
                              {carouselImageUrls.length > 0 && (
                                <div className="mt-3">
                                  <h6 className="small mb-2 fw-semibold">Uploaded Images ({carouselImageUrls.length}/5):</h6>
                                  <div className="row g-2">
                                    {carouselImageUrls.map((url, index) => {
                                      const imageUrl = getImageUrl(url);
                                      return (
                                        <div key={index} className="col-6 col-md-4 col-lg-3">
                                          <div className="position-relative" style={{ 
                                            border: '1px solid #ddd', 
                                            borderRadius: '8px', 
                                            overflow: 'hidden', 
                                            backgroundColor: '#f8f9fa',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                            transition: 'transform 0.2s'
                                          }}
                                          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                                          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                          >
                                            <img 
                                              src={imageUrl} 
                                              alt={`Carousel ${index + 1}`}
                                              style={{ 
                                                width: '100%', 
                                                height: '150px', 
                                                objectFit: 'cover', 
                                                display: 'block',
                                                backgroundColor: '#e9ecef'
                                              }}
                                              onError={(e) => {
                                                e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="150"%3E%3Crect fill="%23e9ecef" width="200" height="150"/%3E%3Ctext fill="%236c757d" font-family="sans-serif" font-size="12" x="50%25" y="50%25" text-anchor="middle" dy=".3em"%3EImage not found%3C/text%3E%3C/svg%3E';
                                              }}
                                            />
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                                              style={{ 
                                                borderRadius: '50%', 
                                                width: '28px', 
                                                height: '28px', 
                                                padding: 0, 
                                                lineHeight: '1', 
                                                fontSize: '18px', 
                                                fontWeight: 'bold',
                                                zIndex: 10,
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                border: '1px solid #fff'
                                              }}
                                              onClick={() => handleRemoveCarouselImage(index)}
                                              title="Remove image"
                                              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                                              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                            >
                                              ×
                                            </button>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        {/* Save/Cancel Buttons for Product Form */}
                        <div className="d-flex justify-content-end gap-2 mt-3">
                          <button type="button" className="btn btn-outline-primary" onClick={handleCancelProduct}>Cancel</button>
                          <button type="button" className="btn btn-primary" onClick={handleSaveProduct}>Save Product</button>
                        </div>
                      </div>
                    </section>
                  </>
                )}

                {/* Products Table */}
                <section className="sp-section">
                  <div className="sp-subcard">
                    <h6 className="sp-section-title">📋 Saved Products</h6>
                    <div className="table-responsive">
                      <table className="table product-catalogue-table">
                        <thead>
                          <tr>
                            <th>Product Name</th>
                            <th>Brand</th>
                            <th>Category</th>
                            <th>HSN Code</th>
                            <th>Model Number</th>
                            <th>MOQ</th>
                            <th>Price</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {savedProducts.length > 0 ? (
                            savedProducts.map((product) => (
                              <tr key={product.id}>
                                <td>{product.pd_name || '-'}</td>
                                <td>{product.pd_brand || '-'}</td>
                                <td>
                                  {categoryData.find(c => String(c.id) === String(product.pd_cat))?.name || '-'}
                                  {product.pd_subcat && ` > ${categoryData.find(c => String(c.id) === String(product.pd_cat))?.subs?.find(s => String(s.id) === String(product.pd_subcat))?.name || ''}`}
                                </td>
                                <td>{product.pd_hsn || '-'}</td>
                                <td>{product.pd_model || '-'}</td>
                                <td>
                                  {product.moq_min ? `${product.moq_min} ${product.moq_uom || ''}` : '-'}
                                </td>
                                <td>
                                  {product.moq_price_tax && product.moq_currency 
                                    ? `${product.moq_currency} ${product.moq_price_tax}` 
                                    : '-'}
                                </td>
                                <td>
                                  <div className="product-actions">
                                    <button type="button" className="btn-edit" onClick={() => handleEditProduct(product)}>Edit</button>
                                    <button type="button" className="btn-delete" onClick={() => handleDeleteProduct(product.id)}>Delete</button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="no-data-cell">
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </section>

                <div className="sp-actions-row mb-2">
                  <div className="sp-left-actions">
                    <button type="button" className="btn btn-outline-primary sp-back" onClick={saveProductDetails}>Back</button>
                  </div>
                  <div className="sp-right-actions">
                    <button type="button" className="btn btn-primary" onClick={handleSave}>Submit</button>
                  </div>
                </div>
              </div>
            </TabPane>
          </Tabs>

          {/* Contract Manufacturer prompt - show after Seller Profile (company) save */}
          <Modal
            title="Contract Manufacturer"
            open={showContractManufacturerModal}
            onCancel={() => setShowContractManufacturerModal(false)}
            footer={[
              <button key="no" type="button" className="btn btn-outline-primary" onClick={() => setShowContractManufacturerModal(false)}>No</button>,
              <button key="yes" type="button" className="btn btn-primary" onClick={() => { setShowContractManufacturerModal(false); navigate('/contract-manufacturer-profile'); }}>Yes</button>
            ]}
          >
            <p className="mb-0">Are you a Contract Manufacturer?</p>
          </Modal>
        </main>
      </div>
    </div>
  );
}



